var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g3, _path56, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path57, _path58, _g15, _g16, _g17, _g18, _g19, _g20, _path59, _path60, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path61, _path62, _g29, _g30, _g31, _g32, _path63, _path64, _g33, _path65, _g34, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M0 0h1100v750H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h1100v500H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h1100v250H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(-.94799 .11424 .13323 .81283 980.72 130.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(-.94799 .11424 .13323 .81283 980.72 130.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(-.94799 -.11424 -.13323 .81283 1059.61 241.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(-.94799 -.11424 -.13323 .81283 1059.61 241.16)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(-.9573 0 0 .82082 1021.59 185.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(-.9573 0 0 .82082 1021.59 185.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(.94799 .11424 -.13323 .81283 119.28 130.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(.94799 .11424 -.13323 .81283 119.28 130.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(.94799 -.11424 .13323 .81283 40.39 241.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(.94799 -.11424 .13323 .81283 40.39 241.16)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.7 187.88c1.07.92 183.54 161.54 184.34 162.24.47-.56 1.39-1.63 1.84-2.13-.76-.68-183.29-161.2-184.36-162.18.33-.6-2.5 2.7-1.83 2.07z",
    fill: "#a05a2c",
    transform: "matrix(.9573 0 0 .82082 78.41 185.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 177.62c.77 1.22 2.96 4.3 2.63 6.85 1.14-1.15 1.68-1.97 2.76-3.2-.59 1.81-.2 2.76.67 3.26.63.72 2.36.29 3.45-.12-1.01.96-2.14 1.96-3.68 2.36-1.53.4-2.1.37-3.03.61 1.03.46 3.66 1.08 5.44 1.16.9.03 2.6-.03 3.27-.66 1.08.92 2.9-1.09 1.83-2.07.33-.6.25-1.48.19-2.66a12.7 12.7 0 0 0-1.87-5.54c0 1.08-.13 2.24-.34 3.3-.2 1.06-.81 1.97-1.4 2.96.28-.98.34-2.4-.63-3.3-.97-.88-2.18-.7-3.24-.03.88-1.05 1.57-1.7 2.64-2.9-1.26.16-5.53-1.08-7-1.82-1.45-.74-6.21-4.04-8.91-6.06 2.32 2.35 6.48 6.68 7.22 7.86z",
    fill: "#e7e7e7",
    transform: "matrix(.9573 0 0 .82082 78.41 185.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z",
    fill: "#00e519",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "#ffe533",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z",
    fill: "none",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "#a05a2c",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#cce5e5",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#e7e7e7",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35",
    fill: "none",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "#cce5e5",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "none",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5",
    fill: "#cce5e5",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z",
    fill: "none",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "#cce5e5",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "none",
    transform: "matrix(-.7956 -.30372 -.35422 .68216 961.26 340.95)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z",
    fill: "#00e519",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "#ffe533",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "#a05a2c",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#cce5e5",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#e7e7e7",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "#cce5e5",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5",
    fill: "#cce5e5",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "#cce5e5",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "none",
    transform: "matrix(-.80166 -.29177 -.34028 .68736 950.35 338.41)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z",
    fill: "#00e519",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "#ffe533",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z",
    fill: "none",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "#a05a2c",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#cce5e5",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#e7e7e7",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35",
    fill: "none",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "#cce5e5",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "none",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5",
    fill: "#cce5e5",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z",
    fill: "none",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "#cce5e5",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "none",
    transform: "matrix(.80363 -.30679 .3578 .68905 135.46 339.65)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.3c-4.15-7.96-21.27-18.78-24.22-19.1 7.87 17.36 20.84 23.65 24.22 19.1z",
    fill: "#00e519",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "#ffe533",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34 331.3c-3.38 4.55-16.27-1.74-24.14-19.01 11.72 11.1 22.2 19.17 24.14 19z",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.42 331.22c-4.42-8.46-22.36-18.94-24.26-19.13 7.91 17.32 20.88 23.68 24.26 19.13z",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "#a05a2c",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56 175.7l-2.8 118.6c1.25 2.8 4.09 1.05 4.55 1.6 1.05 4.38 4.2 6.59 4.58 7.68.85 5.9-2.42 8.93-2.73 9.17-3.7 2.45-.43 7.88-1.1 8.86.08 2.33 3.77 3.45 3.46 6.1.27-.2.02 19.07-.02 21.12.62 1.4.76 14.38.76 14.38 3.5 1.47 21.21-2.5 21.4-2.24-1.26-17.28-9.66-46.68-8.69-47.89-.6-12.2-3.86-26.56-7.35-28.04-3.57-5.2-2.52-14.02-.77-15.38-3.72-1.78-4.61-5.32-4.8-5.59l1.16-85.54c-2.14-2.13-2.3-.73-3.89.63 0 0-.61-3.03-.38-3.27-1.09-1.47-3.03-.93-3.38-.19z",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#cce5e5",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66 153.16c-.08 2.34-1.32 1.8-1.87 1.87l-2.02-.23c-2.02-.85-3.61-.11-3.96.62l-3.04 138.88c1.24 2.8 4.27 1.32 4.77 1.9l1.96-94.94s-.44-33.87-.35-43.2l5.44-.24c1.55.24 2.44-.66 2.56-2.56l-2.2-50.5-1.25 47.51-.04.9",
    fill: "#e7e7e7",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6 303.92c4.92 1.9 5.77 7.26.4 10.83M403.74 309.28c1.24 1.86 3.1.61 3.1.61M392.97 273.78c-2.22 11.85-.75 21.02-.8 23.62 1.67 5.79.34 16.67-.94 18.1l1.95 31.35",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "#cce5e5",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 294.8c2.57.08 13.22-4.51 19.66-.01 2.13 9.67 2.05 18.53 2.55 19.96-9.37 3.4-15.08 4.6-17.1 4.84-.7-1.25-.3-3.65-.3-3.65-.59-2.37 1.78-3.2 1.78-3.2 1.91-4.77.44-9.35-2.43-10.9-3.58-2.02-2.37-1.9-2.84-2.14-1.2-1.9-1.31-4.9-1.31-4.9z",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5l-5.55-8.5",
    fill: "#cce5e5",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87 298.14c3.34 1.4 5.9 4.74 5.55 8.5M399.74 310.56c-.66.66-1.71.7-2.37.04a1.71 1.71 0 0 1 0-2.4c.66-.67 1.71-.63 2.37.03.66.66.66 1.67 0 2.33zM398.54 302.21c-.66.66-1.75.66-2.4 0-.66-.66-.63-1.7.04-2.37a1.62 1.62 0 0 1 2.33 0c.66.66.7 1.71.03 2.37z",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "#cce5e5",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19 188.72c-1.09-1.09-.9-3.07.47-4.43l9.13.18s.81.59 1.04 2.14c.2 1.6-1.28 2.14-1.28 2.14l-9.36-.03",
    fill: "none",
    transform: "matrix(.80166 -.29177 .34028 .68736 149.9 338.41)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33 370.91c.94-1.06 62.72-68.44 63.43-69.23l-2.1-1.88c-.68.74-62.62 68.2-63.61 69.25-.6-.34 2.9 2.54 2.28 1.86z",
    fill: "#a05a2c",
    transform: "matrix(.95347 -.03737 .07151 .82132 510.97 87.23)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.62 176.74c1.44 1.8 4.09 4.05 6.25 3.7.18 3.41-4.41 6.38-6.03 5.66.99-3.6-3.35-6.5-3.26-6.5l3.04-2.86z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    transform: "matrix(-1.14336 .12305 -.17678 -.9872 795.47 488.01)",
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9 161.76c.23-3.52-.34-4.52-.86-8.86-.52-4.26-8.34-4.63-11.24-5.35 0 0 6.85-8.48 15.96-8.48 9.11 0 14.57 4.29 16.3 9.67 0 0-10.75-.54-11.66 3.82-.88 4.22-.46 5.16-.37 8.62",
    fill: "#e7e7e7",
    transform: "matrix(-.35384 .3844 -.45764 -.3157 718.74 331.43)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M123.74 158.97h12.37v6.36h-12.37z",
    transform: "matrix(-.35384 .3844 -.45764 -.3157 718.74 331.43)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.52 453.63l-1.44 14.12s2.18-2.68 2.7-3.57c.53-.88 2.43-3.26 2.83-11.5 0 0-1.48-4.55-2.17-4.54-1.16-.57-1.92 5.49-1.92 5.49zm3.47-31.5s-3.8 22.69-4.18 24.75c0 .7 1.93 2.57 3.32-1.81l2.29-16.49s-1.03-4.39-1.43-6.44z",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.56 444.64c-.92-1.16-2.08-2.61-2.2-3.2l-.59 5s3.16 2.3 2.7 6.72l.62-.89.35-1.77s.65-2.94.66-4.7c0 0-.67-.29-1.54-1.16z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.08 467.75s5.23-4.48 5.53-15.07l.65-2.94s.1 2.35 1.16.57c1.02-2.37.97-4.42.97-4.42s1.9-2.38 2.47.55c0 0-1.76 13.83-1.88 15.01a80.2 80.2 0 0 1-.42 3.24s-1.04-1.75-2.09.03c-1.14 1.78-2.94 4.15-6.4 3.03zm6.34-39.17l-2.3 16.49s1.83.85 2.14 4.67c.17 1.76.87.87 1.16.57.38-1.18.1-3.53.1-3.53l1-11.47s-1.99-5.26-2.1-6.73z",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.6 466.8l-.33 4.12s1.57-.02 2.62-1.8c1.22-1.78 1.67-4.43 1.67-4.43s-1.21-1.74-2.09.03c-.85 1.48-1.86 2.08-1.86 2.08zm2.82-16.49c.84-1.48 1.12-4.13.97-4.42l-1.06.9c.34 1.75.09 3.52.09 3.52z",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.58 448.65c-.72-1.46-1.94-2.32-1.94-2.32l-2.33 18.54s-.65 4.71-3.56 5.93c0 0 1.66 16.13 6.9 11.65.76-.6 1.7-5.6 1.4-8.54-.37-3.23-1.23-7.62-1.31-9.38-.05-2.06.24-4.14.74-7.38.21-1.18.82-3.76.94-4.06.29-.3-.06-2.69-.84-4.44z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.1 445.8s1.41 1.45 1.68 1.44c.34 0-3.68 30.24-3.68 30.24s.15-3.17-1.03-9.32c-.95-5 .28-11.72 1.36-14.94 0 0 1.27-.95 1.67-7.42z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.4 435.61s-.79 8.53-.97 11.18c0 0 2.65-3.86 3.34-.34l.6-5s-2.31-3.8-2.97-5.84z",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.36 449.71s-.87-9.56-5.5-2.8c-.18 0-.42 3.8-.15 4.7.14 1.22 1.42 2.72 1.96 3.63 1 1.5 2.1-.34 2.1-.34s1.04-1.53 1.6-5.19z",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.93 838.9c-1.33-42.47-14.68-113.66-15.34-162.07l-146.33-156s-18.06 119.97-71.2 186.54l232.87 131.61",
    fill: "#d52b1e",
    transform: "matrix(.1282 -.00603 0 .1282 424.44 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.5 844.43c6.16-29.21 13.55-62.06 18.46-123.54l-94.2-97.24c.38 38.74-43.5 96.6-46.46 168.84",
    fill: "#ffe000",
    transform: "matrix(.1282 -.00603 0 .1282 424.44 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.73 937.6c10.8-51.25-15.69-58.91 23.72-129.9l-87.05-87.55c-16.22 48.32-27.14 79.4-25.73 121.88l74.17 56.26",
    fill: "#007934",
    transform: "matrix(.1282 -.00603 0 .1282 424.44 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.05 422.01c-2.26-6.72.8-19.9.47-28.34-.26-5.44 3.75-25.92 3.66-32.12l-22.05-13.77s-.97 22.38-3.5 46.76c-2.29 12.52-2.27 23.97-.63 33.53 2.34 13.58 4.65 19.16 10.14 24.9 9.74 10.09 30.71 4.27 30.71 4.27 17.67-3.66 27.85-14.8 27.85-14.8s-5.75 1.37-15.06 2.31c-20.4-1.43-28.45 3.67-29.08-17.27",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.16 435.58l.34-.15c-3.83 1.43-9.16 3.01-9.16 3.01l-12.44.96c-26.97.63-23.6-16.07-22.52-43.02.25-10.22 2.28-23.1 1.76-27.66l-18.08-10.36c-5.9 16.67-4.06 28.32-5.24 36.85-.62 9.18-2.58 27.11.4 34.93 4.21 18.2 18.47 17.47 37.76 15.86 9.57-.79 14.72-3.25 14.72-3.25l12.45-7.16",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.51 435.21c-3.74 1.94-9.25 3.37-9.25 3.37l-12.6 1.24c-19.55 1.66-31-12.07-28.5-43.13.02-10.97.37-15.85 4.16-30.46l10.75 6.3v1.01c-.61 3.28-2.15 10.96-2.15 14.47 0 24.93 15.77 44.09 37.25 47.34l.34-.15",
    fill: "#007a3d",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.13 360.23c1.82 3.07 12.7 19.64 18.8 22.78M457.96 371.06c1.82 3.14 15.14 21.8 21.14 22.86M454.91 399.6c3.05 3.65 6.09 10.9 15.14 15.59M459.17 420.34c6.09 5.68 21.15 18.15 35.69 18.66M459.17 429.68c3.05 3.66 9.66 20.76 37.52 13M454.91 432.82c1.82 4.1 15.75 26.96 40.56 18.14",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.99 413.8c-2.26-6.71.8-19.89.46-28.33-.25-5.45 2.32-24.28 2.23-30.48l-20.62-15.42s-.96 22.39-3.5 46.77c-2.28 12.52-4.02 27.86-2.33 37.4 2.77 15.64 10.28 20.03 11.64 21.24 10.53 9.38 34.31 8.46 36.67 7.62 17-6.08 24.4-16.87 24.4-16.87s-8.05-.13-17.36.82c-20.41-1.43-30.72-.58-31.35-21.52",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.1 427.37l.33-.15c-3.82 1.44-9.16 3.02-9.16 3.02l-12.43.95c-26.97.63-23.6-16.07-22.53-43.01.26-10.23.61-19.41.09-23.97l-16.17-11.8c-5.9 16.67-4.3 26.07-5.48 34.6-.61 9.17-2.57 27.1.4 34.93 4.22 18.2 18.47 17.46 37.76 15.86 9.58-.8 14.73-3.26 14.73-3.26l12.44-7.16",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.57 427.13c-3.74 1.93-9.24 3.36-9.24 3.36l-12.6 1.25c-19.56 1.66-31-12.08-28.5-43.14.02-10.97-.35-11.74 3.43-26.35 6 3.88 17.44 13.65 17.44 13.65s-3.11 4.38-2.38 10.51c0 24.94 10.03 37.6 31.51 40.85l2.36-20.36",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.06 352.03c1.82 3.06 12.7 19.64 18.8 22.77M473.9 362.86c1.82 3.13 15.14 21.8 21.14 22.85M470.85 391.39c3.04 3.65 6.08 10.9 15.14 15.6M475.11 412.14c6.09 5.67 21.14 18.15 35.68 18.66M475.11 421.48c3.05 3.65 9.66 20.75 37.51 13M470.85 424.61c1.82 4.1 15.75 26.96 40.56 18.14",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27 349.95s-.91 7.94-1 9.36c-.42 6.9-.23 12.1.1 15.35-.02.35 1.33 8.59.86 9.03-1.58 1.8-1.64 2-3.3.67-.25-.28.71-8.71.78-9.87.17-1.25.43-11.1.6-15.4.02-1.7 1.48-10.08 1.48-10.08s.2-1.78.47.91",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27 349.95s-.91 7.94-1 9.36c-.42 6.9-.22 12.1.1 15.35-.02.35 1.6 11.82 1.1 9.04-1.58 1.8-1.9 2.49-3.58 1.15-.24-.27.75-9.2.82-10.36.17-1.25.43-11.1.6-15.4.02-1.7 1.48-10.08 1.48-10.08s.2-1.78.47.91l.01.03z",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1 347.16s-1.8 9.52-1.96 14.98c-.24 6.62-.52 8.5-.42 12.36.07.26-.64 4.99-.85 7.04-.15 1.06.15.27-.02.35-1.36.83-2.28.16-3.1-.5-.25-.18 2.18-5.9 2.26-7.06 1.28-16.8 3.72-26.66 3.72-26.66s-.98 5.96.37-.5",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1 347.16s-1.8 9.52-1.95 14.98c-.24 6.62-.52 8.5-.42 12.36.07.26-.64 4.99-.85 7.04-.15 1.06.15.27-.02.35-1.36.83-2.28.16-3.1-.49-.25-.19 2.19-5.9 2.26-7.08 1.28-16.81 3.7-26.66 3.7-26.66s-.97 5.96.38-.5zm-.78 27.06s-1.43.64-1.59.28m-.06-1.96s1.22-.03 1.41-.38m-.07-1.64s-.9.59-1.14.22m1.12-2.63l-.87.03m.93-2.37l-.95.03m.8-3.35s-.54.24-.6-.12m.77-2.65l-.78-.04m-.74 14.95s-1.4.2-1.56-.25m1.67-2.98s-1.4.12-1.45-.33m1.5-2s-1.13.04-1.2-.05m1.43-2.18l-1.13-.06m1.12-2.63l-.77-.13m1.08-2.19s-.7.15-.85-.21m.93-2.49s-.63.42-.6-.02m-.08 14s-1.39 0-1.36-.42M466.2 341.74s-.9 7.94-1 9.37c-.41 6.89-.22 12.1.1 15.34-.02.35 1.33 8.6.87 9.03-1.59 1.8-1.64 2.01-3.31.67-.24-.27.72-8.71.8-9.87.15-1.25.41-11.1.59-15.4.02-1.7 1.48-10.07 1.48-10.07s.2-1.78.47.9",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.2 341.74s-.9 7.94-1 9.37c-.41 6.89-.2 12.1.1 15.34-.02.35 1.61 11.82 1.1 9.04-1.58 1.81-1.9 2.5-3.57 1.15-.24-.27.75-9.2.82-10.36.16-1.25.42-11.1.6-15.4.02-1.7 1.48-10.07 1.48-10.07s.2-1.78.47.9v.03z",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.04 338.96s-1.8 9.51-1.97 14.97c-.23 6.63-.52 8.5-.41 12.36.07.27-.65 4.99-.86 7.04-.15 1.06.16.27-.02.35-1.35.83-2.27.17-3.1-.49-.24-.18 2.2-5.9 2.26-7.07 1.29-16.8 3.72-26.66 3.72-26.66l.38-.5",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.04 338.96s-1.8 9.51-1.96 14.97c-.23 6.63-.51 8.5-.4 12.36.06.27-.66 4.99-.87 7.04-.15 1.06.16.27-.02.35-1.35.83-2.27.17-3.1-.49-.24-.18 2.2-5.9 2.26-7.08 1.29-16.8 3.71-26.66 3.71-26.66l.38-.5zm-.78 27.05s-1.43.65-1.59.28m-.06-1.96s1.22-.03 1.41-.37m-.07-1.64s-.9.58-1.14.21m1.12-2.63l-.87.04m.92-2.37l-.95.03m.8-3.36s-.53.24-.6-.11m.77-2.66l-.77-.03m-.75 14.94s-1.4.2-1.55-.25m1.67-2.97s-1.4.11-1.46-.33m1.51-2s-1.13.04-1.21-.05m1.44-2.19l-1.13-.05m1.12-2.64l-.77-.12m1.08-2.2s-.7.15-.85-.2m.93-2.5s-.63.42-.6-.02m-.08 14s-1.4.01-1.36-.41",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e8a30e",
    strokeWidth: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.47 216.7s1.26 9.72 1.09 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.27-.27-17.1-2.19-27.2-2.19-27.2l-.36-.53",
    transform: "matrix(.956 .04296 -.0501 .8197 148.72 137.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47 216.7s1.26 9.72 1.08 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.28-.28-17.1-2.18-27.2-2.18-27.2l-.36-.53zM357.38 244.61s1.45.27 1.64-.18M357.57 241.34s1.45.18 1.45-.27M357.57 238.98s1.17.09 1.27 0M357.47 236.7h1.18M357.65 233.97l.8-.09M357.57 231.6s.62.19.81-.17M357.57 228.87s.62.45.62 0M357.38 243.07s1.45.07 1.45-.36",
    transform: "matrix(.956 .04296 -.0501 .8197 148.72 137.16)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.15 346.33l1.24.1-1.24-.1z",
    fill: "#005000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.89 400.63s-.59-.25-.73 0c0 .13.14.25.29.25.15 0 .44-.25.44-.25zM543.29 402.37s2.47-.25 3.34-.25",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.51
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.9 89.5c-.03 1.92-3.76 4.27-6.82.32-3.2-2.73-2.73-7.08-.33-7.77l27.82-34.58c1.14-.8 1.22-1.52 1.77-2.27a77.52 77.52 0 0 0 5.45 5.42c-.81.86-1.46 1.67-1.62 2.32L156.9 89.5z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    transform: "matrix(2.89906 .09014 -.13563 2.47944 63.82 208.03)",
    strokeWidth: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.04,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.24 190.48c.84-1.42 4.37 2.18 3.5 3.33-.89 1.16-4.26-1.89-3.5-3.33z",
    fill: "#e7e7e7",
    strokeLinejoin: "round",
    transform: "matrix(4.63332 .07484 -.13578 3.96195 32.67 -427.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.42 193.54c-.63.59-3.19-1.82-2.8-2.76.66-.88 3.48 2.19 2.8 2.76z",
    fill: "#cccccf",
    transform: "matrix(4.63332 .07484 -.13578 3.96195 32.67 -427.9)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3513.15 736.64c56.55-19.26 95.95-57.23 120-113.04M3934.48 1159.29c71.13-23.52 119-70.3 139.06-144.9M3964.46 1190.93c71.13-23.52 119-70.3 139.06-144.89M4138.5 1357.47c71.12-23.52 127.32-76.13 147.38-150.72M4169.3 1389.11c71.13-23.52 128.16-76.96 148.22-151.55",
    fill: "none",
    transform: "matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4338.34 1405.77c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4375.22 1406.93c.31 11-9.01 20.16-20.85 20.47-11.84.32-21.72-8.32-22.09-19.32-.37-11 8.9-20.2 20.74-20.57 11.84-.38 21.76 11.55 22.2 22.55",
    fill: "#e8a30e",
    transform: "matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4336.24 1403.84c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(-.1253 .00359 .00348 .12902 1025.18 248.4)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.48 453.63l1.44 14.12s-2.18-2.68-2.7-3.57c-.53-.88-2.43-3.26-2.83-11.5 0 0 1.48-4.55 2.17-4.54 1.16-.57 1.92 5.49 1.92 5.49zm-3.47-31.5s3.8 22.69 4.18 24.75c0 .7-1.93 2.57-3.32-1.81l-2.29-16.49s1.03-4.39 1.43-6.44z",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.44 444.64c.92-1.16 2.08-2.61 2.2-3.2l.59 5s-3.15 2.3-2.7 6.72l-.62-.89-.35-1.77s-.65-2.94-.66-4.7c0 0 .67-.29 1.54-1.16z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92 467.75s-5.23-4.48-5.53-15.07l-.65-2.94s-.1 2.35-1.16.57c-1.02-2.37-.97-4.42-.97-4.42s-1.9-2.38-2.47.55a2814 2814 0 0 0 2.3 18.25s1.04-1.75 2.09.03c1.14 1.78 2.94 4.15 6.4 3.03zm-6.34-39.17l2.3 16.49s-1.83.85-2.14 4.67c-.17 1.76-.87.87-1.16.57-.38-1.18-.1-3.53-.1-3.53l-1-11.47s1.99-5.26 2.1-6.73z",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.4 466.8l.33 4.12s-1.57-.02-2.62-1.8c-1.22-1.78-1.67-4.43-1.67-4.43s1.21-1.74 2.09.03c.85 1.48 1.86 2.08 1.86 2.08zm-2.82-16.49c-.84-1.48-1.12-4.13-.97-4.42l1.06.9c-.34 1.75-.09 3.52-.09 3.52z",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.42 448.65c.72-1.46 1.94-2.32 1.94-2.32l2.33 18.54s.65 4.71 3.56 5.93c0 0-1.66 16.13-6.9 11.65-.76-.6-1.7-5.6-1.4-8.54.37-3.23 1.23-7.62 1.31-9.38.05-2.06-.24-4.14-.74-7.38-.21-1.18-.82-3.76-.94-4.06-.29-.3.06-2.69.84-4.44z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 445.8s-1.41 1.45-1.68 1.44c-.34 0 3.68 30.24 3.68 30.24s-.15-3.17 1.03-9.32c.95-5-.28-11.72-1.36-14.94 0 0-1.27-.95-1.67-7.42z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.6 435.61s.79 8.53.97 11.18c0 0-2.65-3.86-3.34-.34l-.6-5s2.31-3.8 2.97-5.84z",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.64 449.71s.87-9.56 5.5-2.8c.18 0 .42 3.8.15 4.7-.14 1.22-1.42 2.72-1.96 3.63-1 1.5-2.1-.34-2.1-.34s-1.04-1.53-1.6-5.19z",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.93 838.9c-1.33-42.47-14.68-113.66-15.34-162.07l-146.33-156s-18.06 119.97-71.2 186.54l232.87 131.61",
    fill: "#d52b1e",
    transform: "matrix(-.1282 -.00603 0 .1282 675.56 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.5 844.43c6.16-29.21 13.55-62.06 18.46-123.54l-94.2-97.24c.38 38.74-43.5 96.6-46.46 168.84",
    fill: "#ffe000",
    transform: "matrix(-.1282 -.00603 0 .1282 675.56 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.73 937.6c10.8-51.25-15.69-58.91 23.72-129.9l-87.05-87.55c-16.22 48.32-27.14 79.4-25.73 121.88l74.17 56.26",
    fill: "#007934",
    transform: "matrix(-.1282 -.00603 0 .1282 675.56 266.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.95 422.01c2.26-6.72-.8-19.9-.47-28.34.26-5.44-3.75-25.92-3.66-32.12l22.05-13.77s.97 22.38 3.5 46.76c2.29 12.52 2.27 23.97.63 33.53-2.34 13.58-4.65 19.16-10.14 24.9-9.74 10.09-30.71 4.27-30.71 4.27-17.67-3.66-27.85-14.8-27.85-14.8s5.75 1.37 15.06 2.31c20.4-1.43 28.45 3.67 29.08-17.27",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.84 435.58l-.34-.15c3.83 1.43 9.16 3.01 9.16 3.01l12.44.96c26.97.63 23.6-16.07 22.52-43.02-.25-10.22-2.28-23.1-1.76-27.66l18.08-10.36c5.9 16.67 4.06 28.32 5.24 36.85.62 9.18 2.58 27.11-.4 34.93-4.21 18.2-18.47 17.47-37.76 15.86-9.57-.79-14.72-3.25-14.72-3.25l-12.45-7.16",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.49 435.21c3.74 1.94 9.25 3.37 9.25 3.37l12.6 1.24c19.55 1.66 31-12.07 28.5-43.13-.02-10.97-.37-15.85-4.16-30.46l-10.75 6.3v1.01c.61 3.28 2.15 10.96 2.15 14.47 0 24.93-15.77 44.09-37.25 47.34l-.34-.15",
    fill: "#007a3d",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.87 360.23c-1.82 3.07-12.7 19.64-18.8 22.78M642.04 371.06c-1.82 3.14-15.14 21.8-21.14 22.86M645.09 399.6c-3.05 3.65-6.09 10.9-15.14 15.59M640.83 420.34c-6.09 5.68-21.15 18.15-35.69 18.66M640.83 429.68c-3.05 3.66-9.66 20.76-37.52 13M645.09 432.82c-1.82 4.1-15.75 26.96-40.56 18.14",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.01 413.8c2.26-6.71-.8-19.89-.46-28.33.25-5.45-2.32-24.28-2.23-30.48l20.62-15.42s.96 22.39 3.5 46.77c2.28 12.52 4.02 27.86 2.33 37.4-2.77 15.64-10.28 20.03-11.64 21.24-10.53 9.38-34.31 8.46-36.67 7.62-17-6.08-24.4-16.87-24.4-16.87s8.05-.13 17.36.82c20.41-1.43 30.72-.58 31.35-21.52",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.9 427.37l-.33-.15c3.82 1.44 9.16 3.02 9.16 3.02l12.43.95c26.97.63 23.6-16.07 22.53-43.01-.26-10.23-.61-19.41-.09-23.97l16.17-11.8c5.9 16.67 4.3 26.07 5.48 34.6.61 9.17 2.57 27.1-.4 34.93-4.22 18.2-18.47 17.46-37.76 15.86-9.58-.8-14.73-3.26-14.73-3.26l-12.44-7.16",
    fill: "#ffe000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.43 427.13c3.74 1.93 9.24 3.36 9.24 3.36l12.6 1.25c19.56 1.66 31-12.08 28.5-43.14-.02-10.97.35-11.74-3.43-26.35-6 3.88-17.44 13.65-17.44 13.65s3.11 4.38 2.38 10.51c0 24.94-10.03 37.6-31.51 40.85l-2.36-20.36",
    fill: "#007934",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.94 352.03c-1.82 3.06-12.7 19.64-18.8 22.77M626.1 362.86c-1.82 3.13-15.14 21.8-21.14 22.85M629.15 391.39c-3.04 3.65-6.08 10.9-15.14 15.6M624.89 412.14c-6.09 5.67-21.14 18.15-35.68 18.66M624.89 421.48c-3.05 3.65-9.66 20.75-37.51 13M629.15 424.61c-1.82 4.1-15.75 26.96-40.56 18.14",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.73 349.95s.91 7.94 1 9.36c.42 6.9.23 12.1-.1 15.35.02.35-1.33 8.59-.86 9.03 1.58 1.8 1.64 2 3.3.67.25-.28-.71-8.71-.78-9.87-.17-1.25-.43-11.1-.6-15.4-.02-1.7-1.48-10.08-1.48-10.08s-.2-1.78-.47.91",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.73 349.95s.91 7.94 1 9.36c.42 6.9.22 12.1-.1 15.35.02.35-1.6 11.82-1.1 9.04 1.58 1.8 1.9 2.49 3.58 1.15.24-.27-.75-9.2-.82-10.36-.17-1.25-.43-11.1-.6-15.4-.02-1.7-1.48-10.08-1.48-10.08s-.2-1.78-.47.91l-.01.03z",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.9 347.16s1.8 9.52 1.96 14.98c.24 6.62.52 8.5.42 12.36-.07.26.64 4.99.85 7.04.15 1.06-.15.27.02.35 1.36.83 2.28.16 3.1-.5.25-.18-2.18-5.9-2.26-7.06-1.28-16.8-3.72-26.66-3.72-26.66s.98 5.96-.37-.5",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.9 347.16s1.8 9.52 1.95 14.98c.24 6.62.52 8.5.42 12.36-.07.26.64 4.99.85 7.04.15 1.06-.15.27.02.35 1.36.83 2.28.16 3.1-.49.25-.19-2.19-5.9-2.26-7.08-1.28-16.81-3.7-26.66-3.7-26.66s.97 5.96-.38-.5zm.78 27.06s1.43.64 1.59.28m.06-1.96s-1.22-.03-1.41-.38m.07-1.64s.9.59 1.14.22m-1.12-2.63l.87.03m-.93-2.37l.95.03m-.8-3.35s.54.24.6-.12m-.77-2.65l.78-.04m.74 14.95s1.4.2 1.56-.25m-1.67-2.98s1.4.12 1.45-.33m-1.5-2s1.13.04 1.2-.05m-1.43-2.18l1.13-.06m-1.12-2.63l.77-.13m-1.08-2.19s.7.15.85-.21m-.93-2.49s.63.42.6-.02m.08 14s1.39 0 1.36-.42",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.8 341.74s.9 7.94 1 9.37c.41 6.89.22 12.1-.1 15.34.02.35-1.33 8.6-.87 9.03 1.59 1.8 1.64 2.01 3.31.67.24-.27-.72-8.71-.79-9.87-.16-1.25-.42-11.1-.6-15.4-.02-1.7-1.48-10.07-1.48-10.07s-.2-1.78-.47.9",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.8 341.74s.9 7.94 1 9.37c.41 6.89.2 12.1-.1 15.34.02.35-1.61 11.82-1.1 9.04 1.58 1.81 1.9 2.5 3.57 1.15.24-.27-.75-9.2-.82-10.36-.16-1.25-.42-11.1-.6-15.4-.02-1.7-1.48-10.07-1.48-10.07s-.2-1.78-.47.9v.03z",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.96 338.96s1.8 9.51 1.97 14.97c.23 6.63.52 8.5.41 12.36-.07.27.65 4.99.86 7.04.15 1.06-.16.27.02.35 1.35.83 2.27.17 3.1-.49.24-.18-2.2-5.9-2.26-7.07-1.29-16.8-3.72-26.66-3.72-26.66l-.38-.5",
    fill: "#f7e214",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.96 338.96s1.8 9.51 1.96 14.97c.23 6.63.51 8.5.4 12.36-.06.27.66 4.99.87 7.04.15 1.06-.16.27.02.35 1.35.83 2.27.17 3.1-.49.24-.18-2.2-5.9-2.26-7.08-1.29-16.8-3.71-26.66-3.71-26.66l-.38-.5zm.78 27.05s1.43.65 1.59.28m.06-1.96s-1.22-.03-1.41-.37m.07-1.64s.9.58 1.14.21m-1.12-2.63l.87.04m-.92-2.37l.95.03m-.8-3.36s.53.24.6-.11m-.77-2.66l.77-.03m.75 14.94s1.4.2 1.55-.25m-1.67-2.97s1.4.11 1.46-.33m-1.51-2s1.13.04 1.21-.05m-1.44-2.19l1.13-.05m-1.12-2.64l.77-.12m-1.08-2.2s.7.15.85-.2m-.93-2.5s.63.42.6-.02m.08 14s1.4.01 1.36-.41",
    fill: "#e8a30e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e8a30e",
    strokeWidth: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.47 216.7s1.26 9.72 1.09 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.27-.27-17.1-2.19-27.2-2.19-27.2l-.36-.53",
    transform: "matrix(-.956 .04296 .0501 .8197 951.28 137.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47 216.7s1.26 9.72 1.08 15.26c-.18 6.73 0 8.64-.37 12.55-.08.27.37 5.1.44 7.18.08 1.08-.17.27 0 .36 1.36.9 2.36.27 3.27-.36.35-.17-1.9-6.09-1.9-7.28-.28-17.1-2.18-27.2-2.18-27.2l-.36-.53zM357.38 244.61s1.45.27 1.64-.18M357.57 241.34s1.45.18 1.45-.27M357.57 238.98s1.17.09 1.27 0M357.47 236.7h1.18M357.65 233.97l.8-.09M357.57 231.6s.62.19.81-.17M357.57 228.87s.62.45.62 0M357.38 243.07s1.45.07 1.45-.36",
    transform: "matrix(-.956 .04296 .0501 .8197 951.28 137.16)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M571.85 346.33l-1.24.1 1.24-.1z",
    fill: "#005000",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.11 400.63s.59-.25.73 0c0 .13-.14.25-.29.25-.15 0-.44-.25-.44-.25zM556.71 402.37s-2.47-.25-3.34-.25",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.19231499999999999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.73 336.68c-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0 .22.68.2 1.26 0 .58-.72 2.6-3.23 4.29-2.56 1.73-6.31 2.3-6.31 2.3z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.7 335.43L552 395.56l2.2-2.17-47.25-61.08-1.27 3.12z",
    fill: "#a05a2c",
    fillRule: "evenodd",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.98 323.69s5-.52 4.35-3.39c-.71-2.83-4.09-2.78-5.5-2.9-1.45-.1-6.05.96-7.41 2.33-1.41 1.4-4.29 3.8-3.36 7.8a31.27 31.27 0 0 0 3.6 9.3 7.63 7.63 0 0 1 .7 6.14c-.12.46-.58 1.99.68 2.54 1.84.79 2.3.8 3.9-.99 1.64-1.74 3.83-4.56 3.79-7.84-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0-1.16-1.89-2.9-1.8-1.78.06-5.3-1.5-7.2-3.35z",
    fill: "#d52b1e",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.98 323.69s5-.52 4.35-3.39c-.71-2.83-4.09-2.78-5.5-2.9-1.45-.1-6.05.96-7.41 2.33-1.41 1.4-4.29 3.8-3.36 7.8a31.27 31.27 0 0 0 3.6 9.3 7.63 7.63 0 0 1 .7 6.14c-.12.46-.58 1.99.68 2.54 1.84.79 2.3.8 3.9-.99 1.64-1.74 3.83-4.56 3.79-7.84-.05-3.28 3.05-5.18 3.52-5.5 1.52-1.02 2.55-1.91 5.82-2.34 0 0-1.16-1.89-2.9-1.8-1.78.06-5.3-1.5-7.2-3.35z",
    fill: "none",
    strokeWidth: 0.19231499999999999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.98 323.69c-.68 0-2.68-.87-4.06-.38-1.35.53-4.15 2.17-3.7 4.54M513.51 327.53s-2.89 1.2-4.92 2.57c-.86.58-3.69 3.2-5.51 5.06-1.62 1.6-1.97 3.75-5.43 6.1M511.7 327.11c-.6.53-1.2 1.06-2.21 1.62-.97.53-1.28 1.37-1.9 2.04",
    fill: "none",
    strokeWidth: 0.19231499999999999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.51
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.9 89.5c-.03 1.92-3.76 4.27-6.82.32-3.2-2.73-2.73-7.08-.33-7.77l27.82-34.58c1.14-.8 1.22-1.52 1.77-2.27a77.52 77.52 0 0 0 5.45 5.42c-.81.86-1.46 1.67-1.62 2.32L156.9 89.5z",
    fill: "#e8a30e",
    fillRule: "evenodd",
    transform: "matrix(-2.89906 .09014 .13563 2.47944 1036.18 208.03)",
    strokeWidth: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.04,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.24 190.48c.84-1.42 4.37 2.18 3.5 3.33-.89 1.16-4.26-1.89-3.5-3.33z",
    fill: "#e7e7e7",
    strokeLinejoin: "round",
    transform: "matrix(-4.63332 .07484 .13578 3.96195 1067.33 -427.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.42 193.54c-.63.59-3.19-1.82-2.8-2.76.66-.88 3.48 2.19 2.8 2.76z",
    fill: "#cccccf",
    transform: "matrix(-4.63332 .07484 .13578 3.96195 1067.33 -427.9)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3513.15 736.64c56.55-19.26 95.95-57.23 120-113.04M3934.48 1159.29c71.13-23.52 119-70.3 139.06-144.9M3964.46 1190.93c71.13-23.52 119-70.3 139.06-144.89M4138.5 1357.47c71.12-23.52 127.32-76.13 147.38-150.72M4169.3 1389.11c71.13-23.52 128.16-76.96 148.22-151.55",
    fill: "none",
    transform: "matrix(.1253 .00359 -.00348 .12902 74.82 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4338.34 1405.77c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(.1253 .00359 -.00348 .12902 74.82 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4375.22 1406.93c.31 11-9.01 20.16-20.85 20.47-11.84.32-21.72-8.32-22.09-19.32-.37-11 8.9-20.2 20.74-20.57 11.84-.38 21.76 11.55 22.2 22.55",
    fill: "#e8a30e",
    transform: "matrix(.1253 .00359 -.00348 .12902 74.82 248.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4336.24 1403.84c4.01 16.34 13.42 21.21 26.23 15.82M4192.59 1403.14c28.07 40.4 57.66 27.18 82.72 26.9",
    fill: "none",
    strokeLinecap: "round",
    transform: "matrix(.1253 .00359 -.00348 .12902 74.82 248.4)"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 2.16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M580.7 274.25c2.78 4.43 6.89 12.44 8.01 18.57 2.07 11.31-1.17 23.85-11.02 32.71-8.03 7.22-20.63 9.46-25.89 10.53-5.25 1.08-9.04 2.77-9.91 3.93-.05-.82-.16-1.63.71-2.45 2.5-1.1 6.54-1.75 12.18-2.91 11.33-2.34 23.23-6.58 29.71-18.95 8.46-16.12 3.42-28.79-3.9-41.37l.11-.06z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.0845 .08154 -.07896 .07515 609.5 273.75)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M591.52 320.22c-1.68 1-3.35 1.26-4.69 1.7-1.03.35-2.81.91-3.43 1.14-.58.22-1.5.64-2.28.99-1.24.56-2.58 2.12-2.58 2.12s1.89 1.98 4.14 1.7c1.77-.22 2.66-.7 3.54-1.14.92-.45.9-.96 2.23-1.91 1.47-1.06 2.5-3.15 3.07-4.6zM582.7 322.09c-.55.84-1.84.78-2.58.66l-.33.42c1.01.02 2.4.03 3.1-.88-.02-.14-.1-.2-.2-.2z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M591.5 320.3c-1.52 1.48-4.37 3.13-7.23 4.35a21.94 21.94 0 0 1-7.81 1.6l-.42.45c2.31-.21 5.37-.63 7.95-1.7 3.38-1.38 6.15-3.16 7.53-4.62l-.02-.09zM587.79 327.44c-3.05-.1-4.72.84-7.55 1.46-2.64.58-5.73-.8-7.44 1.75 6.88 4.46 11.86 1.46 14.99-3.2z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M581.6 333.7c-1.32-1.13-12.59-4.94-14.38-.68 2.68 2.96 10.52 3.62 14.37.67z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M578.92 336.7c-1.19-.2-2.59-.47-3.96-.63-1.38-.16-1.92-.4-2.93-.54-1.67-.23-3.58-2.56-9.44-.78 2.27 5.23 10.02 6.33 16.33 1.94zM581.46 333.78c-6 1.2-13.06 0-15.85-1.65l-.44.3c6.43 2.74 12.68 2.38 16.29 1.35zM587.7 327.44c-3.54 2.37-8.1 4.14-17.86 2.83l-.13.34c13.37 1.15 14.7-1.3 17.98-3.17z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M578.88 336.74c-4.67.16-7.3 2.24-16.03-2.06-.72-.35-1.67-.6-2.22-.86l-.8.3c.6.27 1.59.26 2.13.5 10.92 4.82 10.61 2.57 16.92 2.12z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(-.05923 -.0996 -.0979 .05129 617.52 320.58)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M561.17 331.64c-1 .26-1.3 1.46-1.39 2.17l-.52.18c.27-.92.64-2.2 1.76-2.57.13.05.17.14.15.22z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.11688 .02781 -.02616 .1032 585.82 237.8)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M583.78 317.43c-.21-3.26-1.8 1.25-5-6.03-.92-2.11-.91-3.46-1.54-6.64 1.74 2.75 4.65 3.49 5.83 5.6 1.16 2.1.86 5.45.71 7.07z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M577.3 305s1.57 3.67 3.84 6.27c2.28 2.62 2.7 5.8 2.7 5.8",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M578.86 308.12c2 2.7 4.7 5.9 4.82 9.26l.32.11c-.47-4.41-3.08-6.45-4.7-8.68l-.44-.7zM595.8 312.29c-1.46 1.2-3 1.64-4.21 2.24-.93.46-1.72 1.07-2.27 1.37-.52.3-1.38.42-2.07.87-1.1.7-3.26 3.17-3.26 3.17s2.04 1.68 3.3 1.4c3.69-.71 4.76-2.17 6.62-3.52 1.43-1.18 1.53-3.96 1.9-5.53z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M582.34 320.06l-.35.5c2.11-.2 5.48-2.23 7.72-3.36 3.01-1.52 4.7-2.67 5.98-4.83-1.44 2.16-3.33 3.38-6.16 4.75-2.38 1.15-5.76 3.1-7.2 2.94z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M597.06 305.15c-1.23 1.43-2.67 2.1-3.76 2.89-.83.6-1.5 1.33-1.98 1.72-.47.37-1.3.64-1.9 1.19-.95.87-2.38 3.42-2.38 3.42s1.02 1.09 2.22.61c3.71-.46 4.8-2.22 6.18-5.38.77-1.64 1.53-2.84 1.62-4.45z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(-.10957 .0476 .04556 .09693 577.86 257.64)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M585.17 314.98l-.25.55c4.45-2.02 10.28-6.11 12.2-10.27-2.72 4.49-7.2 7.45-11.95 9.72zM598.07 298.28c-1.05 1.49-2.36 2.25-3.33 3.1-.74.64-1.32 1.4-1.75 1.82-.41.4-1.17.71-1.7 1.3-.84.92-2 3.52-2 3.52s1.36 1.27 2.46.73c1.1-.55 2.56-1.8 3.29-2.44.75-.68.94-2.3 1.83-3.55a6.9 6.9 0 0 0 1.2-4.48z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M594.87 302.87c-2.15 2.46-4.8 4.8-7.3 5.87l-.19.57c4.05-2.3 5.75-4.37 7.54-6.36l-.05-.08zM596.54 294.05c-.73 1.44-1.84 2.3-2.6 3.17-.59.67-1 1.42-1.33 1.84-.32.4-.98.79-1.38 1.37-.63.92-1.26 3.34-1.26 3.34s.92.98 1.86.35a18.3 18.3 0 0 0 2.85-2.6c.6-.7.9-2.2 1.52-3.4.72-1.41.66-2.7.34-4.07zM589.72 292.34c-.4.85-.55 1.68-.8 2.55l-.1-.63c.2-.68.37-1.4.7-2.02.06-.02.13-.02.2.1z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M594.33 298.5c-1.6 2.44-3.7 4.86-5.86 6.15l-.08.52c3.41-2.58 4.66-4.63 6-6.61l-.06-.06zM585.55 313.96a5.05 5.05 0 0 0-.84-2.1c-.07 0-.13.03-.14.1.46.75.66 1.42.79 2.33l.19-.33z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.06585 -.05973 .05891 .0576 545.9 264.29)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M586.17 285.2c-.56-.48-1.25-.92-1.95-1.35-.08.03-.09.09-.07.16.81.5 1.52 1 2.12 1.57l-.1-.38zM594.8 285.76c-1.77 3.73-6.02 6.33-4.31 11.8 4.39 3.97 4.67-7.1 4.31-11.8z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M590.77 277.6c-.72 3.81-4.1 6.96-1.89 12.01 6.23 1.57 3.26-6.82 1.9-12z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M587.09 271.9c3.13 5.81 3.88 9.18.19 13 0 0-1.94-1.83-2.4-5.18-.4-2.84 1.92-6.23 2.2-7.82z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M581.9 268.52c.83 3.69-2.37 5.38 2.2 10.13 3.26-3.88 1.7-4.84-2.2-10.13z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M580.67 274.97c-5.26.57-3.21-4-4.71-8.2 3.1 2.3 7.3 3.23 4.7 8.2zM584.1 281.93c-1.48-6.86-6.2-4.17-8.81-7.2 1.35 4.43 3.33 7.45 8.8 7.2zM586.22 288.32c-4.11-.27-7.44-2.3-9.66-6.85 4.22 1.89 8.9 2.08 9.66 6.85z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M586.85 294.27c-1.63-1.86-1.67-3.06-2.28-4.3a14.07 14.07 0 0 0-4.76-5.8c.02 4.86.71 10.22 7.04 10.1z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M587.78 299.34c-2.52-3.51-4.86-6.5-8.68-8.95 1.58 3.45.85 9.84 8.68 8.95z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M587.07 306.32c-7.75-.22-7.02-7.53-7.08-10.95 1.4 2.1 3.11 3.91 4.38 5.42 1.4 1.64 2.74 3.5 2.7 5.53z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M586.13 310.67c-.62-1.59-.14-2.23-1.53-3.62-1.49-1.5-4.36-4.2-5.86-7.28-.21 2.73-.25 6.94 1.87 8.36 1.6 1.06 3 1.36 5.52 2.54zM579.37 322c-6.08-4.74-2.43-8.73-1.92-12.26 1.55 3.99 5.9 7.42 1.92 12.25zM581.86 276.4a86.01 86.01 0 0 0-5.75-9.5c3.01 4.35 4.31 7.12 6.04 10.1",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M579.46 323.17c.24-4.81-1.07-8.96-1.92-13.3.8 4.58 1.95 9.2 1.52 13.68l.4-.38zM586.67 311.63c-.63-2.94-6.43-4.9-7.88-11.74 1.19 6.8 7.07 8.52 7.66 12.34l.22-.6zM587.97 307.63l-.16.74c-.86-4.6-6.27-6.87-7.83-13.02 2.28 6.66 6.7 7.54 7.99 12.28zM589.04 300.73c-2.66-4.07-6.39-5.6-9.91-10.37 3.3 4.69 7.45 6.88 9.97 11l-.06-.63zM588.95 295.38c-2.94-1.26-5.98-4.77-9.16-11.2 2.09 4.75 4.73 9.06 9.16 11.92v-.72z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M587.6 289.1c-3.43-2.7-7.86-4.5-11.05-7.67 2.65 3.02 7.74 5.13 11.14 8.12l-.1-.45zM584.95 282.38c-3.46-2.35-6.79-3.08-9.66-7.53 2.3 4.36 5.98 5.46 9.78 7.86l-.12-.33zM594.8 285.85c-1.24 4.8-2.29 9.85-5.57 13.08l.03-.62c1.5-.84 3.88-5.85 5.54-12.46zM590.8 277.78c-.22 4.96-.14 10.21-2.7 13.03l-.2-.57c2.62-2.12 2.4-7.73 2.9-12.46zM587.28 272.14c.88 4.36.94 8.4-.22 14.93l-.25-.47c.73-3.85 1.55-7.8.47-14.46zM581.99 268.67c1.75 3.7 3.1 7.45 1.95 11.47l-.31-.45c1.36-3.67-.23-7.35-1.64-11.02z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.2 317.43c2.08 5-.66 8.62-3.9 10.72-2.53-7.26 2.73-6.44 3.9-10.72z",
    strokeWidth: 0.19202400000000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.3 317.41c.35 3.1-3 6.55-4.05 11.77l-.47.43c1.55-6.37 4.8-8.82 4.51-12.2z",
    strokeWidth: 0.19202400000000003
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.08752 .01564 -.0096 .08183 578.72 241.2)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M586.76 285.87c.04-.74-.04-1.55-.12-2.37-.07-.05-.12-.02-.17.04.1.95.13 1.81.05 2.64l.24-.31z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.06806 -.0338 .01538 .06954 568.1 253.97)",
    fill: "#d52b1e",
    strokeWidth: 2.65
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M586.18 284.93c-.17-.6-.45-1.2-.74-1.8-.06 0-.1.04-.1.11.32.7.59 1.37.75 2.06l.1-.37z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.08889 -.00182 .00663 .08212 572.2 252.5)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M588.84 294.72c-.1-.73-.34-1.52-.59-2.3-.08-.03-.12 0-.15.07.28.92.49 1.75.57 2.58l.17-.35z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.06188 -.0663 .05536 .06394 550.9 271.43)",
    fill: "#d52b1e",
    strokeWidth: 2.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M588.74 294.65a13.93 13.93 0 0 0-1.83-1.5c-.07.03-.08.1-.06.17a13.4 13.4 0 0 1 1.99 1.75l-.1-.42z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.083 .03187 -.02487 .07855 586.21 268.38)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M585.69 313.76c.18-.72.25-1.53.32-2.35-.06-.06-.11-.05-.17 0-.09.96-.21 1.81-.45 2.6l.3-.25z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(-.06585 -.05973 -.05891 .0576 625.76 293.28)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M585.5 314.2c.55-.48 1.24-.92 1.94-1.35.09.03.1.09.07.16-.8.5-1.51 1-2.12 1.57l.1-.38z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.05877 .0667 -.05844 .05807 601.94 282.16)",
    fill: "#d52b1e",
    strokeWidth: 2.25
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M580.44 322.12c.5-.55.94-1.23 1.38-1.93-.03-.08-.09-.09-.16-.07-.52.8-1.02 1.5-1.6 2.1l.38-.1z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(-.11967 -.0134 -.01416 .10528 604.06 270.57)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M580.28 320.42c-.37.95-.1 1.31.11 1.72l-.23.49c-.32-.55-.45-1.14-.16-2.27.14-.05.23-.01.28.06zM561.35 335.09c-1.04.08-1.56-.5-1.9-1.13h-.55c.58.78 1.2 1.4 2.4 1.39.1-.1.1-.2.05-.26z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(-.02645 .11159 -.10932 -.0223 618.28 330.4)",
    fill: "#d52b1e",
    strokeWidth: 1.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M569.83 322a8.61 8.61 0 0 1-6.26 9.94c-1.38-6.2 4.34-6.43 6.26-9.94z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M569.84 322.04a33.7 33.7 0 0 1-7.43 11.17l-.8.1c4.19-3.31 6.5-7.63 8.23-11.27z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4 484.16a5.78 8.12 0 1 1-11.56 0 5.78 8.12 0 1 1 11.56 0z",
    transform: "matrix(.05417 .0985 -.0893 .02218 597.38 307.93)",
    fill: "#d52b1e",
    strokeWidth: 1.92
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M559.23 334.05c.77-.24 1.52-.65 2.27-1.07-.01-.09-.08-.13-.17-.15-.88.47-1.71.85-2.6 1.1l.5.12z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.42,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.33 326.25c-.2 1.93-1.72 3.67-3.13 5.03-1.4 1.36-1.55 1.86-3.53 2.45-1.9-4.33 4.46-5.19 6.66-7.48z",
    strokeWidth: 0.192027
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.32 326.2c-2.13 3.97-5.5 5.92-7.34 8.48l-.27-.02c2.64-3.48 4.88-4.14 7.6-8.46z",
    strokeWidth: 0.192027
  }))), /*#__PURE__*/React.createElement("g", null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M519.41 274.25c-2.77 4.43-6.89 12.44-8 18.57-2.08 11.31 1.16 23.85 11.01 32.71 8.03 7.22 20.63 9.46 25.9 10.53 5.24 1.08 9.04 2.77 9.9 3.93.05-.82.17-1.63-.7-2.45-2.5-1.1-6.55-1.75-12.18-2.91-11.33-2.34-23.24-6.58-29.72-18.95-8.46-16.12-3.42-28.79 3.9-41.37l-.11-.06z",
    fillRule: "evenodd",
    strokeWidth: 0.19202400000000003
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.11577 0 0 -.11026 470.28 397.17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.11577 0 0 -.11026 470.28 397.17)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.0444 .06862 -.05494 .02167 594.9 355.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.0444 .06862 -.05494 .02167 594.9 355.34)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.05524 -.03793 .04771 .06236 525.35 215.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.05524 -.03793 .04771 .06236 525.35 215.78)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.02243 -.06172 .053 .0239 500.95 225.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.02243 -.06172 .053 .0239 500.95 225.9)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.04201 -.04403 -.03718 -.02348 564.75 263.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.04201 -.04403 -.03718 -.02348 564.75 263.98)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.0109 -.0722 .04959 .01802 494.01 226.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.0109 -.0722 .04959 .01802 494.01 226.27)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.00144 -.07793 .0687 .00644 475.88 232.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.00144 -.07793 .0687 .00644 475.88 232.54)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.01157 -.07209 .05272 .00208 475.45 242.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.01157 -.07209 .05272 .00208 475.45 242.62)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.04886 -.04636 -.04417 -.04006 571.17 275.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.04886 -.04636 -.04417 -.04006 571.17 275.47)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.05208 -.04272 -.04117 -.04314 569.92 282.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.05208 -.04272 -.04117 -.04314 569.92 282.54)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.05391 -.04792 -.04589 -.04442 572.3 284.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.05391 -.04792 -.04589 -.04442 572.3 284.15)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4.24,
    fillRule: "evenodd"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M513.8 285.95s-.44-.87-.44-1.67c-.01-.8.2-1.21.2-1.21l-.32-.2s-.15.86-.15 1.28l.01.51s-.56-.48-.68-.75l-.28-.68-.27.12s.25.85.47 1.02c.75.57 1.21 1.73 1.21 1.73",
    strokeWidth: 0.1923688
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.87 281.72a.58.85-6.47 1 1 .19 1.69.58.85-6.47 1 1-.2-1.69z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1928355,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.8 281.7a.85.58-70.71 1 1-.55 1.61.85.58-70.71 1 1 .56-1.6z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1928355,
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4.24,
    fillRule: "evenodd"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M513.64 285.86s.89-.39 1.4-1c.5-.63.61-1.08.61-1.08l.37.05s-.43.77-.69 1.09l-.34.39s.74-.02 1.01-.16c.27-.13.64-.35.64-.35l.14.27s-.73.5-1 .49c-.96-.03-2.04.58-2.04.58",
    strokeWidth: 0.1923688
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.8 283.8a.85.58-44.43 1 0-1.2 1.2.85.58-44.43 1 0 1.2-1.2z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1928355,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.31 282.57a.85.58-70.18 1 0-.57 1.6.85.58-70.18 1 0 .57-1.6z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1928355,
    overflow: "visible"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.01678 -.07418 .05494 -.0013 469.8 247.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.01678 -.07418 .05494 -.0013 469.8 247.56)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.05289 -.05337 -.05062 -.04316 573.21 284.35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.05289 -.05337 -.05062 -.04316 573.21 284.35)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.05443 -.05577 -.04812 -.02978 572.05 279.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.05443 -.05577 -.04812 -.02978 572.05 279.46)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.02128 -.07612 .07793 -.01146 453.26 256.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.02128 -.07612 .07793 -.01146 453.26 256.53)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.04466 -.06692 -.05426 -.02125 569.63 273.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.04466 -.06692 -.05426 -.02125 569.63 273.14)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.0337 -.0747 .07231 -.02674 448.84 271.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.0337 -.0747 .07231 -.02674 448.84 271.75)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.89,
    fillRule: "evenodd"
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M511.02 299.36s-.7-.8-.92-1.64c-.22-.85-.12-1.34-.12-1.34l-.38-.12s.07.95.18 1.38l.15.55s-.72-.36-.92-.62l-.48-.64-.25.2s.49.83.76.94c.96.42 1.75 1.52 1.75 1.52",
    strokeWidth: 0.192555
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.84 295.4a.63.93-20.56 1 1 .65 1.74.63.93-20.56 1 1-.65-1.74z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19274030000000003,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.9 294.87a.63.93 5.2 1 1-.18 1.85.63.93 5.2 1 1 .17-1.85z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19274030000000003,
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.89,
    fillRule: "evenodd"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M511 299.3s.84-.65 1.22-1.44c.38-.79.36-1.3.36-1.3l.4-.04s-.24.92-.43 1.33l-.26.5s.78-.21 1.03-.43c.24-.2.59-.54.59-.54l.21.25s-.64.72-.93.78c-1.02.23-2 1.16-2 1.16",
    strokeWidth: 0.192555
  })), /*#__PURE__*/React.createElement("path", {
    d: "M514.87 296.02a.93.63-58.51 1 0-.96 1.58.93.63-58.51 1 0 .96-1.58z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19274030000000003,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.96 295.1a.63.93 5.73 1 0-.18 1.85.63.93 5.73 1 0 .18-1.84z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19274030000000003,
    overflow: "visible"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.05002 -.07495 .06077 -.0238 446.17 274.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.05002 -.07495 .06077 -.0238 446.17 274.65)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.03692 -.0818 -.0792 -.02929 580.01 273.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.03692 -.0818 -.0792 -.02929 580.01 273.54)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.0346 -.08362 -.07299 -.0195 576.5 271.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.0346 -.08362 -.07299 -.0195 576.5 271.62)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.98
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.0568 -.08234 .081 -.0479 431.82 288.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.0568 -.08234 .081 -.0479 431.82 288.74)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.01123 -.08405 -.06502 .0048 563.24 267.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.01123 -.08405 -.06502 .0048 563.24 267.44)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.0827 -.06704 .07183 -.06909 426.97 320.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.0827 -.06704 .07183 -.06909 426.97 320.2)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.07484 -.07005 .06288 -.04124 434.11 298.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.07484 -.07005 .06288 -.04124 434.11 298.38)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.01884 -.09267 -.08599 -.0123 577.2 267.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.01884 -.09267 -.08599 -.0123 577.2 267.75)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.47,
    fillRule: "evenodd"
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M514.75 314.8s-1.08-.5-1.68-1.27c-.6-.78-.72-1.33-.72-1.33l-.44.05s.49.94.8 1.34c.3.4.4.5.4.5s-.9-.05-1.22-.23c-.33-.17-.78-.44-.78-.44l-.18.32s.88.63 1.22.62a5.8 5.8 0 0 1 2.47.78",
    strokeWidth: 0.19234210000000002
  })), /*#__PURE__*/React.createElement("path", {
    d: "M509.72 312.16a.7 1.04-44.11 1 1 1.44 1.49.7 1.04-44.11 1 1-1.44-1.49z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19278089999999998,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.59 310.7a.7 1.04-18.35 1 1 .65 1.97.7 1.04-18.35 1 1-.65-1.97z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19278089999999998,
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.47,
    fillRule: "evenodd"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M514.9 314.74s.56-1.04.6-2.02c.03-.98-.2-1.49-.2-1.49l.38-.22s.16 1.05.15 1.56c-.02.5-.04.63-.04.63s.7-.57.86-.9c.16-.33.36-.82.36-.82l.33.15s-.33 1.03-.6 1.23c-.94.68-1.54 2.08-1.54 2.08",
    strokeWidth: 0.19234210000000002
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.4 309.64a.7 1.04 7.93 1 0-.29 2.06.7 1.04 7.93 1 0 .29-2.06z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19278089999999998,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.03 309.57a.7 1.04-17.83 1 0 .63 1.97.7 1.04-17.83 1 0-.63-1.97z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.19278089999999998,
    overflow: "visible"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.0873 -.03844 .03616 -.07072 447.54 341.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.0873 -.03844 .03616 -.07072 447.54 341.65)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(.00173 -.07673 -.05583 -.00256 555.07 279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(.00173 -.07673 -.05583 -.00256 555.07 279)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.10019 -.03492 .04827 -.0788 438.61 352.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.10019 -.03492 .04827 -.0788 438.61 352.73)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.0355 -.06479 -.07228 .04669 547.73 262.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.0355 -.06479 -.07228 .04669 547.73 262.28)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.01,
    fillRule: "evenodd"
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M523.96 326.03s-.9.71-1.88.15a4.1 4.1 0 0 1-1.33-1.11l-.46.24s.93.8 1.43 1.1c.5.29.64.35.64.35s-.99.33-1.4.29c-.42-.05-1.03-.15-1.03-.15l-.05.42s1.19.18 1.57.15c.38-.02 2.4-.8 2.4-.8",
    strokeWidth: 0.1923089
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.9 326.15a.81 1.2-65.89 1 1 2.19.98.81 1.2-65.89 1 1-2.18-.98z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1918091,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.28 323.79a.81 1.2-40.13 1 1 1.54 1.83.81 1.2-40.13 1 1-1.54-1.83z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1918091,
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.01,
    fillRule: "evenodd"
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M524.07 326.57s.77-.87.26-1.88a4.1 4.1 0 0 0-1.02-1.4l.26-.43s.75.97 1.01 1.5a8 8 0 0 1 .31.65s.4-.96.38-1.38c-.02-.42-.08-1.03-.08-1.03l.42-.02s.1 1.19.05 1.57c-.05.38-.95 2.34-.95 2.34",
    strokeWidth: 0.1923089
  })), /*#__PURE__*/React.createElement("path", {
    d: "M524.56 320.53a.81 1.2-20.55 1 0 .84 2.24.81 1.2-20.55 1 0-.84-2.24z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1918091,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.12 321.76a.81 1.2-46.3 1 0 1.73 1.65.81 1.2-46.3 1 0-1.73-1.65z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1918091,
    overflow: "visible"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.10758 -.0135 .01448 -.10023 457.88 380.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.10758 -.0135 .01448 -.10023 457.88 380.47)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.61,
    fillRule: "evenodd"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M535.58 332.1s-.73 1.11-2 .86c-1.28-.26-1.87-.72-1.87-.72l-.41.43s1.31.53 1.97.67c.66.13.83.15.83.15s-.95.73-1.43.83c-.47.1-1.17.22-1.17.22l.1.47s1.36-.24 1.77-.41a24.5 24.5 0 0 0 2.3-1.76",
    strokeWidth: 0.1920699
  })), /*#__PURE__*/React.createElement("path", {
    d: "M529.01 334.47a.93 1.38-84.59 1 1 2.75.26.93 1.38-84.59 1 1-2.75-.26z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1924824,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.64 331.38a.93 1.38-58.83 1 1 2.36 1.43.93 1.38-58.83 1 1-2.36-1.43z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1924824,
    overflow: "visible"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-609.04 575.42c2.99-5.86 54.13-52.97 100.64-49.44 34.05 2.58 39.68 11.2 39.68 11.2s3.18 8.86-27.06 15.36c-30.54 6.56-83.49 28.46-113.26 22.88z",
    fillRule: "evenodd",
    transform: "matrix(-.05025 -.05913 -.07391 .0559 545.48 263.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470.4 536.96c-36.55-4.34-73.8 11.16-102.96 22.85",
    transform: "matrix(-.05025 -.05913 -.07391 .0559 545.48 263.4)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.61,
    fillRule: "evenodd"
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M536.48 332.92s.34-1.29-.7-2.07a4.72 4.72 0 0 0-1.78-.9l.05-.6s1.27.62 1.81 1.02.66.52.66.52-.09-1.2-.33-1.62c-.24-.42-.62-1.01-.62-1.01l.42-.24s.73 1.17.88 1.58c.14.42.23 2.9.23 2.9",
    strokeWidth: 0.1920699
  })), /*#__PURE__*/React.createElement("path", {
    d: "M533.86 326.45a.93 1.38-47.26 1 0 2.03 1.87.93 1.38-47.26 1 0-2.03-1.87z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1924824,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.98 328.98a.93 1.38-73.02 1 0 2.64.8.93 1.38-73.02 1 0-2.64-.8z",
    style: {
      marker: "none"
    },
    fill: "#000",
    strokeWidth: 0.1924824,
    overflow: "visible"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M548.6 326.54s-3.66 8.5-2.4 9.34c0 0 3.72-6.6 6.97-9.09 1.7-1.6 2.73.01 2.95-1.39.21-1.4-4.46-3.42-4.46-3.42l-3 4.21",
    fill: "#452c25"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M593.68 214.48s-8.43 19.15-5.52 21.05c0 0 8.55-14.87 16.06-20.5 3.9-3.6 6.27.04 6.77-3.13s-10.26-7.71-10.26-7.71l-6.9 9.5",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.58
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M535.26 333.01s-5.32 9.26-3.93 9.37c1.4.1 7.08-11.8 7.08-11.8l-1.94.33-1.21 2.1z",
    fill: "#452c25"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M562.94 229.06s-12.24 20.87-9.03 21.12c3.2.24 16.3-26.61 16.3-26.61l-4.46.74-2.8 4.75z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M536.86 330.43s-5.56 9.1-4.17 9.26c1.4.14 7.39-11.6 7.39-11.6l-1.95.27-1.27 2.07z",
    fill: "#452c25"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M566.64 223.25s-12.8 20.53-9.6 20.86c3.2.33 17.02-26.16 17.02-26.16l-4.49.63-2.93 4.67z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M537.99 328.85s-6.33 8.56-4.96 8.84c1.37.27 8.37-10.9 8.37-10.9l-1.97.11-1.44 1.95z",
    fill: "#452c25"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M569.23 219.67S554.66 239 557.82 239.6c3.16.62 19.27-24.55 19.27-24.55l-4.52.23-3.34 4.4z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M539.68 327.34s-7.41 7.61-6.09 8.07c1.32.46 9.74-9.62 9.74-9.62l-1.96-.18-1.7 1.73z",
    fill: "#452c25"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M573.13 216.28s-17.07 17.15-14.02 18.2c3.05 1.03 22.43-21.7 22.43-21.7l-4.51-.4-3.9 3.9z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M539.94 324.58s-6.46 8.45-5.1 8.75c1.37.3 8.54-10.74 8.54-10.74l-1.96.06-1.48 1.93z",
    fill: "#452c25"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M573.74 210.04s-14.9 19.07-11.75 19.74c3.15.67 19.68-24.23 19.68-24.23l-4.53.16-3.4 4.33z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M538.3 331.84s-6.34 8.57-4.96 8.84c1.37.28 8.36-10.88 8.36-10.88l-1.96.1-1.45 1.94z",
    fill: "#452c25"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M569.94 226.43s-14.58 19.31-11.42 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.52.23-3.33 4.4z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M541.85 330.15s-3.7 6.97-3.28 7.26c.43.3 4.92-3.97 7.15-8.12 2.22-4.15-4.03.69-4.03.69",
    fill: "#452c25"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M578.14 222.61s-8.53 15.72-7.56 16.37c.98.66 11.34-8.96 16.46-18.31 5.12-9.36-9.27 1.55-9.27 1.55",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M542.25 329.46s-3.66 8.5-2.4 9.34c0 0 4.6-5.13 5.8-9.2 1.19-4.07 0-.28 0-.28l-.34-4.42-3 4.2",
    fill: "#452c25"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M579.05 221.05s-8.42 19.16-5.51 21.06c0 0 10.57-11.56 13.33-20.74 2.75-9.18 0-.63 0-.63l-.77-9.98-6.9 9.5",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.58
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M540.35 328.72s-7.4 7.6-6.09 8.07c1.33.46 9.74-9.63 9.74-9.63l-1.96-.17-1.69 1.73z",
    fill: "#452c25"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M574.68 219.38s-17.07 17.15-14.02 18.19c3.04 1.04 22.43-21.7 22.43-21.7l-4.51-.39-3.9 3.9z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M540.94 329.75s-7.41 7.6-6.09 8.07c1.33.46 9.74-9.63 9.74-9.63l-1.96-.17-1.7 1.73z",
    fill: "#452c25"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M576.03 221.7s-17.06 17.16-14.02 18.2c3.05 1.03 22.44-21.7 22.44-21.7l-4.51-.4-3.9 3.9z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M541.53 330.95s-7.41 7.6-6.09 8.07c1.32.46 9.74-9.63 9.74-9.63l-1.96-.17-1.7 1.73z",
    fill: "#452c25"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M577.39 224.41s-17.07 17.16-14.02 18.2c3.05 1.03 22.43-21.7 22.43-21.7l-4.51-.4-3.9 3.9z",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M542.08 320.5s-5.5 7.04-4.71 8.25c.8 1.2 5.82-3.23 7.41-6.34 1.59-3.11-2.65-2.13-2.65-2.13",
    fill: "#452c25"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M578.66 200.87s-12.67 15.85-10.85 18.58c1.83 2.73 13.41-7.28 17.07-14.3 3.66-7-6.1-4.8-6.1-4.8",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M541.9 327.97s-4.71 9.03-3.5 8.52c1.22-.52 6-7.31 6.53-8.81.53-1.5.35-3.07.35-3.07l-3.65 2.25.32 1.75",
    fill: "#452c25"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M578.26 217.7s-10.87 20.36-8.07 19.2c2.8-1.18 13.82-16.49 15.04-19.86 1.22-3.38.81-6.91.81-6.91l-8.41 5.07.72 3.94",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M541.94 325s3.91-7.2-.03 1.36c-3.94 8.55-5.42 7.14-5.42 7.14-.3-.49 3.43-6.28 3.43-6.28s2.77-4.46 3.44-4.88",
    fill: "#452c25"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M578.33 211.01s9.02-16.23-.06 3.06c-9.08 19.28-12.48 16.1-12.48 16.1-.7-1.1 7.9-14.17 7.9-14.17s6.38-10.05 7.91-11",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M546.14 324.05s4.35-7.15-.02 1.36c-4.36 8.5-6.06 7.06-6.06 7.06-.36-.49 3.81-6.23 3.81-6.23s3.1-4.43 3.84-4.84",
    fill: "#452c25"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M588 208.85s10.03-16.11-.02 3.06C577.93 231.1 574 227.85 574 227.85c-.81-1.11 8.79-14.07 8.79-14.07s7.12-9.97 8.85-10.9",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.43
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M584.32 202.05s-12.67 15.85-10.85 18.58c1.83 2.73 13.41-7.27 17.07-14.29s-6.1-4.8-6.1-4.8",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.47
  })), /*#__PURE__*/React.createElement("g", null, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M601.28 392.3a51.28 57.7 0 1 1-102.56 0 51.28 57.7 0 1 1 102.56 0z",
    fill: "#e8a30e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M508.9 392.3c0-26.8 18.86-47.36 41.1-47.36 22.24 0 41.1 20.57 41.1 47.37",
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none",
      InkscapeFontSpecification: "Sans"
    },
    fontWeight: 400,
    color: "#000",
    fill: "none",
    stroke: "#390",
    strokeWidth: 1.2820999999999998,
    overflow: "visible",
    fontFamily: "Sans"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M498.79 395.33C500.19 425.8 522.59 450 550 450c27.42 0 49.81-24.21 51.21-54.67H498.8z",
    fill: "#007934",
    stroke: "#eee",
    strokeWidth: 0.12821
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M-237.6 1162.17a577.6 643.15 0 1 1-1155.21 0 577.6 643.15 0 1 1 1155.21 0z",
    transform: "matrix(.08878 0 0 .0897 622.38 288.06)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6.46
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.51 493.62c-4.87 19.06.5 34.74 9.81 49.52 7.2 11.43 11.93 23.61 11.7 36.7-3.27 1.85-6.4 3.84-9.4 5.98l-75.26-49.99 50.52 74.43c-.9 1.26-1.8 2.56-2.64 3.85-14.33-6.46-27.79-7.74-40.6-5.26-18.13 3.5-33.51-.29-49.58-9.86 10.03 16.92 25 24.2 42.03 28.07 13.2 3 25.13 8.26 34.24 17.7-1 3.57-1.81 7.17-2.43 10.82L80.3 673.55l88.39 16.9c.24 1.52.53 3.04.84 4.55-14.7 5.57-25.15 14.15-32.46 24.97-10.34 15.3-23.83 23.5-41.96 28.08 19.06 4.88 34.72-.56 49.5-9.87 11.43-7.2 23.6-11.93 36.7-11.7 1.84 3.27 3.83 6.4 5.98 9.4l-49.97 75.33 74.47-50.62c1.24.9 2.5 1.83 3.78 2.67-6.45 14.33-7.7 27.85-5.23 40.67 3.5 18.12-.31 33.44-9.89 49.5 16.92-10.02 24.21-24.99 28.08-42.02 3-13.2 8.25-25.13 17.7-34.24 3.57 1 7.15 1.8 10.82 2.43l17.96 88.59 16.9-88.39c1.52-.24 3.04-.53 4.56-.84 5.56 14.7 14.15 25.15 24.97 32.46 15.29 10.34 23.49 23.83 28.08 41.96 4.87-19.06-.57-34.72-9.88-49.5-7.21-11.45-11.9-23.6-11.64-36.72 3.25-1.84 6.35-3.83 9.35-5.96l75.32 49.97-50.55-74.5c.89-1.22 1.77-2.49 2.6-3.75 14.34 6.47 27.85 7.71 40.67 5.23 18.12-3.5 33.44.31 49.51 9.89-10.03-16.92-24.97-24.15-42-28.01-13.19-3-25.1-8.36-34.2-17.8a107.4 107.4 0 0 0 2.37-10.79l88.6-17.9-88.4-16.96c-.25-1.52-.54-3.04-.85-4.56 14.72-5.55 25.15-14.14 32.47-24.97 10.33-15.29 23.85-23.42 41.98-28.01-19.06-4.88-34.74.5-49.52 9.8-11.46 7.22-23.6 11.9-36.73 11.65a106.67 106.67 0 0 0-5.95-9.35l49.99-75.26-74.52 50.49c-1.23-.89-2.5-1.77-3.76-2.6 6.47-14.33 7.74-27.79 5.26-40.6-3.5-18.13.29-33.51 9.86-49.58-16.92 10.03-24.14 24.97-28.01 42-3 13.22-8.35 25.19-17.83 34.3-3.54-1-7.12-1.85-10.75-2.47l-17.9-88.6-16.97 88.4c-1.52.25-3.04.54-4.55.85-5.57-14.7-14.15-25.15-24.97-32.47-15.3-10.33-23.43-23.85-28.02-41.98z",
    style: {
      marker: "none"
    },
    fill: "#d52b1e",
    strokeWidth: 1.67,
    overflow: "visible",
    transform: "translate(518.3 295.25) scale(.11524)"
  }), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.85 374.24) scale(.22284)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "rotate(22.5 138.15 65.85)",
    width: 330,
    height: 330,
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 35.71 -47.86)",
    width: 330,
    height: 330,
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.7 2.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57-21.86c-11.5-10-26-11.5-34-4-5.8 7.77-5.29 16.9 1.5 26.5-.5 0-1.5.5-2 1-5.04-9.6-5.9-19.49-2.5-28.5 11-9 26-10 37 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.43-24.86c-6.5 0-8 1.5-11 4s-4.5 2-5 2.5 0 2 1 1.5 3-1.5 6-4 6-2.5 9-2.5c9 0 14 7.5 15 7s-5-8.5-15-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07-16.36c-6.5-7-18.5-7.5-23.5.5h2c5-8 17-4.5 18-1v1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: -9,
    r: 4.5,
    transform: "translate(-31.43 -7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.43-15.86c5 4.5 16 5 23.5-.5l-3.5-.5c-5 5.5-13 5-18 1v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57-13.86c-8.5 6.5-17 6-22 3s-5-4-4-4 2 1 6 3 10 2 20-2M-20.93 1.14a3 3 0 1 1-4 3c-.5 1-2.5 4-6.5 4h-1l1 1.5c1 0 4 0 6-1.5a4.5 4.5 0 1 0 4.5-7M-14.93 22.14c-4.5-3-6.5-7.5-11.5-7.5-1 0-3 .5-5 1.5h-1l1 1.5c2 0 5-2.5 8.5-.5s5.5 4 8 5M-16.43 22.14c-10-3-12-1-15-1h-1l1 2c4 0 6-3 15-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.93 22.14c-11-1-7.5 5.5-16.5 5.5h-1l1 1.5c11 0 6-6 16.5-7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 -93.57 2.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57-21.86c-11.5-10-26-11.5-34-4-5.8 7.77-5.29 16.9 1.5 26.5-.5 0-1.5.5-2 1-5.04-9.6-5.9-19.49-2.5-28.5 11-9 26-10 37 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.43-24.86c-6.5 0-8 1.5-11 4s-4.5 2-5 2.5 0 2 1 1.5 3-1.5 6-4 6-2.5 9-2.5c9 0 14 7.5 15 7s-5-8.5-15-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07-16.36c-6.5-7-18.5-7.5-23.5.5h2c5-8 17-4.5 18-1v1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: -9,
    r: 4.5,
    transform: "translate(-31.43 -7.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.43-15.86c5 4.5 16 5 23.5-.5l-3.5-.5c-5 5.5-13 5-18 1v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57-13.86c-8.5 6.5-17 6-22 3s-5-4-4-4 2 1 6 3 10 2 20-2M-20.93 1.14a3 3 0 1 1-4 3c-.5 1-2.5 4-6.5 4h-1l1 1.5c1 0 4 0 6-1.5a4.5 4.5 0 1 0 4.5-7M-14.93 22.14c-4.5-3-6.5-7.5-11.5-7.5-1 0-3 .5-5 1.5h-1l1 1.5c2 0 5-2.5 8.5-.5s5.5 4 8 5M-16.43 22.14c-10-3-12-1-15-1h-1l1 2c4 0 6-3 15-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.93 22.14c-11-1-7.5 5.5-16.5 5.5h-1l1 1.5c11 0 6-6 16.5-7"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 1.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.08 1010.9c13.59 1.21 27.74.35 39.85-3.7 11.06-4.1 23.17-7 35.28-6.2 0-1.62 3.52-2.87 1.48-4.1-4.5-2.47-10.07-2.02-15.63-4.5-9.08-3.7-14.58-10.34-23.66-14.9-1-.35-5-2.44-5-4.52 19.65 25.35 63.52 10.67 101.38 6.6 3.52.81 12.6-2.03 20.14-4.52 9.08-3.28 31.26-1.64 36.82-5.39.93-.35-9.57-6.16-11.61-7.83-5.5-6.18-19.15-4.92-26.2-11.56-11.06-11.14-27.68-14.03-41.4-23.15-3.02-1.63-9.08-.9-13.58-1.75-5.67-4.3-.29-4.32-43.5-36.27-38.62-13.85-36.77-25.36-60.72-33.36-8.53-3.7-16.44-10.55-23.48-8.46-12.6 3.7-39.7 18.12-51.82 25.57-10.07 6.19-22.59 17.12-31.17 24.16-2.26 1.85-28.31 24.56-58.13 41.57-29.82 17-73.03 40.38-76.8 40.78 68.44-5.49-60.65 20.65 247.75 31.52z",
    strokeLinecap: "round",
    transform: "matrix(.18472 .00617 -.00642 .19224 381.4 203.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.22 940.41c17.05-9.61 82.27-46.69 102.03-71.93-2.8.27 5.85 7.47 5.27 10.53 6.43-.43 2.89-7.04 8.23-7.47 4.12 0 7.08-1.72 10.61-3.06 4.12-.86 1.74 1.72 1.74 3.06-5.27 10.1-17.04 16.22-26.5 24.12 1.15.86 2.3 1.72 1.73 3.06 3.46.38 7.58.38 9.96-1.72.58-.43.58-1.77.58-2.63 3.54 1.3 2.31 3.92 1.16 5.7-2.31 5.26-12.35 4.78-15.31 9.61-3.47 5.21-7 9.62-12.35 13.6 4.11-3.5 8.8-7.9 14.15-8.34 8.24-.86 11.2-6.12 18.27-7.84 7.66-1.72 12.35-7.9 18.28-12.73-2.31 3.5-7.08 6.55-5.28 10.53a5.08 5.08 0 0 0 4.87.77c-5.28 7.03-16.06 12.34-19.6 20.66-3.54-1.29-5.85 1.3-8.23 1.72-3.47 1.3-2.31 6.56-4.7 8.33-9.96 5.7-14.73 14.93-18.84 22.77-.58.86-8.24 5.26-11.2 6.13-5.27 2.2-37.9 28.15-38.48 24.66-3.47-16.65-36.27 14.65-112.75-9M985.95 971.96c-.58-.65-1.73-.96-1.73-1.28 1.15-2.61-4.12-2.94-4.12-5.59 8.81 0 15.89 9.47 21.23 3.57 1.16-1.32-2.31-3.25 2.9-4.89 1.15-.28-1.16-1.28-.59-1.97-2.89 0-5.27.32-7.08-.28-2.3-.64-3.53-1.28-6.42-1.97-2.9-.64-4.12-3.57 0-4.57 7.65-1.33 15.89 3.57 21.8.64 4.7-2.29 9.4-2.93 14.09-4.57 2.31-.65 10.04-.28 7.65 1.92-1.73 1.33-5.85.97-8.23 1.6-4.11 1.3-7.65 3.26-11.77 4.9 2.89-.32 2.31 2.93 5.85 1.97 5.27-1.6 10.62-3.57 16.47-4.25-.58-1.29 1.15-2.3 1.15-3.62h1.73c-2.88-3.89 5.28-2.24 8.24-5.53 0 .64.5.64 1.15.96-4.11 1.6-2.3 4.21-3.46 6.22-.58.64-2.31.96-1.74 1.97 2.32 1.6 2.32-1.29 4.12-.64 1.73.32 4.12.96 5.27.64 2.89 0 5.85-1.29 4.05-3.62-2.32-1.92-4.7-3.57-4.7-6.18 0-.32-.58-.64-1.73-.96 4.7 0 8.23 1.33 9.96 3.25 2.32 1.97 2.9 4.9 6.5 5.58 7 .96 6.43-2.29 6.43-5.58 5.27.32 12.93 2.29 11.77 4.9-.5 1.93-4.69 3.57-8.8 3.93-2.9.28-1.16 2.29-2.9 2.61-3.46 0-7.65.64-8.8 1.97-1.16 1.96.57 5.86 2.88 7.18 3.47 1.6 10.55-.64 15.89 0 .5-2.93 4.12-3.89 7.08-5.9 3.46-1.92-1.74-3.57-4.7-4.9-2.3-.64-.57-1.28.58-2.92 1.73-1.93 7.08-.33 7.66-1.93 1.15-1.97-1.16-4.9 1.15-6.22 1.73-1.29 4.12.96 3.47 2.6 2.3-.27 2.89-1.6 5.27-1.92 2.89-.32 4.7 1.93 3.47 2.6-3.47 2.3-6.43 3.9-5.28 7.2 0 1.64-4.11 2.28-2.3 3.6 3.46 2.3 3.46 4.58 4.69 7.2 1.15 2.92 7.65 3.57 13.5 2.28-2.3-5.55 11.2-3.26 17.12-4.9.5 0 .5-.97 0-1.28-2.9-1.6-3.47-2.25-2.9-4.58 0-.28-1.08-.96-1.72-1.28 8.8 2.6 24.4 6.07 30.9 10.97-8.23 1.6-23.83-1.5-32.06.47-9.97 2.6-20 5.85-30.7 5.85-4.69 0-9.38-1.92-14.07-1.92m-94.97-2.6c1.15.27-2.89-.33-3.47-.66",
    transform: "matrix(.18472 .00617 -.00642 .19224 381.4 203.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.99 1017.33c16.35-1.41 19.33 10.72 29.7-.3 9.86 1.41 18.84-2.03 18.93-3.4 23.02 3.87 93.8-4.72 88.95-9.4-7.6-7.8-19.6-10.45-29.23-17.05-2.14-1.2-6.54-1.74-9.8-2.51-5.43-1.4-12.54.02-17.2-2.14-7.5-3.73-15.44-6.93-22.15-11.71-4.22-2.7-5.78-7.17-10.41-10.45-4.95-3.28-11.94-3.71-16.98-5.66-7.57-2.64-11.92-9.45-19.04-14.26-2.46-1.75-6.56-1.47-9.4-3.01-6.06-2.81-10.86-9.12-16.1-8.07-9.35 1.85-14.64 9.41-23.8 13.75-7.6 3.6-10.96 9.92-17.53 14.15-1.73 1.1-21.71 14.8-44.2 24.6-22.5 9.79-52.02 21.71-54.79 21.8 0 0 20.64 13.6 67.46 10.2l28.98 7.95 15.93-3.22s39.91-1.32 40.68-1.27z",
    transform: "matrix(.18472 .00617 -.00642 .19224 381.4 203.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.35 985.45c10.36-5.19 50.02-25.21 62-38.77-1.72.16 3.58 3.98 3.23 5.61 3.92-.24 1.74-3.77 5-4.01 2.51-.01 4.31-.94 6.46-1.67 2.51-.47 1.07.91 1.07 1.63-3.19 5.41-10.35 8.72-16.1 12.97.71.46 1.42.92 1.07 1.64 2.12.19 4.63.17 6.07-.95.35-.24.35-.95.35-1.41 2.16.68 1.42 2.09.72 3.04-1.4 2.82-7.52 2.6-9.3 5.18a28.96 28.96 0 0 1-7.5 7.3c2.5-1.87 5.35-4.24 8.6-4.49 5.02-.48 6.81-3.3 11.12-4.25 4.66-.94 7.5-4.26 11.1-6.86-1.4 1.87-4.29 3.53-3.18 5.65.36.22 1.77 1.4 3.22.9-3.2 3.78-10 6.14-12.14 10.6-2.16-.68-3.56.7-5.01.94-2.11.7-1.4 3.51-2.84 4.47-6.06 3.07-8.94 8.03-11.43 12.23-.35.46-5 2.84-6.8 3.31-3.22 1.2-23.04 15.17-23.4 13.3-2.16-8.89-21.4 4.95-68.08-7.45",
    transform: "matrix(.18472 .00617 -.00642 .19224 381.4 203.44)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M550 334.62c-28.32 0-51.28 25.83-51.28 57.69S521.68 450 550 450s51.28-25.84 51.28-57.7c0-31.86-22.96-57.7-51.28-57.7zm0 12.88c20.65 0 38.53 19.2 38.53 44.8 0 25.62-17.88 44.81-38.53 44.81-20.65 0-38.53-19.2-38.53-44.8 0-25.6 17.88-44.8 38.53-44.8z",
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      marker: "none",
      InkscapeFontSpecification: "Sans"
    },
    fontWeight: 400,
    color: "#000",
    fill: "#00a6de",
    stroke: "#000",
    strokeWidth: 0.19231499999999999,
    overflow: "visible",
    fontFamily: "Sans"
  }), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8a30e",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.87 24.41c.1 6.95-1.99 7.2-12.55 8.97-10.34 1.73-12.33 1.77-12.47-4.82-.1-6.95 2.2-7.23 12.54-8.97 9.78-1.63 12.33-2.48 12.48 4.82z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 24.02c.14 4.36-6.63 5.42-14.74 6.77-8.15 1.35-14.56 2.27-14.7-1.84-.18-4.36 6.58-5.42 14.73-6.77 8.12-1.35 14.53-2.7 14.7 1.84zM56.9 333.89c22.26-73.42 28.1-128.87-3.75-207.57 52.87-62.22 91.66-40.64 126.7 3.54-33.33 77.7-24.62 133.09-5.55 204.56-41.46 27.03-77.57 26.25-117.4-.53z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33 87.63c-1.1.03-2.2.07-3.3.17 3.7 89.26.58 177.8-.06 266.42 1.45.08 2.94.11 4.4.11-.26-89.18 3.93-175.53-.82-266.7h-.22z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36 88.55c-9.35 81.25-12.82 163.34-10.56 265.78 1.28 0 2.59 0 3.87-.03C118.13 253.2 121 171.04 129 89.43c-1.2-.32-2.44-.63-3.65-.88zM143.3 3.58c-9.4 12.75-14.57 12.65-9.86 32.42 10.38-8.72 10.1-15.94 9.85-32.42z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46 12.12c6.13 7.97 15.1 12.12 9.39 33.62-11.2-11.94-9.75-13.14-9.4-33.62zM120.54 34.09c8.12 7.26 15.56 8.78 10 27.53-7.13-10.49-10.2-9.6-10-27.53z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31 45.78c6.17 7.83 15.13 11.9 9.46 32.95-11.2-11.7-9.74-12.86-9.46-32.95z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.73 62.82c7.2 7.7 17.61 11.8 11.23 32.1-12.43-12.93-6.3-15.94-11.23-32.1z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.35 80.04c6.73 7.44 17.36 11.8 11.34 31.43-9.6-10.84-10.84-12.54-11.34-31.43zM149.5 21.54c-4.9 5.03-16.17 4.54-16.63 26.01 13.9-9.85 13.75-7.97 16.62-26z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75 36.81c-5.21 4.65-17.26 4.08-17.65 24.2 14.81-9.07 14.67-7.3 17.65-24.2z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.98 50.63c-5.39 5.04-17.86 4.43-18.29 26.15 15.35-9.81 15.17-7.93 18.29-26.15z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06 69.63c-5.67 2.58-18.93-2.56-19.03 24.37 11.34-3.72 10.56-11.9 19.03-24.37z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75 86.03c-7.9 4.08-12.37 3.26-13.82 24.91 11.44-9.53 11.3-7.76 13.82-24.9zM148.43 98.79c-19.99 70.62-24.2 137.48-22.22 254.87 1.63-.22 3.23-.46 4.86-.75-1-116.4 2.62-180.81 20.97-251.54-1.2-.92-2.4-1.77-3.61-2.58zM181.03 20.98c-11.41 9.95-16.44 8.5-15.24 28.98 11.7-5.74 12.65-12.86 15.24-28.98z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1 23.85c4.67 9.39 12.75 15.73 3.47 35.18-8.93-14.53-7.3-15.34-3.48-35.18z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.46 44.72c6.73 9.17 13.75 12.61 5.07 29.44-5.18-12.12-8.36-12.05-5.07-29.44z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28 55.52c4.68 9.25 12.8 15.56 3.58 34.55-8.97-14.31-7.34-15.1-3.58-34.55z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 71.15c5.74 9.39 15.27 16.12 5.52 34.2-9.99-15.85-3.43-17.16-5.52-34.2z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.47 87.56c5.39 9 15.03 16.05 5.74 33.59-7.54-13.11-8.47-15.1-5.74-33.6zM184.04 40.11c-5.67 3.61-16.65.18-20.8 20.94 15.3-5.92 14.85-4.14 20.8-20.94z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67 54.78c-5.91 3.15-17.64-.6-21.47 18.92 16.09-4.92 15.63-3.3 21.47-18.92z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.56 67.75c-6.16 3.47-18.28-.36-22.46 20.66 16.76-5.53 16.26-3.76 22.46-20.66z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38 86c-6.02 1.02-18.1-7.44-22.85 18.74 11.76-.67 12.4-8.82 22.85-18.74z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35 100.31c-8.44 1.88-12.69-.07-17.83 20.59 12.9-6.24 12.44-4.57 17.83-20.59zM167.17 115.16c-25.97 64.2-31.5 122.99-18.56 232.69 1.87-.71 3.79-1.53 5.7-2.38-12.86-104.74-7.8-163.38 16.05-226.88-1.06-1.2-2.12-2.33-3.19-3.43zM210.5 38.34c-12.4 8-17.25 5.77-18.2 26.22 12.22-3.83 13.96-10.7 18.2-26.22z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4 37.63c3.65 10.03 11.02 17.65-.25 35.36-7.37-15.8-5.67-16.33.25-35.36z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6 57.4c5.7 10.17 12.33 14.67 1.95 29.9-3.86-12.78-7.05-13.2-1.95-29.9z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.29 67.43c3.72 9.88 11.09 17.43-.04 34.72-7.4-15.59-5.7-16.08.04-34.72z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 81.85c4.72 10.2 13.47 18.35 1.88 34.69-8.25-17.26-1.6-17.54-1.88-34.69z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.22 97.37c4.4 9.78 13.25 18.28 2.16 34.12-6.1-14.14-6.8-16.26-2.16-34.12zM211.46 57.76c-5.98 2.62-16.54-2.52-22.85 17.36 15.84-3.4 15.2-1.74 22.85-17.36z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61 71.72c-6.2 2.16-17.5-3.4-23.35 15.23 16.51-2.26 15.9-.7 23.35-15.23z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.15 83.87c-6.48 2.44-18.14-3.3-24.48 16.83 17.22-2.8 16.55-1.1 24.48-16.83z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1 101.23c-6.1.07-17.23-10.24-24.7 14.88 11.76 1.24 13.25-6.73 24.7-14.88z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6 113.95c-8.6.53-12.6-2.05-19.87 17.54 13.46-4.14 12.83-2.51 19.88-17.54zM101.37 89.86c-1.17.35-2.37.78-3.57 1.2 8.57 81.29 14.06 163.35 13 263.1 1.1.06 2.2.14 3.3.14 2.83-101.77-2.95-183.34-12.73-264.44zM83.34 1.91c9.32 13.26 14.5 13.43 9.67 33-10.34-9.33-10.03-16.56-9.67-33z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14 11.59c-6.2 7.65-15.2 11.3-9.6 33.13 11.23-11.3 9.81-12.62 9.6-33.13z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 33.66c-8.18 6.8-15.62 7.94-10.16 27 7.2-10.13 10.24-9.03 10.17-27z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.07 45.5c-6.2 7.5-15.2 11.05-9.67 32.42 11.3-11.06 9.85-12.33 9.67-32.42z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54 62.72c-7.23 7.33-17.68 10.84-11.4 31.5 12.5-12.23 6.37-15.6 11.4-31.5z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82 80.04c-6.8 7.05-17.43 10.81-11.52 30.8 9.64-10.35 10.88-11.98 11.52-30.8zM77.03 19.52c4.86 5.28 16.12 5.46 16.48 26.93C79.65 35.82 79.8 37.7 77.03 19.52z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67 34.83c5.17 4.93 17.26 5.03 17.5 25.16-14.77-9.85-14.6-8.12-17.5-25.16z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.37 48.72c5.35 5.35 17.82 5.46 18.14 27.21-15.27-10.7-15.13-8.82-18.14-27.21z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19 67.78c5.66 2.9 18.92-1.48 18.88 25.44-11.34-4.35-10.49-12.5-18.88-25.44z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39 84.54c7.9 4.5 12.33 3.97 13.67 25.66-11.4-10.14-11.26-8.37-13.67-25.66zM79.37 101.2c-1.17.85-2.34 1.77-3.54 2.73 18.5 70.12 25.3 134.96 23.67 248.77 1.41.28 2.87.53 4.28.74 2.63-115.12-4.46-182.01-24.41-252.24zM45.5 17.22c11.37 10.56 16.4 9.39 15.1 29.84-11.67-6.45-12.62-13.61-15.1-29.84z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.43 21.26c-4.71 9.14-12.86 15.06-3.69 35 9.04-14.02 7.41-14.91 3.69-35z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92 42.45c-6.77 8.82-13.82 11.87-5.24 29.16 5.24-11.8 8.43-11.55 5.24-29.16z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07 53.5c-4.75 9-12.9 14.85-3.83 34.34 9.07-13.82 7.44-14.67 3.83-34.34z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 69.48c-5.77 9.08-15.33 15.28-5.7 33.88 10.07-15.27 3.55-16.94 5.7-33.88z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.63 86.14c-5.39 8.71-15.1 15.2-5.92 33.23 7.62-12.65 8.54-14.56 5.92-33.23zM42.41 36.18c5.64 3.9 16.62 1.1 20.66 22.07-15.3-6.77-14.85-5-20.66-22.07z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.67 51.02c5.89 3.48 17.65.4 21.33 20.1-16.05-5.82-15.62-4.15-21.33-20.1z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68 64.2C55.8 68.03 68 64.88 72 86.14c-16.69-6.49-16.23-4.68-22.32-21.94z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75 82.67c6.03 1.38 18.18-6.42 22.75 20.02-11.76-1.32-12.33-9.5-22.75-20.02zM62.68 97.48c8.43 2.37 12.69.67 17.72 21.61-12.86-6.98-12.4-5.24-17.72-21.61zM60.9 117.67c-.95 1-1.9 2.02-2.86 3.09 23.5 65.09 27.32 120.86 19.66 224.57l1.07.74c1.24.54 2.44 1.07 3.68 1.56 8.72-105.2 4.43-162.1-21.54-229.96zM15.94 32.92c12.34 8.68 17.23 6.7 18.04 27.25-12.19-4.54-13.89-11.52-18.04-27.25z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06 33.45c-3.73 9.81-11.13 17 .03 35.36 7.44-15.38 5.74-16.01-.03-35.36z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7 53.61c-5.77 9.85-12.43 14.03-2.12 29.83 3.97-12.57 7.12-12.82 2.13-29.83z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.95 63.96c-3.75 9.67-11.2 16.8-.17 34.72 7.54-15.16 5.84-15.77.17-34.72z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.93 78.84c-4.79 9.92-13.58 17.6-2.1 34.58 8.37-16.8 1.7-17.43 2.1-34.58z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.84 94.68c-4.43 9.53-13.36 17.54-2.37 34.01 6.2-13.82 6.9-15.87 2.37-34.01zM14.85 52.26c5.98 2.98 16.58-1.56 22.74 18.64-15.83-4.29-15.16-2.59-22.74-18.64z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63 66.47c6.2 2.52 17.5-2.4 23.24 16.59-16.5-3.23-15.87-1.63-23.24-16.59z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.02 78.94c6.44 2.84 18.14-2.26 24.37 18.22-17.22-3.76-16.54-2.02-24.37-18.22z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.97 96.66c6.1.4 17.29-9.28 24.59 16.27-11.76.56-13.22-7.48-24.6-16.27z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35 109.95c8.61 1.03 12.61-1.35 19.8 18.64-13.46-4.86-12.85-3.23-19.8-18.64zM102.3.53c8.71 13.9 13.85 14.42 8.14 33.56-9.88-10-9.24-17.19-8.14-33.56z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63 11.66c-6.52 7.19-15.7 10.17-11.09 32.31 11.77-10.49 10.39-11.87 11.1-32.31z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41 33.77c-8.47 6.23-15.98 6.84-11.37 26.22 7.62-9.6 10.63-8.3 11.37-26.22z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 45.7c-6.51 7.06-15.65 10-11.08 31.69C125.68 67.15 124.3 65.76 125 45.7z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74 63.14c-7.59 6.8-18.18 9.57-12.87 30.62 13.08-11.34 7.1-15.13 12.87-30.62z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23 80.5c-7.12 6.56-17.93 9.6-12.93 29.9 10.1-9.63 11.44-11.15 12.93-29.9zM95.17 17.68c4.64 5.6 15.88 6.52 15.27 28-13.35-11.56-13.28-9.68-15.27-28z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.14 32.99c4.96 5.28 17 6.2 16.37 26.29-14.32-10.88-14.25-9.1-16.37-26.3zM96.2 46.95c5.1 5.7 17.58 6.66 16.9 28.38-14.77-11.73-14.74-9.81-16.9-28.38z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13 66.01c5.56 3.3 19-.18 17.75 26.68-11.12-5.13-9.92-13.18-17.75-26.68z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59 83.16c7.69 5.07 12.15 4.82 12.5 26.54-10.94-10.91-10.87-9.14-12.5-26.54zM91.1 94a69.62 69.62 0 0 0-3.9 2.1c16.37 82.52 20.2 158.7 18.78 257.66.46.04.92.07 1.38.15l1.88-.43c2.37-88.3 0-174.58-18.14-259.48zM63.14 11.59c10.8 11.44 15.91 10.66 13.54 30.93-11.34-7.33-11.87-14.53-13.54-30.93z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.83 17.36c-5.18 8.75-13.61 14-5.5 34.62 9.75-13.29 8.19-14.31 5.5-34.62z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26 38.94c-7.23 8.26-14.46 10.74-6.77 28.63 5.84-11.37 9-10.84 6.77-28.63z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8 50.28c-5.2 8.57-13.64 13.75-5.6 33.9 9.78-13.03 8.19-14.02 5.6-33.9z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33 66.72c-6.27 8.58-16.13 14-7.48 33.3 10.88-14.41 4.43-16.65 7.48-33.3z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7 83.62c-5.89 8.26-15.92 13.96-7.66 32.67 8.26-12.01 9.28-13.85 7.65-32.67zM59.07 30.26c5.42 4.32 16.54 2.4 19.49 23.63-14.92-7.97-14.57-6.13-19.5-23.63z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55 45.28c5.7 3.94 17.6 1.81 20.3 21.76-15.77-7.09-15.41-5.39-20.3-21.76z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.91 58.75c5.92 4.32 18.22 2.12 21.16 23.63-16.37-7.8-15.98-5.95-21.16-23.63z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 77.5c5.95 1.83 18.5-4.97 21.72 21.75C78.02 97.02 77.85 88.8 68 77.49z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15 92.98c8.32 3 12.65 1.66 16.58 22.92-12.47-7.97-12.12-6.23-16.58-22.92zM54.64 124.58c-.5.57-1 1.14-1.49 1.74 19.38 47.94 24.84 87.24 21.08 127.24v.07c-.7 26.18-3.93 54.35-9.35 85.29 1.38.81 2.76 1.56 4.1 2.3l.79.28c15.27-88.54 13.82-153.95-15.13-216.92z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.11 107.86c-1.2 1.06-2.44 2.16-3.65 3.3C89.65 184.28 92.7 251.71 89.5 350.03l2.94 1 1.28.31c4.22-100.06 1.49-170-22.6-243.5zM31 24.98c12.05 9.35 16.98 7.65 17.08 28.17C36.04 47.98 34.62 40.93 31 24.98z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08 26.72c-4.04 9.6-11.73 16.4-1.2 35.32 8-14.95 6.3-15.66 1.2-35.32z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.06 47.3c-6.13 9.5-12.93 13.3-3.23 29.63 4.43-12.34 7.59-12.4 3.23-29.63z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.91 57.86c-4.1 9.46-11.8 16.2-1.41 34.7 8.07-14.75 6.4-15.46 1.41-34.7z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.35 73.17c-5.13 9.64-14.2 16.83-3.33 34.4 8.97-16.3 2.34-17.32 3.33-34.4z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7 89.33c-4.78 9.24-13.96 16.76-3.57 33.8 6.7-13.46 7.47-15.48 3.57-33.8zM29.23 44.26c5.88 3.3 16.62-.68 22.08 19.84-15.66-5.17-15.1-3.4-22.08-19.84z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52 58.71c6.1 2.84 17.57-1.49 22.64 17.79-16.4-4.11-15.84-2.48-22.64-17.79z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.44 71.43c6.35 3.2 18.25-1.27 23.75 19.53-17.08-4.72-16.48-2.94-23.75-19.53z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76 89.47c6.1.7 17.61-8.36 24.02 17.54-11.8-.07-12.93-8.19-24.02-17.54z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68 103.29c8.58 1.49 12.65-.68 19.13 19.66-13.28-5.6-12.72-3.93-19.13-19.66zM.5 46.7c13.14 6.66 17.71 3.93 20.69 24.2C8.65 68.35 6.27 61.7.49 46.7z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.43 43.69c-2.66 10.38-9.25 18.7 3.72 35.18 5.78-16.5 4-16.86-3.72-35.18z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14 62.54c-4.71 10.7-10.84 15.9.99 29.98 2.59-13.15 5.7-13.9-1-29.98z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.37 71.96c-2.69 10.24-9.28 18.5 3.48 34.55 5.84-16.3 4.1-16.62-3.48-34.55z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.83 85.46c-3.68 10.67-11.58 19.7 1.53 34.73 6.52-18.04-.1-17.61-1.53-34.73z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35 100.31c-3.4 10.17-11.38 19.56 1.2 34.16 4.68-14.7 5.17-16.87-1.2-34.16zM1.45 66.08C7.7 68.1 17.68 61.9 25.9 81c-16.12-1.74-15.27-.14-24.45-14.92z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 79.48c6.38 1.52 17.04-5.21 24.7 12.75-16.66-.56-15.88.96-24.7-12.75z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 91.03c6.7 1.77 17.75-5.18 26.04 14.2-17.43-.99-16.58.6-26.04-14.2z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.04 107.68c6.06-.6 16.12-11.98 26.04 12.23-11.58 2.44-13.85-5.32-26.04-12.23z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 119.23c8.6-.35 12.33-3.36 21.54 15.38-13.82-2.7-13.04-1.17-21.54-15.38zM139.6 93.54c-18.84 84.51-21.5 171.89-19.66 260.68a60.2 60.2 0 0 0 4.36-.35c-.78-99.92 2.4-175.93 19.24-258.2a71.26 71.26 0 0 0-3.93-2.13zM167.56 14.5c-10.87 10.83-15.94 9.77-13.71 30.18 11.37-6.7 11.98-13.89 13.71-30.19z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.84 19.06c5.14 9.04 13.54 14.74 5.28 34.9-9.67-13.81-8.08-14.74-5.28-34.9z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3 40.4c7.2 8.64 14.4 11.5 6.6 28.98-5.81-11.66-8.97-11.34-6.6-28.99z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7 51.52c5.13 8.86 13.56 14.53 5.38 34.23-9.71-13.6-8.12-14.5-5.39-34.23z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06 67.64c6.2 8.93 16.05 14.88 7.26 33.73-10.77-15.02-4.32-16.86-7.26-33.73z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 84.37c5.78 8.6 15.8 14.84 7.44 33.1-8.18-12.48-9.21-14.4-7.44-33.1zM171.53 33.38c-5.46 4.04-16.55 1.49-19.63 22.57 14.99-7.16 14.6-5.35 19.63-22.57z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94 48.3c-5.7 3.6-17.6.81-20.4 20.58 15.8-6.2 15.4-4.5 20.4-20.58z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54 61.58c-5.95 3.94-18.24 1.07-21.33 22.43 16.4-6.87 16.02-5.07 21.33-22.43z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32 80.11c-5.95 1.53-18.46-5.98-21.83 20.56 11.7-1.6 11.9-9.78 21.83-20.56z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06 95.14c-8.32 2.58-12.65.95-16.72 22 12.54-7.26 12.19-5.56 16.72-22zM159.34 107.47c-25.97 72.46-29.44 142.51-23.38 244.38 1.95-.5 3.9-1.03 5.84-1.63-6.7-103.04-3.36-168.98 20.73-239.78a122.43 122.43 0 0 0-3.19-2.97zM199.63 29.7c-12.12 8.67-17 6.69-17.26 27.2 12.09-4.5 13.54-11.47 17.26-27.2z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52 30.19c4 9.85 11.66 17.04 1.03 35.4-7.9-15.42-6.24-16.05-1.03-35.4z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.47 50.39c6.06 9.85 12.83 14 3.01 29.8-4.32-12.58-7.51-12.83-3.01-29.8z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5 60.7c4.05 9.67 11.7 16.8 1.21 34.72-7.97-15.2-6.27-15.77-1.2-34.72z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 75.54c5.06 9.96 14.1 17.65 3.11 34.59-8.85-16.8-2.23-17.44-3.11-34.59z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.54 91.42c4.71 9.53 13.85 17.54 3.37 33.98-6.6-13.82-7.37-15.88-3.37-33.98zM201.26 49.04c-5.88 2.98-16.58-1.6-22.18 18.6 15.7-4.25 15.1-2.55 22.18-18.6z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9 63.28c-6.1 2.48-17.54-2.48-22.75 16.52 16.44-3.2 15.84-1.6 22.75-16.52z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9 75.72c-6.37 2.8-18.2-2.27-23.84 18.18 17.11-3.72 16.48-2.02 23.85-18.18z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48 93.44c-6.09.39-17.57-9.32-24.13 16.23 11.8.56 13-7.48 24.13-16.23z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 106.72c-8.58 1-12.7-1.38-19.25 18.6 13.29-4.85 12.72-3.22 19.24-18.6zM176.92 126.18c-30.33 65.62-27.75 135.42-15.24 215.68 1.56-.82 3.08-1.67 4.68-2.55-5.35-34.7-8.79-66.51-8.68-96.66v-.18c-1.56-35.04 4.14-70.55 22.21-112.6-.99-1.25-1.98-2.49-2.97-3.7zM230 53.11c-13.19 5.92-17.76 2.95-20.84 23.04 12.54-1.85 14.99-8.4 20.84-23.04z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1 48.9c2.59 10.49 9.1 19.17-3.97 34.93-5.63-16.83-3.9-17.07 3.97-34.93z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28 67.18c4.61 10.95 10.74 16.51-1.2 29.9-2.52-13.28-5.6-14.2 1.2-29.9z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94 76.25c2.66 10.38 9.21 19-3.65 34.37-5.77-16.62-4-16.86 3.65-34.37z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.44 89.22c3.62 10.84 11.45 20.34-1.77 34.62-6.37-18.36.25-17.58 1.77-34.62z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.83 103.64c3.33 10.35 11.26 20.2-1.42 34.09-4.6-14.95-5.07-17.15 1.42-34.09zM228.93 72.46c-6.23 1.63-16.19-5.1-24.55 13.54 16.12-.85 15.3.7 24.55-13.54z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63 85.46c-6.38 1.17-17.01-6.13-24.8 11.41 16.68.36 15.87 1.81 24.8-11.4z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93 96.66c-6.7 1.38-17.68-6.16-26.12 12.76 17.44-.04 16.59 1.52 26.12-12.76z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1 112.85c-6.06-.92-16.05-12.86-26.12 10.81 11.56 3.08 13.9-4.57 26.12-10.8z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.33 123.77c-8.6-.85-12.3-4.08-21.61 14.17 13.85-1.95 13.08-.46 21.61-14.17zM98.79 218.16l31.85.89c19.28.53 34.76 5.95 34.73 12.19 0 6.2-15.52 10.77-34.8 10.24l-31.85-.89c-19.28-.53-34.76-5.95-34.73-12.19.04-6.2 15.52-10.8 34.8-10.24z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.71 217.52l-9.53 19.78a7.88 7.88 0 0 0 5.46 2.58l5.74.14 10.7-22.14-12.37-.36zm24.8.71l-10.66 22.15 12.33.35 10.7-22.18-12.36-.32zm24.84.68l-10.7 22.14 12.33.36 10.7-22.15-12.33-.35zm24.8.7l-10.7 22.15 12.37.35 9.4-19.48a8.07 8.07 0 0 0-5.75-2.87l-5.31-.15z",
    transform: "matrix(.05586 0 0 .0453 549.9 415.76)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 3.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-123.18 1511.6c.24-.04 3 43.37 6.39 64.53.41 2.59 3.55 4.1 4.25 6.62.76 2.73-.2 5.67-.24 8.5 0 .32.05.64 0 .95-.55 3.9-4 7.47-3.3 11.35.39 2.22 3.14 3.36 4.01 5.44 5.1 12.06 4.04 26.47 6.39 38.76.98 5.18-.95-1 8.27 13.7.92 1.49 4.96 1.66 4.96 1.66l4.02.24 3.76 3.88-5.69 5.18-17.55 1.67-7.85-5.01s2.48-4.25 1-6.35c-1.06-1.51-4.83-.5-5.01-2.34-.33-3.37-.7-12.53-.84-12.54-.3-.01-.15-.6-.33-.83 0 0-12.78-14.68-17.22-23.24-2.3-4.42-2.14-9.91-4.68-14.2-1.62-2.75-5.22-4.1-6.52-7.02-10.75-24.3-21.52-71.13-21.56-70.87M-333.8 1500.42l45.3 11.33-18.01 62.89c-9.69 19.86-8.98 20.58-6.88 26.27 4.41 10.93 7.1 27.28 23.61 53.25 5.98 6.62 12.87 7.4 15.19 10.1.97 2.83 6.14 7.1 10.65 8.88h14.52c2.69-3.22 2.63-2.15 3.46-4.6-.81-2.96-7.8-1.94-12.33-6.02-1.93-7.7-11.72-19.56-12.56-27.67-4.45-17.72-2.74-18.24.12-36.2 1.43-9.26 11.11-29.68 14.98-40.79 7.8-11.86 16.29-32.53 16.48-47.46l-16.39-41.7-10.2-16.98M-307.15 1424.29c-75.62 20.37-49.75 84.64-28.89 85.87M-80.85 1319.76l12.9-22.82 1.45-8.42-.9-1.78-21.49 21.78-.37 1.45",
    transform: "matrix(.06022 -.00163 .00525 .06438 544.07 322.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.13 1358.04c4.58 1.77 10.4 3.54 11.67.94 1.58-3.21 2.36-5.48-1.03-8.1-1.63-1.46 1.23-3.65-.47-7.8-12.2-8.8-21.06-9.24-23.65-16.07l-.1-4.68c-.14-5.93-18.51-8.84-22.78-11.85 0 0-7.51-3.84-11.6-4.78-1.74-.4-5.37-.34-5.37-.34-18.85-.65-29.12 17.69-33.25 28.9 0 0-8.2 51.38-19.4 74.44-1.03 2.1-2.52 4-4.25 5.56-1.69 1.53-3.56 3.8-5.82 3.6-51.97-4.69-87.39-7.79-108.68-7.6-21.3.2-46.9 14.99-48.54 16.63 0 0-24.88 13.89-32.12 37.4-2.42 7.86-1.16 17.23 1.34 26.6 18.07 63.04 46.7.95 55.06 1.9l10.29 1.18c12.07 1.37 31.42 36.92 64.99 44.77 101.33 23.72 134.01-26.04 141.59-138.26l1.39-1.59v-3.82l6.03-8.8.1-12.44-1.35-5.93.39-2.3 29.37-2.77 5.19-2.04",
    transform: "matrix(.06022 -.00163 .00525 .06438 544.07 322.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88.42 1324.95l14.75-26.12 1.66-9.63-1.02-2.04-24.6 24.93-.42 1.65M-345.18 1490.89c4.99 18.68 15.28 37.39 13.85 44.19-2.16 10.2-8.71 14.76-9.25 15.72-.5.87-2.9 2.12-3.7 2.75-3.4 2.68-5.99 8.22-7.77 12.18-2.2 4.9-3.57 9.28-3.4 14.13.61 18 8.4 55.14 8.93 55.69 0 0 5.94 3.6 7.44 7.06 1.52 3.51.62 6.84.06 10.62-.77 5.2-4.9 16.72-4.9 16.72s.04 2.26.68 2.94c1.8 1.91 8.19 5.31 8.19 5.31h14s-7.15-7.55-7.6-9.22c-.49-1.85-.68-3.27.04-5.34 1.32-3.83 5.66-8.3 7.15-10.56 1.6-2.44.66-8.94.66-8.94.06-2.37-1.88-3.5-1.94-4.5-.48-7.79-.5-13.4-.19-21.13.28-6.81 3.28-27.18 3.28-27.18s3.55-2.55 5-4.16c1.33-1.46 3.32-4.9 3.32-4.9s17.68-8.67 25.47-14.6c9.23-7.03 24.71-24.5 24.71-24.5s4.64-7.13 5.6-11.19c.32-1.38.2-2.85 0-4.25a83.82 83.82 0 0 0-6.69-22.1c-3.07-6.8-6.77-13.49-11.81-19-.52-.56-1.85-1.37-1.85-1.37M-126.06 1534.25c-14.59 8.23-47.98 14.46-49.05 20.64 0 0-4.35 38.84-10.44 54.23-2.4 6.06-5.65 7.77-8.58 13.6-3.05 6.06-3.3 10.75-6.02 16.8-2.9 6.46-7.6 12.2-9.2 23.5l-.47 9.4 9.57 5.83-10.71 3.06-15.79-6.5-.1-14.35 4.88-14.74.39-2.39-3.26-9.09.2-32.34 4.87-24 4.12-88.7M-83.29 1362.83c6.11 5.1 14.47 8.51 34.7 3.02 3.58 2.35 7.34 5.27 16.7-5.37M-39.67 1347.53c.13-.13 3.6 2.47 4.95 2.5 1.06.03 2.56-1.96 1.75-2.65-.88-.75-2.56-1.62-3.45-1.1-1.29.75-3.23 1.47-3.25 1.25z",
    transform: "matrix(.06022 -.00163 .00525 .06438 544.07 322.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.53 408.47s.1 0 .15.1c.14.31.48.36.76.03.03-.04.11-.1.12-.1-.05 0-.09 0-.13-.05-.3-.3-.62-.04-.72-.02l-.18.04z",
    fill: "#000",
    stroke: "none"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#e3e4e5",
    strokeWidth: 0.42
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e7e7e7",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.27 426.42c-.09.47-.08.84-.02 1.17-.09.42-.1.83-.02 1.17-.07.37-.09.74-.02 1.11-.07.37-.07.73-.02 1.06.39.3 1.48.33 1.97.06.06-.33.06-.74 0-1.1.07-.37.06-.75-.01-1.12.07-.34.07-.75 0-1.17.06-.32.07-.7-.01-1.17a3.5 3.5 0 0 0-.01-1.2c.06-.37.06-.76-.01-1.17.07-.36.06-.76-.01-1.22a4.1 4.1 0 0 0 0-1.23c.06-.43.05-.84-.02-1.23a3.8 3.8 0 0 0 0-1.23c.06-.35.06-.75-.02-1.22.1-.38.07-.86 0-1.23.06-.45.05-.85-.01-1.23.06-.4.06-.81-.01-1.22.05-.4.04-.81-.01-1.23.05-.4.04-.8-.01-1.22.04-.37.04-.77-.02-1.23.06-.38.07-.8 0-1.23.06-.4.05-.81-.01-1.23.05-.38.06-.78-.02-1.22a3.6 3.6 0 0 0-.01-1.2c.05-.4.05-.7 0-1.1.01-.13 0-.36-.01-.48l-1.23-.02c-.06.08-.07.25-.04.48-.06.18-.06.94.01 1.12a3.6 3.6 0 0 0-.02 1.2c-.08.43-.09.84-.03 1.22-.07.41-.08.82-.03 1.22-.08.44-.07.85-.02 1.24-.07.45-.07.85-.03 1.22-.06.42-.08.81-.03 1.22-.06.42-.07.83-.02 1.23-.08.41-.09.82-.03 1.23-.07.37-.08.77-.02 1.21-.08.38-.12.86-.03 1.24-.08.47-.09.87-.02 1.23a3.8 3.8 0 0 0-.03 1.22c-.07.4-.08.8-.02 1.23-.08.47-.08.87-.03 1.24-.08.45-.08.85-.02 1.2-.08.42-.08.8-.02 1.17-.09.45-.09.85-.03 1.2z",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.26 427.57c.45.21 1.61.18 1.88.04M564.25 426.4c.43.19 1.47.18 1.89.04M564.3 425.18c.42.21 1.42.16 1.83.04M564.33 424.02a3.3 3.3 0 0 0 1.79.04M564.35 422.83c.5.14 1.38.14 1.76 0M564.37 421.6c.52.13 1.32.13 1.73.01M564.4 420.37c.47.12 1.37.12 1.7 0M564.42 419.15c.4.13 1.27.12 1.66 0M564.46 417.93c.52.12 1.24.13 1.61 0M564.48 416.69c.53.12 1.28.1 1.59 0M564.5 415.47a4.3 4.3 0 0 0 1.56 0M564.53 414.28c.49.09 1.3.04 1.52-.03M564.55 413.01c.48.13 1.28.07 1.49 0M564.59 411.82c.45.12 1.17.07 1.44-.03M564.62 410.57c.45.1 1.2.07 1.4 0M564.64 409.35c.45.09 1.18.05 1.37-.01M564.68 408.13a4.5 4.5 0 0 0 1.3-.01M564.71 406.88c.4.08 1.08.08 1.26.02M564.74 405.68c.44.07 1.05.07 1.23.01M564.7 404.57c.32.04 1.13.06 1.27.02M564.23 428.73c.47.21 1.64.18 1.92.04M564.21 429.84c.47.21 1.66.18 1.94.04",
    strokeLinejoin: "round",
    strokeWidth: 0.1907934
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#e7e7e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.98 401.68c.75-.17 1.82-.19 3.3-.23a21.4 21.4 0 0 0-1.34-.4c.86-.12 2.92-.1 3.45-.1a7.7 7.7 0 0 0-1.48-.61c1.13-.2 2.48-.01 3.44.14-.45-.25-.95-.57-1.59-.74 1.36-.1 1.9.01 3.16.18a4.09 4.09 0 0 0-1.38-.75 12.6 12.6 0 0 1 3.84-.22c-4.27-1.96-9.47-.94-12.59 1.21.31-.49.99-1.23 1.65-1.8a3.94 3.94 0 0 0-1.08.07 6.44 6.44 0 0 1 1.9-1.4 4.58 4.58 0 0 0-1.17.04 10.4 10.4 0 0 1 2.17-1.47 4.86 4.86 0 0 0-1.31.03 8.08 8.08 0 0 1 2.49-1.8c-.59-.02-.95 0-1.47.1.75-.67 1.74-1.39 3.05-2.05-5.19.58-8.05 4.32-8.3 7.5-1.38-2.99-5.14-5.84-10.33-5.62 1.55.47 2.78 1.04 3.74 1.63-.58-.03-.96.01-1.58.11 1.06.3 2.3.86 3.08 1.47-.47-.01-.94.07-1.39.18.87.27 1.92.71 2.66 1.17-.42-.02-.8.05-1.24.14.67.15 1.75.7 2.36 1.14-.47 0-.81.04-1.16.12 1.56.6 1.66.88 2 1.09-3.23-.7-7.9.37-11.5 4.55.52-.44 2.75-1.27 3.45-1.46-.36.44-.5.67-.78 1.23.8-.66 2.03-1.2 3.2-1.66a7.5 7.5 0 0 0-.64 1.16c.85-.52 1.1-.6 2.84-1.42-.13.21-.47.67-.64 1.1.53-.3 1.8-.75 2.65-1.06.06-.02-.51.47-.77 1.06l1.42-.52c-2.74 1.91-4.78 5.12-4.36 9.02.16-.61.88-2.36 1.29-3.06-.05.46.06 1.23.14 1.58.4-1.17.85-2.1 1.51-3.1-.05.62-.04 1.3.05 1.59.37-.87.66-1.6 1.56-3.2-.06.24-.07.91-.02 1.5.3-.65 1-1.95 1.68-2.9-.03.35-.1.95-.07 1.2.07-.13.28-.49.53-.88.4-.61.87-1.33 1.02-1.44.12.12.23.26.34.43.42.69.73 1.73.82 2.81.23-.53.33-1.07.36-1.36a12.94 12.94 0 0 1 1.07 3.73c.16-.5.25-.81.3-1.59.51.81.95 2.81 1 3.68.2-.34.35-.76.47-1.4.5 1.12.7 2.51.81 3.47 1.27-4.62-.55-7.61-2.77-9.9.56.31 1.26.93 1.95 1.68a7.62 7.62 0 0 0-.4-1.36 22.6 22.6 0 0 1 2.36 2.13c-.05-.45-.12-.7-.36-1.28.97.67 1.83 1.82 2.33 2.46-.04-.3-.12-.84-.32-1.47a9.44 9.44 0 0 1 2.16 2.73c0-.5-.15-1.05-.27-1.6 1.2 1.01 1.65 2.09 2.03 2.74 0-4.18-4.82-7.93-9.32-8.32z",
    fill: "#007934",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.12 401.72c4.9-.7 11.19 3.52 11.18 8.28-.38-.65-.83-1.73-2.03-2.75.12.56.26 1.1.27 1.61a9.43 9.43 0 0 0-2.16-2.73c.2.63.28 1.18.32 1.47-.5-.64-1.36-1.79-2.33-2.46.24.58.3.83.36 1.28a22.53 22.53 0 0 0-2.37-2.13c.16.35.35 1.01.41 1.36a8.67 8.67 0 0 0-1.95-1.67M565.03 401.66c-2.93-1.89-9.16-1.55-13.67 3.7.52-.44 2.75-1.27 3.45-1.46-.36.44-.5.67-.78 1.23.8-.66 2.03-1.2 3.2-1.66-.25.37-.52.86-.64 1.16.84-.52 1.1-.6 2.84-1.42-.13.21-.47.67-.64 1.1.53-.3 1.8-.75 2.65-1.06.06-.02-.52.47-.77 1.06l1.42-.52",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.22 400.91c-.62-3.44-4.75-7.4-10.83-7.15 1.55.47 2.78 1.04 3.74 1.63-.58-.03-.96.01-1.58.11 1.06.3 2.3.86 3.08 1.47-.47-.01-.94.07-1.39.18.87.27 1.92.71 2.66 1.17-.42-.02-.8.05-1.24.14.67.15 1.75.7 2.36 1.14a4.3 4.3 0 0 0-1.16.12c1.56.6 1.66.88 2 1.09M565.18 402.28c-4.07 1.24-8.01 5.25-7.45 10.53.16-.61.88-2.36 1.29-3.06-.05.46.06 1.23.14 1.58.4-1.17.85-2.1 1.51-3.1-.05.62-.04 1.3.05 1.59.37-.87.66-1.6 1.56-3.2-.06.24-.07.91-.02 1.5.3-.65 1-1.95 1.68-2.9-.03.35-.1.95-.07 1.2.18-.33 1.3-2.13 1.55-2.32M562.89 404.35c-.29.8-.52 1.67-.61 2.27M561.4 405.37c-.28.72-.62 2.02-.73 2.85M559.9 406.8c-.4.91-.77 2.24-.88 2.95",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M565.42 404.1l.02-.95",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.64 408.2c.13.75.19 1.14.14 2.2M568.1 405.63c.15.83.22 1.38.22 2.5M566.65 403.96c.18.52.29 1.18.29 2.02M574.36 405.37c.54.7.8 1.48.9 1.88M572.15 403.84a7.98 7.98 0 0 1 1.23 2.29M570.3 403.22c.46.6.77 1.23 1.07 1.92M554.81 403.9a7.29 7.29 0 0 1 2.7-1.87M557.22 403.47c.6-.77.92-1.25 2.5-1.94M559.43 403.2c.5-.63 1.3-1.36 2.52-1.79M561.44 403.25a8.02 8.02 0 0 1 2.5-1.53M558.13 395.39c1.04.11 2.5.48 3.38 1.06M559.63 396.97c.96.02 2.26.3 2.93.66M560.9 398.32a7 7 0 0 1 3.1.96M562.02 399.6a6 6 0 0 1 2.7.92M566.03 400.74c2.98-2.53 8.7-3.92 13.35-1.79a12.58 12.58 0 0 0-3.84.22c.62.17 1.2.6 1.38.75-1.26-.17-1.8-.28-3.16-.18.64.17 1.14.5 1.59.74-.96-.15-2.31-.33-3.44-.14.23.04 1.12.4 1.48.61-.53 0-2.59-.02-3.45.1.59.16.99.28 1.34.4-1.48.04-2.55.06-3.3.23M575.54 399.17a9.46 9.46 0 0 0-3.35-.5M573.76 399.74a9.06 9.06 0 0 0-3.95-.4M571.9 400.34c-1.42-.4-3.1-.42-3.88-.3M569.94 401.05a7.82 7.82 0 0 0-3.14-.17M568.1 402.55c.57.48.97 1.04 1.26 1.74",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1907934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.72 399.37c.25-3.17 3.11-6.9 8.3-7.49a13.6 13.6 0 0 0-3.05 2.05c.52-.1.88-.12 1.47-.1-.9.42-1.91 1.11-2.5 1.8.44-.08.89-.07 1.32-.03-.73.37-1.6.93-2.17 1.47.38-.08.74-.07 1.17-.05-.59.23-1.45.9-1.9 1.4.43-.07.74-.08 1.08-.05a9.56 9.56 0 0 0-1.65 1.8M569.97 393.93c-.75.21-1.72.61-2.41 1.11M568.95 395.63c-.71.12-1.6.45-2.19.8M568.09 397.07a5.7 5.7 0 0 0-2.3 1.08M567.36 398.43a5.02 5.02 0 0 0-2.26 1.23M564.4 403.4a9.41 9.41 0 0 0-.46 1.82M565.77 402.08c2.88 2.52 6.48 5.77 4.82 11.8-.12-.97-.31-2.36-.8-3.48a4.27 4.27 0 0 1-.49 1.4c-.04-.87-.48-2.87-.98-3.68a5.52 5.52 0 0 1-.31 1.59c-.04-.94-.59-2.64-1.07-3.73-.03.29-.13.83-.36 1.36-.11-1.35-.56-2.64-1.16-3.24",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1907934
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      textAlign: "center",
      lineHeight: "125%",
      InkscapeFontSpecification: "Linux Biolinum Bold"
    },
    fontSize: 100,
    fontWeight: 700,
    letterSpacing: 60,
    wordSpacing: 0,
    textAnchor: "middle",
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 1.5,
    fontFamily: "Linux Biolinum"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.28 364.86l1.97 1.07.47-.88c.25-.45.32-.8.23-1.06-.1-.26-.36-.5-.8-.74-.46-.26-.84-.35-1.12-.29-.3.06-.53.26-.7.6-.25.44-.36.74-.36.9.01.16.11.3.3.4m2.58 1.4l2.53 1.37c.2.1.37.12.52.03a4.28 4.28 0 0 0 .94-1.64.93.93 0 0 0-.03-.64c-.08-.17-.17-.3-.28-.4-.11-.1-.29-.2-.52-.33-1.18-.64-2.05-.46-2.6.56l-.56 1.05m-4.06-1.21a47.42 47.42 0 0 0 .96-1.84c.26-.5.55-.9.86-1.2.3-.31.6-.5.88-.6.29-.09.54-.12.78-.11.23.01.46.08.66.19.3.16.52.43.67.81.16.38.23.77.2 1.17a3.5 3.5 0 0 1 1.45-.92 1.9 1.9 0 0 1 1.53.17c.55.3.9.82 1.05 1.57.15.73-.06 1.62-.62 2.65l-.62 1.1-.54.96-.48.97h-.04c-.56-.43-1.29-.88-2.18-1.37l-2.76-1.5a18.3 18.3 0 0 0-2.33-1.08l-.02-.04.55-.93M520.66 348.13c-1.12.94-.92 2.31.59 4.12a4.35 4.35 0 0 0 2.28 1.62 2.3 2.3 0 0 0 2.06-.52c.55-.47.79-1.03.7-1.69a4.87 4.87 0 0 0-1.23-2.3c-.85-1.02-1.62-1.62-2.31-1.8-.7-.2-1.4 0-2.09.57m5.83-.29a4.23 4.23 0 0 1 1.08 3.2 4.42 4.42 0 0 1-1.73 3 4.53 4.53 0 0 1-3.18 1.16 3.81 3.81 0 0 1-2.86-1.46 4.38 4.38 0 0 1-1.08-3.24c.09-1.19.63-2.2 1.62-3.02a4.54 4.54 0 0 1 3.25-1.2 4 4 0 0 1 2.9 1.56M539 343.77c.23.84.41 1.36.54 1.57a22.54 22.54 0 0 0 2.96-1.05l.5-.2.03.03a7.12 7.12 0 0 0 .34 1.23l-.01.04c-.2.03-.46.09-.75.17l-3.76 1.05-1 .32-.04-.03a20 20 0 0 0-.56-2.51l-.84-3.02c-.28-1-.56-1.82-.83-2.44l.02-.04c.38-.08.7-.16.98-.24l1.02-.32.02.04c.07.56.26 1.4.57 2.5l.8 2.9M553.44 339.3c.1-.98.15-1.84.13-2.57l.03-.03a17.57 17.57 0 0 0 2.1.23l.01.03c-.17.66-.32 1.51-.43 2.54l-.34 3.12c-.1.96-.15 1.82-.12 2.56l-.03.04a17.58 17.58 0 0 0-2.1-.23l-.01-.04c.17-.68.32-1.52.42-2.53l.34-3.12M568.83 347.48a56.06 56.06 0 0 0 4.92-4.19c.08.07.3.2.64.39.27.14.46.23.56.25a436.38 436.38 0 0 0-7.3 5.61l-.78-.42.33-3.22.37-3.67c.1-1.01.16-1.74.18-2.16.11.09.49.3 1.12.64.45.24.74.38.87.43a54.59 54.59 0 0 0-.9 6.34M582.06 353.49c.73-.67 1.33-1.28 1.8-1.84h.04a17.57 17.57 0 0 0 1.43 1.55l-.02.04c-.57.38-1.24.92-2 1.61l-2.32 2.11c-.72.66-1.32 1.27-1.8 1.85h-.04a17.58 17.58 0 0 0-1.42-1.56l.02-.03c.58-.4 1.24-.93 2-1.62l2.31-2.11M589.85 369.12a67.7 67.7 0 0 0 2.07-2.21l-.03-.08-3.04.1a29.95 29.95 0 0 0 1 2.2m-1.79-2.17c-1.33.07-2.33.17-3 .29a2.9 2.9 0 0 0-.22-.54 4.09 4.09 0 0 0-.33-.64c4.33-.03 7.4-.06 9.21-.12l.49 1.05c-3.14 3.3-5.19 5.54-6.14 6.73-.04-.14-.2-.5-.46-1.07-.23-.5-.39-.8-.47-.93a37.6 37.6 0 0 0 2.18-2.07 54.72 54.72 0 0 0-1.26-2.7",
    style: {
      InkscapeFontSpecification: "Linux Biolinum Bold"
    },
    strokeWidth: 0.19231499999999999
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8a30e",
    strokeWidth: 1.79,
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.7 438.45l-1.2 3.45-3.66.08 2.91 2.2-1.06 3.5 3-2.09 3 2.09-1.06-3.5 2.91-2.2-3.65-.08zM571.97 432.37l-1.2 3.45-3.65.07 2.9 2.21-1.05 3.5 3-2.09 3 2.09-1.06-3.5 2.9-2.2-3.64-.08zM594.02 393.37l-1.2 3.45-3.66.07 2.91 2.21-1.05 3.5 3-2.09 3 2.09-1.06-3.5 2.9-2.2-3.65-.08zM583.55 421.2l1.2 3.44 3.65.08-2.91 2.2 1.06 3.5-3-2.09-3 2.1 1.06-3.5-2.91-2.21 3.65-.08zM590.94 408.47l1.2 3.45 3.65.08-2.9 2.2 1.05 3.5-3-2.09-3 2.1 1.06-3.5-2.9-2.21 3.64-.08zM542.3 438.45l1.2 3.45 3.66.08-2.91 2.2 1.06 3.5-3-2.09-3 2.09 1.06-3.5-2.91-2.2 3.65-.08zM528.03 432.37l1.2 3.45 3.65.07-2.9 2.21 1.05 3.5-3-2.09-3 2.09 1.06-3.5-2.9-2.2 3.64-.08zM505.98 393.37l1.2 3.45 3.66.07-2.91 2.21 1.05 3.5-3-2.09-3 2.09 1.06-3.5-2.9-2.2 3.65-.08zM516.45 421.2l-1.2 3.44-3.65.08 2.91 2.2-1.06 3.5 3-2.09 3 2.1-1.06-3.5 2.91-2.21-3.65-.08zM509.06 408.47l-1.2 3.45-3.65.08 2.9 2.2-1.05 3.5 3-2.09 3 2.1-1.06-3.5 2.9-2.21-3.64-.08z",
    strokeWidth: 0.1921207
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e7e7e7",
    strokeWidth: 0.37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.88 211.78l-.02-4.44h.54l-6.79-4.4h-5.46l-6.76 4.39h.54l.02 4.44 17.93.01",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.88 211.78l-.02-4.44h.54l-6.79-4.4-.51-6.68h-4.43l-.52 6.68-6.76 4.39h.54l.02 4.44 17.93.01zM363.97 217.62V219l-21.88-.03-.01-1.38 21.89.02",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.97 217.62V219l-21.88-.03-.01-1.38 21.89.02z",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54 217.53l-.02-4.7h.89l-.05 4.76.05-4.73-1.28-.03v-1.01l19.56.02.01 1h-1.2l.02 4.77-.04-4.77h.9l.01 4.71",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54 217.53l-.02-4.7h.89l-.05 4.76.05-4.73-1.28-.03v-1.01l19.56.02.01 1h-1.2l.02 4.77-.04-4.77h.9l.01 4.71",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74 216.37l-.01-3.28h-2.63l.02 3.28h2.62",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.82 213.78v1.9h1.2v-1.9h-1.2M360.58 216.38l-.01-3.27h-2.62l.01 3.27h2.62",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.66 213.79l.01 1.9h1.2l-.01-1.9h-1.2M360.56 211.04l-.01-3.28h-2.62v3.28h2.63z",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64 208.45v1.9h1.2v-1.9h-1.2M347.72 211.03l-.02-3.28h-2.62l.01 3.28h2.63z",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8 208.44v1.9h1.2v-1.9h-1.2M352.47 211.03v-3.27h-2.63v3.27h2.63",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.55 208.44v1.9h1.2v-1.9h-1.2M356.14 211.04l-.02-3.28h-2.62l.01 3.27 2.63.01",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.21 208.44l.01 1.9h1.2v-1.9h-1.2",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79 210.03l.03 7.57-7.6-.01-.03-7.56h7.6",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79 210.03l.03 7.57-7.6-.01-.03-7.56h7.6zM349.14 212.2h7.65M350.1 217.6l-.03-5.35M355.9 217.6l-.03-5.34M359.56 206.81l-4.28-3.12-4.8-.01-4.25 3.12 13.33.01M350.85 203h4.05M351.94 201.56v.95h1.86v-.95h-1.86",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54 210.25h.56l-.16.3s.26.34 0 .73l.15.27h-.54l.15-.26s-.28-.45 0-.75l-.16-.3M350.67 210.25h.56l-.16.3s.26.33 0 .73l.14.27h-.53l.14-.26s-.26-.45.02-.75l-.17-.3M351.9 210.25h.56l-.17.3s.27.34 0 .73l.15.28h-.53l.14-.27s-.27-.45.01-.75l-.16-.3zM353.3 210.25h.55l-.16.3s.26.34 0 .73l.15.28h-.54l.14-.26s-.26-.46.02-.75l-.16-.3zM354.53 210.25h.55l-.16.3s.27.34 0 .73l.15.28h-.54l.14-.26s-.27-.46.02-.75l-.16-.3M355.76 210.25h.55l-.16.3s.27.34 0 .73l.14.28h-.53l.14-.26s-.27-.46.02-.75l-.16-.3",
    transform: "matrix(.1902 0 0 .1695 482.85 351.75)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M549.75 384.42h.5v.58h-.5v-.58z",
    fill: "#e7e7e7",
    fillRule: "evenodd",
    strokeWidth: 0.050000600000000006
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 383.7v.75",
    fill: "none",
    strokeWidth: 0.115386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.73 383.98h.54",
    fill: "none",
    strokeWidth: 0.1461556
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M545.53 328.6s-3.66 8.5-2.4 9.34c0 0 4.6-5.13 5.8-9.2 1.19-4.07 0-.28 0-.28l-.34-4.42-3 4.2",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.6 219.12s-8.42 19.15-5.5 21.05c0 0 10.56-11.55 13.32-20.74 2.76-9.18 0-.63 0-.63l-.77-9.97-6.89 9.5",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.3 324.54s-4.4 9.36-3.39 10.05c0 0 3.65-4.2 4.6-7.55.96-3.34 0-.23 0-.23l1.23-6.02",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.39 209.96s-10.13 21.1-7.81 22.66c0 0 8.41-9.49 10.6-17.02 2.2-7.54 0-.52 0-.52l2.82-13.56",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.83 322.46s-4.4 9.35-3.39 10.04c0 0 3.65-4.2 4.6-7.55.96-3.34 0-.23 0-.23l1.23-6.01",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.82 205.26s-10.13 21.1-7.81 22.66c0 0 8.41-9.49 10.6-17.02 2.2-7.54 0-.52 0-.52l2.82-13.56",
    transform: "matrix(.43415 0 0 .44354 290.86 231.41)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.56 305.63l5.22 2.97s1.27 1.05-1.52.43c-2.8-.62-8.76-2.68-20.02-9.92-5.09-3.28-6.7-3.19-6.7-3.19l7.1.2 15.92 9.51z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.56 305.63l5.22 2.97s1.27 1.05-1.52.43c-2.8-.62-8.76-2.68-20.02-9.92-5.09-3.28-6.7-3.19-6.7-3.19l7.1.2 15.92 9.51z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1875456
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.28 304.35l5.22 2.96s1.28 1.05-1.52.43c-2.8-.62-8.75-2.68-20.01-9.92-5.1-3.28-1 2.7-1 2.7l.87-3.93 16.44 7.76z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.28 304.35l5.22 2.96s1.28 1.05-1.52.43c-2.8-.62-8.75-2.68-20.01-9.92-5.1-3.28-1 2.7-1 2.7l.87-3.93 16.44 7.76z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1875456
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.96 307.2s-6.23-1.16-8.5-2.82c0 0 .4.72-2.64-.67 0 0 1.17 2.67-7.4-3.18-8.59-5.84-5.59-2.9-5.59-2.9l2.4-.62s13.17 5.26 14.62 5.81c1.44.55 7.11 4.38 7.11 4.38",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.96 307.2s-6.23-1.16-8.5-2.82c0 0 .4.72-2.64-.67 0 0 1.17 2.67-7.4-3.18-8.59-5.84-5.59-2.9-5.59-2.9l2.4-.62s13.17 5.26 14.62 5.81c1.44.55 7.11 4.38 7.11 4.38z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.18315
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.38 309.53l2.09 2.98s-.7 2.8-7.94-2.64c-7.25-5.43-6.87-4.98-6.87-4.98l4-.56 8.8 4.99",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.38 309.53l2.09 2.98s-.7 2.8-7.94-2.64c-7.25-5.43-6.87-4.98-6.87-4.98l4-.56 8.8 4.99",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.97 311.03s3.37 4.4 2.62 4.95c-.75.54-4.73.3-7.57-4-2.84-4.31-.06-.22-.06-.22l.27-6.97 4.81 6.02",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.97 311.03s3.37 4.4 2.62 4.95c-.75.54-4.73.3-7.57-4-2.84-4.31-.06-.22-.06-.22l.27-6.97 4.81 6.02",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.43 309s3.24 4.18 2.88 4.82c-.35.63-4.92.23-8.56-3.9-3.64-4.12-.54-5.44-.54-5.44l6.16 4.3",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.4 308.89s3.27 4.29 2.91 4.93c-.35.63-4.92.23-8.56-3.9-3.64-4.12-.54-5.44-.54-5.44l6.19 4.4z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9 306.53s9.23 3.97 2.38 3.71c0 0-13.42-3.61-20.36-9.56l1.96-2.6 15.9 8.22",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9 306.53s9.23 3.97 2.38 3.71c0 0-13.42-3.61-20.36-9.56l1.96-2.6 15.9 8.22",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.74 305.38s5 3.04 5.37 4.19c.37 1.15-15.53-2.97-23.93-9.96l3.75-1.83 14.8 7.6z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.74 305.38s5 3.04 5.37 4.19c.37 1.15-15.53-2.97-23.93-9.96l3.75-1.83 14.8 7.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.22 308.13s3.61 2.97 3.2 3.31c-.4.35-7.74-.75-13.5-5.18l.7-2.65 9.67 4.38",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.22 308.13s3.61 2.97 3.2 3.31c-.4.35-7.74-.75-13.5-5.18l.7-2.65 9.67 4.38",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.4 307.88s3.57 2.46 2.83 2.72c-.74.26-3.54 2.46-16.81-5.32l-1.57-.86 2.11-3.31 13.45 6.55",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.4 307.77s3.57 2.57 2.83 2.83c-.74.26-3.54 2.46-16.81-5.32l-1.57-.86 2.11-3.31 13.45 6.66z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.78 300.6s4.31 3.86 3.76 4.42c-.55.55-5.68-.67-7.95-2.36-2.26-1.68-3.91-3.84-3.91-3.84l4.81-1.03 3.29 2.8z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.78 300.6s4.31 3.86 3.76 4.42c-.55.55-5.68-.67-7.95-2.36-2.26-1.68-3.91-3.84-3.91-3.84l4.81-1.03 3.29 2.8z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.63 294.14l7.87 4.69s6.41 4.53 5.73 4.93c-.67.4-5.73-1.17-9.32-3.13-3.58-1.95-7.74-6.16-7.74-6.16",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.63 294.14l7.87 4.69s6.41 4.53 5.73 4.93c-.67.4-5.73-1.17-9.32-3.13-3.58-1.95-7.74-6.16-7.74-6.16",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.67 316.3s1.47 3.75.6 4.07c-.88.33-3.05-.34-4.8-3.73-1.73-3.4 1.53-1.97 1.53-1.97l2.67 1.63z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.67 316.3s1.47 3.75.6 4.07c-.88.33-3.05-.34-4.8-3.73-1.73-3.4 1.19-1.9 1.19-1.9l3.01 1.56z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.28 313.88s2.2 3.63 1.72 4.05c-.48.41-3.38 1.66-6.54-3.02-3.15-4.68 3.25-3.7 3.25-3.7l1.57 2.67z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.28 313.88s2.2 3.63 1.72 4.05c-.48.41-3.38 1.66-6.54-3.02-3.15-4.68 3.25-3.7 3.25-3.7l1.57 2.67z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.71 297.49s7.5 14.47 6.88 15.24c-.63.77-3.59 0-5.25-3.83-1.66-3.82-3.02-8.8-3.02-8.8l1.4-2.61z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.71 297.49s7.5 14.47 6.88 15.24c-.63.77-3.59 0-5.25-3.83-1.66-3.82-3.02-8.8-3.02-8.8l1.4-2.61z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.45 301.17s6.25 5.32 4.97 5.99c-1.29.67-3.77-.3-7.43-3.92-3.66-3.62 2.4-2.29 2.4-2.29",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.42 301.06s6.28 5.43 5 6.1c-1.29.67-3.77-.3-7.43-3.92-3.66-3.62 2.43-2.18 2.43-2.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.41 301.26s4.48 8.21 3.92 8.98c-.56.78-3.91-2.04-5.57-4.13a25.29 25.29 0 0 1-2.9-5.13",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.41 301.26s4.48 8.21 3.92 8.98c-.56.78-3.91-2.04-5.57-4.13a25.29 25.29 0 0 1-2.9-5.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.9 318.12s-.26 4.84 0 5.2c.27.37 2.73.37 2.86-3.25.13-3.6-.53-3.75-.53-3.75l-2.4 1.66",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.9 318.12s-.26 4.84 0 5.2c.27.37 2.73.37 2.86-3.25.13-3.6-.53-3.75-.53-3.75l-2.4 1.66",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.37 312.29s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.29-2.99.29",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.37 312.29s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.29-2.99.29z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.56 319.2s.33 5.06 1.26 5.28c.93.22 2.45-1.44 2.45-2.74 0-1.3-1.59-4.34-1.59-4.34l-2.19 1.6",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.56 319.2s.33 5.06 1.26 5.28c.93.22 2.45-1.44 2.45-2.74 0-1.3-1.59-4.34-1.59-4.34l-2.19 1.6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.6 313.15s-1.72 5.42-.06 6.5c1.66 1.09 2.98-5.34 3.05-6.79.07-1.44-2.99.3-2.99.3z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.74 304.46s-2.52 2.6-2.46 4.04c.07 1.45 3.72-1.95 4.05-2.6.33-.65-1.6-1.44-1.6-1.44",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.74 304.46s-2.52 2.6-2.46 4.04c.07 1.45 3.72-1.95 4.05-2.6.33-.65-1.6-1.44-1.6-1.44z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 303s-1.99 3.68-1.46 4.84c.54 1.15 2.46-.87 3.39-2.17.93-1.3-1.93-2.67-1.93-2.67",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 303s-1.99 3.68-1.46 4.84c.54 1.15 2.46-.87 3.39-2.17.93-1.3-1.93-2.67-1.93-2.67z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.98 298.12s3.18 5.98 2.3 6.31c-.87.33-2.2-1.18-3.54-2.97-1.33-1.79 1.24-3.34 1.24-3.34",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.98 298.12s3.18 5.98 2.3 6.31c-.87.33-2.2-1.18-3.54-2.97-1.33-1.79 1.24-3.34 1.24-3.34z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.06 310.36s1.15 5.04.14 5.5c-1.98.91-3.09-3.58-3.2-5.26-.14-1.89 3.06-.24 3.06-.24zM564.1 318.35s.26 3.77-.28 4.1c-.54.34-1.87.43-3.36-2.74-1.48-3.17-.79-1.98-.79-1.98l3.65-1.8.79 2.05",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.74 317.48s.43 4-.37 4.1c-.8.12-2.93-1.23-3.86-3.62-1.07-2.76 3.72-1.94 3.72-1.94l.51 1.46z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.99 305.24s4.1 9.17 3.44 10.47c-1.3 2.56-5.02-5.58-6.14-8.76-1.26-3.56 2.7-1.71 2.7-1.71z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.09 306.77s5.59 10.1 3.23 10.33c-2.36.23-6.64-7.32-7.36-9.08-.72-1.76 4.13-1.25 4.13-1.25z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.75 308.86s2.75 9.68.98 8.82c-1.77-.85-3.9-8.14-4.2-9.71-.28-1.58 3.22.9 3.22.9zM571.41 295.1s4.24 6.48 2.87 6.67c-1.38.2-6.4-4.32-6.45-5.07-.04-.75 3.58-1.6 3.58-1.6z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.76 295.38s5.4 7.38 3.78 7.75c-1.63.37-1.75-.78-1.75-.78s-4.32-3.89-4.6-4.87c-.3-.98 2.42-2.2 2.42-2.2M574.12 295.5s3.72 3.83 2.74 5.12c-.97 1.3-6.14-4.85-6.84-5.63-.7-.78 4.5.35 4.5.35M565.1 300.82s6 11.66 4.9 12.84c-1.11 1.19-7.76-8.74-8-10.18-.23-1.44 3.17-2.88 3.17-2.88",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.67 301.87s2.39 3.65 2.25 5.62c-.13 1.96-3.61-2.82-3.91-3.71-.3-.9 1.66-1.9 1.66-1.9z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.241758
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.59 299.98s1.86 3.77 1.29 4.9c-.57 1.13-3.1-2.28-3.99-3.62-.88-1.34 2.7-1.28 2.7-1.28z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.95 303.68s2.93 3.25 2.78 4.97c-.14 1.73-4.38-2.52-4.75-3.31-.37-.8 1.97-1.66 1.97-1.66z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.249084
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.84 294.33s4.42 3.97 3.73 4.6c-.68.62-6.67-3.67-7.57-4.5-.9-.83 3.84-.1 3.84-.1z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.1 294.05l3.46 2.91s3.2 2.15 2.66 2.7c-.55.56-5.58-1.74-6.48-2.8-.9-1.04-.79-2.12-.79-2.12l1.15-.7zM584.5 294.96s13.09 5.31 12.58 6.6c-.51 1.28-13.73-4.26-15.8-5.72-2.08-1.45 3.02-.96 3.02-.96",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.97 296.65s9.83 5.53 8.68 6.06c-1.14.54-8.18-1.34-11.82-3.8-3.63-2.47-5.18-3.83-5.18-3.83l4.49-1.05 3.83 2.62zM560.76 303.38s1.86 3.76 1.29 4.9c-.57 1.13-2.42-.97-3.3-2.31-.9-1.34 2-2.6 2-2.6zM561.2 311.86s1.54 5.49-.16 6.5c-1.7 1.02-2.8-5.46-2.81-6.9-.02-1.45 2.97.4 2.97.4z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.59 302.83s5.47-2.4 6.43-2.21c0 0 1.15-.29 1.77-.77.62-.48 2.03-1.63 2.03-1.63s-.97-6.63 6-5.95c6.96.67 16.13 1.53 17.98 1.82 1.85.29 8.64 2.2 10.23 2.98a367 367 0 0 0 14.05 6.21c1.25.46 4.02 2.19 6.06 3.52 1.41.92-.04.26-.04.26s-16.75-8.89-22.67-10.08c-1.48-.3.1 1.7.1 1.7s-3.85-1.52-5.44-2.19a9.26 9.26 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.46-.39-.71 1.06s-2.38.48-2.56-.29c-.17-.77-1.4 3.46-2.03 4.7-.61 1.26-2.9 1.25-3.61 2.02a8 8 0 0 1-1.5 1.44c-.35.2-2.12 1.25-2.73 1.25-.62 0-4.41.29-4.41.29l-.97-1.54.44-.57zM560.78 318.35s.1 4.85-.18 5.2c-.28.35-2.73.25-2.74-3.36-.01-3.62.66-3.74.66-3.74l2.33 1.76",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.37 314.63s-.47-2.1-.8-2.38c-.33-.3.13-.58.13-.58s-.86-2.1-1.4-2.46c-.52-.37.07-.65.07-.65s-.92-1.45-1.59-1.89c-.66-.43 0-.5 0-.5s-.7-1.95-2.3-2.84c0 0-1.08-1.13-2.17-1.44-1.1-.3-3.8-.6-7.09-.53-3.45.06-4.91 2.45-4.91 2.45l-.22 2.78.5-.34-.74 3.46c-.11.79.62 2.16.66 3.81.02.53.05 1.07.1 1.63.16 1.49.51 3.06 1.19 4.51.05.12.1.45.16.34.17-.29.55.98.89 1.44 0 0 .2 1.72.37 1.08.06-.24.62.98.96 1.75.12.28.77 2.18.75 1.31-.03-.94.57 2.02.57 2.44l.8-1.15.4 1.3.66-.07-.2 1.23s1.86-1.52 1.93-2.1c.06-.58.13-1.02.13-1.02l.6-.57.93-1.45s2.32 1.8 2.58 2.46l.53 1.23.6-.58.53 1.3.33-.65.33.9.02-.05.22.6c.16.15.53.22 1.22-.94 1-1.67.93-2.97 1-3.26.07-.29.46.5.46.5s.87-1.58.73-2.6c-.13-1.01.54-.65.54-.65s.13-2.68 0-3.33c-.14-.65.46-.5.46-.5s-.2-3.19-.4-3.55c-.2-.36.47-.44.47-.44z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.72 307.27c.46.14.7.66.9 1.07-.02-.02.02-.14 0-.19-.2-.41-.43-.94-.9-1.09 0 0-.04.2 0 .2M557.14 309.27c.86.73.94 1.73.9 2.82v.1c.06-1.15.05-2.32-.9-3.12.02.01-.04.16 0 .2M558.94 310.3a4.71 4.71 0 0 1 .54 2.54c0-.96-.03-1.9-.54-2.74.01.02-.03.15 0 .2M559.57 314.07a17.3 17.3 0 0 1-.26 1.66v.18c.12-.56.22-1.13.27-1.7 0-.02 0-.22-.01-.14M558.99 316.97c.04.37.09.73.05 1.1a6.04 6.04 0 0 0-.04-1.24c-.01-.08-.02.12-.01.14M560.05 316.84c.26.27.41.59.47.96 0 .04.02-.03.02-.04v-.13a1.82 1.82 0 0 0-.49-1c.02.03-.04.17 0 .21M559.9 312.78c.26.22.47.49.68.76-.02-.03.04-.15 0-.2a4.85 4.85 0 0 0-.69-.76c.02.02-.04.17 0 .2M557.71 315.82c0 .55-.05 1.1-.15 1.64v.18a10.16 10.16 0 0 0 .15-1.82M556.55 317.03c.05.5.05.98 0 1.48a9.74 9.74 0 0 0 .01-1.62l-.01.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.53 303.64s-1.33 4.98-.33 5.49c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.53 303.64s-1.33 4.98-.33 5.49c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.4 303.6s-2.52 2.6-2.45 4.04c.06 1.45 3.71-1.95 4.04-2.6.34-.65-1.59-1.44-1.59-1.44",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.4 303.6s-2.52 2.6-2.45 4.04c.06 1.45 3.71-1.95 4.04-2.6.34-.65-1.59-1.44-1.59-1.44z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.4 303.96s-5.2 2.62-5.67 3.73c-.45 1.12 15.72-1.69 24.6-7.97l-3.6-2.13-15.33 6.37z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.4 303.96s-5.2 2.62-5.67 3.73c-.45 1.12 15.72-1.69 24.6-7.97l-3.6-2.13-15.33 6.37z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.49 305.01s-9.43 3.43-2.57 3.57c0 0 13.58-2.83 20.82-8.36l-1.83-2.7-16.3 7.27",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.55 304.9s-9.49 3.54-2.63 3.68c0 0 13.58-2.83 20.82-8.36l-1.83-2.7-16.36 7.38z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.48 295.44s-10.01 5.13-8.89 5.7c1.13.58 8.23-1 11.95-3.32 3.71-2.3 5.3-3.61 5.3-3.61l-4.44-1.23-3.92 2.46z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.48 295.44s-10.01 5.13-8.89 5.7c1.13.58 8.23-1 11.95-3.32 3.71-2.3 5.3-3.61 5.3-3.61l-4.44-1.23-3.92 2.46z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.7 306.69s-3.58 3-3.16 3.34c.41.34 7.73-.82 13.43-5.29l-.72-2.64-9.62 4.45",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.7 306.69s-3.58 3-3.16 3.34c.41.34 7.73-.82 13.43-5.29l-.72-2.64-9.62 4.45",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.47 306.22s-3.44 2.63-2.69 2.85c.76.23 3.66 2.29 16.53-6.1l1.52-.94-2.27-3.2-13.1 7.18",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46 306.12s-3.43 2.73-2.68 2.95c.76.23 3.66 2.29 16.53-6.1l1.52-.94-2.27-3.2-13.1 7.29z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.82 296.24c-10.83 3.78-21.68 11.33-21.68 11.33 1.06-.36 27.85-11.15 27.85-11.15M526.56 313.14s-2.32 3.54-1.85 3.97c.46.44 3.31 1.8 6.63-2.74 3.32-4.55-3.12-3.83-3.12-3.83l-1.66 2.6z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.56 313.14s-2.32 3.54-1.85 3.97c.46.44 3.31 1.8 6.63-2.74 3.32-4.55-3.12-3.83-3.12-3.83l-1.66 2.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.09 315.67s-1.6 3.68-.73 4.04c.86.36 3.05-.21 4.9-3.54 1.86-3.32-.86-1.66-.86-1.66l-3.31 1.16zM523.98 310.18s-3.52 4.26-2.79 4.84c.73.57 4.71.5 7.7-3.69 2.98-4.19.06-.21.06-.21l-.86-3.83-4.18 2.67",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.09 315.67s-1.6 3.68-.73 4.04c.86.36 3.05-.21 4.9-3.54 1.86-3.32-.86-1.66-.86-1.66l-3.31 1.16zM523.98 310.18s-3.52 4.26-2.79 4.84c.73.57 4.71.5 7.7-3.69 2.98-4.19.06-.21.06-.21l-.86-3.83-4.18 2.67",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6 308s-3.39 4.05-3.06 4.7c.33.66 4.91.44 8.7-3.54 3.78-3.97.72-5.41.72-5.41l-6.3 4.04",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6 308s-3.39 4.05-3.06 4.7c.33.66 4.91.44 8.7-3.54 3.78-3.97.72-5.41.72-5.41l-6.3 4.04",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.62 308.3l-2.19 2.89s.6 2.82 8.03-2.31 7.03-4.7 7.03-4.7l-3.98-.72-8.95 4.62",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.59 308.19l-2.16 3s.6 2.82 8.03-2.31 7.03-4.7 7.03-4.7l-3.98-.72-8.92 4.73z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.92 303.87l-4.7 2.12s-1.07.93 1.7 1c2.76.07 8.47-.7 18.42-6.33a51.59 51.59 0 0 0 7.34-4.98l-3.62-1.35-19.14 9.54z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.92 303.87l-4.7 2.12s-1.07.93 1.7 1c2.76.07 8.47-.7 18.42-6.33a51.59 51.59 0 0 0 7.34-4.98l-3.62-1.35-19.14 9.54z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.85 306.84s6.78-.73 9.47-2.5c0 0-.55.82 2.92-.53 0 0-1.73 3.1 8.38-3.05 10.1-6.15.08-.12.08-.12l11.22-6.43-.65-1.28s-21.44 9.18-23.07 9.7c-1.62.5-8.35 4.21-8.35 4.21",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.66 300.7l11.26-6.49-.65-1.28s-21.44 9.18-23.07 9.7c-1.62.5-8.35 4.21-8.35 4.21s6.78-.73 9.47-2.5c0 0-.55.82 2.92-.53 0 0-1.69 3.04 8.42-3.1z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.07 315.51s-.66 5.37.13 5.57c.8.2 3.06-1.5 3.99-4.77.92-3.29-3.65-2.89-3.65-2.89l-.67 1.9",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.07 315.51s-.66 5.37.13 5.57c.8.2 3.06-1.5 3.99-4.77.92-3.29-3.65-2.89-3.65-2.89l-.67 1.9",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2432232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.59 317.98s-.4 3.76.13 4.12c.53.36 1.86.5 3.45-2.6 1.6-3.11.86-1.95.86-1.95l-3.58-1.96-.86 2.03",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.59 317.8s-.4 3.94.13 4.3c.53.36 1.86.5 3.45-2.6 1.6-3.11.86-1.95.86-1.95l-3.58-1.96-.86 2.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.58 310.97s-2.92 6.36-1.26 6.29c1.66-.08 3.92-4.84 4.25-5.93.33-1.08-2.99-.36-2.99-.36",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.58 310.97s-2.92 6.36-1.26 6.29c1.66-.08 3.92-4.84 4.25-5.93.33-1.08-2.99-.36-2.99-.36z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.33 310.92s-1.1 7 .47 6.4c1.57-.59 2.45-5.86 2.48-7 .03-1.15-2.95.6-2.95.6",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.33 310.92s-1.1 7 .47 6.4c1.57-.59 2.45-5.86 2.48-7 .03-1.15-2.95.6-2.95.6z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.7 311.62s-1.72 5.42-.06 6.5c1.66 1.09 2.99-5.34 3.05-6.79.07-1.44-2.98.3-2.98.3",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.7 311.62s-1.72 5.42-.06 6.5c1.66 1.09 2.99-5.34 3.05-6.79.07-1.44-2.98.3-2.98.3z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.9 309.84s-1.65 4.98-.66 5.49c1.95.99 3.54-3.45 3.72-5.13.2-1.88-3.05-.36-3.05-.36zM519.53 299.56s-4.44 3.68-3.91 4.26c.53.58 5.7-.43 8.03-2.02 2.32-1.6 3.25-2.46 3.25-2.46l-3.98-2.46-3.39 2.68z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.45 295.8s-2.86 2.31-2.33 2.89c.54.58 5.64-1.52 6.57-2.53.93-1.01.87-2.1.87-2.1l-5.11 1.74z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.37 295.44s-3.85 3.18-2.92 4.33c.93 1.16 6.3-3.97 7.03-4.62.73-.65-4.51.14-4.51.14",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.64 294l-7.76 3.68s-6.57 4.26-5.9 4.7c.66.43 5.77-.95 9.41-2.75 3.65-1.8 7.7-4.84 7.7-4.84M526.8 298.19s-8.4 7.22-7.13 7.94c1.26.72 6.87-2.3 10.65-5.77",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.87 300.57s-4.76 8.02-4.22 8.81c.53.8 3.98-1.88 5.7-3.9 1.73-2.02 3.08-5.01 3.08-5.01",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.6 301.27s-5.15 9.57-4.55 10.37c.6.8 3.58.14 5.37-3.61 1.8-3.76 1.64-6.18 1.64-6.18l-2.46-.58z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.6 301.73s-5.73 11.81-4.6 12.97c1.13 1.16 7.46-8.96 7.75-10.39.51-2.51-3.22-2.8-3.22-2.8M521.52 293.92s-5.17 2.46-4.11 2.96c1.06.5 5.9-1.66 6.57-1.88.66-.21-2.46-1.08-2.46-1.08z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.32 294.72s-3.19 2.52-2.52 3.18c.66.65 5.5-1.96 6.43-2.75.93-.8-3.91-.43-3.91-.43z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 294.92s-4.35 5.85-3.02 6.08c1.34.23 6.39-3.77 6.46-4.46.07-.7-3.44-1.62-3.44-1.62z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.21978000000000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.94 296.23s-4.64 5.85-3.31 6.22c1.32.36 1.46-.58 1.46-.58s3.64-3.04 3.91-3.83c.27-.8-1.92-1.88-1.92-1.88",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.4 297.6s-3.38 5.86-2.52 6.22c.87.36 2.26-1.08 3.65-2.82 1.4-1.73-1.13-3.4-1.13-3.4z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.27 300.28s-2 3.68-1.46 4.84c.53 1.16 2.45-.87 3.38-2.17.93-1.3-1.92-2.67-1.92-2.67zM534.1 310.5s-1.33 5-.33 5.5c1.95.99 3.2-3.45 3.38-5.13.2-1.88-3.05-.36-3.05-.36z",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.22 303.77s-1.33-.44-2.32-.44c0 0-2.92-2.31-4.52-2.53-1.59-.21-.23-.25-.23-.25s-.16-3.8-.63-4.08c0 0-.26-3.9-2.72-4.2-2.45-.28-7.96.22-8.96-.14-1-.36-4.04-1.63-9.81-.07-5.91 1.6-17.54 6.82-18.14 6.96-.6.15 13.36-3.06 17.27-4.8 0 0 3.92-.28 5.11-.64 0 0-4.44 2.17-.33 1.23s3.18 0 3.18 0-.4.94 1.93.43c2.32-.5 2.32 0 2.32 0s2.65.94 4.71-.29c0 0 1.06 3.69 2.39 4.2 0 0 1.58 3.37 4.9 4.02l1.9 1.33 1.88.62 2-1.57",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.02 293.78s-13.27 4.76-12.81 6.07c.46 1.3 13.87-3.69 15.99-5.06 2.12-1.37-2.99-1.09-2.99-1.09",
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.75 304.06c.3.05.56.19.83.33.01 0 .13.07.15.04.02-.03-.08-.12-.1-.12a2.4 2.4 0 0 0-.56-.42c-.34-.18-.68-.37-1.07-.43-.08-.02.21.26.23.27.14.12.34.3.52.33M542.42 314.08c.2.37.23.81.42 1.19-.01-.03.03-.15 0-.2-.19-.37-.22-.81-.42-1.19.02.03-.03.15 0 .2M544.22 303.86c.45-.16.92-.16 1.38-.22.02 0 0-.2 0-.2-.46.06-.93.06-1.38.22-.03 0 0 .2 0 .2M546.87 303.64a3 3 0 0 1 1.32-.21c.02 0 .02-.2 0-.2a3 3 0 0 0-1.32.21c-.04.02.01.2 0 .2M542.26 305.98c-.05.01-.06.06-.06.1v.15c.01.03.02-.04.02-.04 0 .04.02 0 .04 0 .03-.01 0-.2 0-.2M541.99 313.12a7.68 7.68 0 0 0 .07 1.07v-.13a6.24 6.24 0 0 1-.07-.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.67 334.2s-1.5 1.17-1.67 1.72c-.17.55-.22 1.07-.22 1.07s1.34-.16 1.18.58c0 0 .44.25 1.13-1.36.7-1.6 1.35-2.3 1.84-2.25.49.04 1.11.52 1.43.86.31.33.75.58 1.3.43 0 0-.58-.88-.22-1.07.37-.2.92-.15.92-.15s-.46-1.1-1.44-1.25c-.99-.16-1.67-.43-1.44-.86.24-.43 1.5-3.76 1.5-3.76l-1.67-2.45-.67 2.14s.22 1.26.23 1.58c0 .32-1.33 3.08-1.5 3.24-.19.16-3.77 1.54-4.2 1.67-.42.14-1.3 1.2-1.3 1.2l-.1.8s.6-.5.78-.2c0 0 .42-.53.79-.33.37.2.31.27.31.27s.67-.44.78-.65c.12-.21.15-.19.15-.19s.34-.09.82-.17",
    fill: "#bd8759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.67 334.2s-1.5 1.17-1.67 1.72c-.17.55-.22 1.07-.22 1.07s1.34-.16 1.18.58c0 0 .44.25 1.13-1.36.7-1.6 1.35-2.3 1.84-2.25.49.04 1.11.52 1.43.86.31.33.75.58 1.3.43 0 0-.58-.88-.22-1.07.37-.2.92-.15.92-.15s-.46-1.1-1.44-1.25c-.99-.16-1.67-.43-1.44-.86.24-.43 1.5-3.76 1.5-3.76l-1.67-2.45-.67 2.14s.22 1.26.23 1.58c0 .32-1.33 3.08-1.5 3.24-.19.16-3.77 1.54-4.2 1.67-.42.14-1.3 1.2-1.3 1.2l-.1.8s.6-.5.78-.2c0 0 .42-.53.79-.33.37.2.31.27.31.27s.67-.44.78-.65c.12-.21.15-.19.15-.19s.34-.09.82-.17",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.87 326.83l.06 3.35a3.6 3.6 0 0 1-.36 1.77c-.3.46-.6.72-1.08.72-.49 0-1.75-.07-2 .4-.24.45-.42.71-.42.71s.79-.45.9 0c.13.46-.3.86-.3.86s.73.13 1.4-.26c.66-.4 1.02-.46 1.32-.46.3 0 .54.32.54.32s.18.99.12 1.58c-.06.59-.18 1.77.48 1.77 0 0 .24-.59.49-.66.24-.06.9.6.78.8 0 0 .12-1.26-.12-1.98s-.36-1.5-.36-1.5 2.05.72 2.23.98c.18.26.66.72.84.65.18-.06 0-.65.36-.78s.54.2.54.2-.6-1.38-1.5-1.84c-.9-.46-1.5-.46-1.87-.86-.36-.39-.42-.85-.48-1.3-.06-.47.01-4.43.01-4.43l-1.52-.3",
    fill: "#bd8759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 326.62l.03 3.56a3.6 3.6 0 0 1-.36 1.77c-.3.46-.6.72-1.08.72-.49 0-1.75-.07-2 .4-.23.45-.42.71-.42.71s.79-.45.9 0c.13.46-.3.86-.3.86s.73.13 1.4-.26c.66-.4 1.02-.46 1.32-.46.3 0 .54.32.54.32s.18.99.12 1.58c-.06.59-.18 1.77.48 1.77 0 0 .24-.59.49-.66.24-.06.9.6.78.8 0 0 .12-1.26-.12-1.98s-.36-1.5-.36-1.5 2.05.72 2.23.98c.18.26.66.72.84.65.18-.06 0-.65.36-.78s.54.2.54.2-.6-1.38-1.5-1.84c-.9-.46-1.5-.46-1.87-.86-.36-.39-.42-.85-.48-1.3-.06-.47.01-4.43.01-4.43l-1.55-.25z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.3 308.31s-.2-2 .36-2.22c0 0 .2-1.85 2.65-1.6 0 0 .83-1.37 2.16-.64 0 0 1.26-.62 1.99-.26s1.63.98 1.7 1.12c0 0 1.05-.21 1.55.18.5.4.27 1.7.27 1.7s1.2.92 1.29 1.72c.1.81.1 1.13-.17 1.35 0 0 .53.43.44 1.05-.1.61-.6 1.5-.7 1.5-.1 0 .06 1.6-.47 2.15-.53.54-1.02.65-1.26.72-.23.07-.83.94-1.39 1.05-.56.1-1.33-.87-1.4-1.16-.06-.29-.82-.61-.82-.61s-1.73 1.84-2.89 1.55a3 3 0 0 1-1.82-1.44c-.1-.18-.43-1.52-.43-1.52s-1.3-.76-1.2-1.48c.1-.72.63-1.6.63-1.6l-.5-1.56z",
    fill: "#dcddde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6 331.16c-.15.03-.26 0-.36-.07M547.18 329.7a1.25 1.25 0 0 1-.5-.18M546.59 330.45c.1.06.24.09.37.07M545.36 332.73a.5.5 0 0 0 .25.09M555.65 331.36c.25.04.47.17.73.2M556.08 330.63c-.2.05-.37.01-.49-.13M556.2 329.78c-.23.03-.47.02-.67-.06M555.35 332.67c.23.03.44.14.67.2M555.41 333.59c.11-.03.22 0 .3.06M555.6 336.08c.14-.03.3 0 .42.07M548.06 332.86a.53.53 0 0 0-.42.33M549.29 332.97c-.26.16-.5.37-.53.68M541.67 334.33c.2.18.5.3.68.46M557.82 333.33a.55.55 0 0 0-.3.39M558.67 333.59a.29.29 0 0 0-.18.26",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.77 336.05l.86-.22.08.03s-.56 1.1-.41 1.36c.15.26-.77-.48-.53-1.17",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.77 336.05l.86-.22.08.03s-.56 1.1-.41 1.36c.15.26-.77-.48-.53-1.17z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.04 336.7s-.95 1.59.28 2.38c0 0-.07-1.48.9-1.8l-1.18-.58z",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.04 336.7s-.95 1.59.28 2.38c0 0-.07-1.48.9-1.8l-1.18-.58z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.35 335.21l-.28-.85.33-.46h.68l.28.13s.55 1.24.07 1.9c0 0-.2-.7-.43-.8 0 0-.5-.08-.65.08",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.35 335.21l-.28-.85.33-.46h.68l.28.13s.55 1.24.07 1.9c0 0-.2-.7-.43-.8 0 0-.5-.08-.65.08z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.47 333.4h.56l.22.52-.08.5-.5.22s-.8-.2-.6.75c0 0-.38-1.76.4-2",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.47 333.4h.56l.22.52-.08.5-.5.22s-.8-.2-.6.75c0 0-.38-1.76.4-2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.46 337.33l.58-.64.63.33s-.26 1.7-.36 1.83c-.1.12-.12.14-.12.2 0 .04-.1-.33-.28-.54-.2-.22-.39-1.16-.45-1.18",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.46 337.33l.58-.64.63.33s-.26 1.7-.36 1.83c-.1.12-.12.14-.12.2 0 .04-.1-.33-.28-.54-.2-.22-.39-1.16-.45-1.18z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.26 335.62s.94 1.18.82 1.56c0 0 .97-.98-.27-2.37l-.55.81z",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.26 335.62s.94 1.18.82 1.56c0 0 .97-.98-.27-2.37l-.55.81z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.13 306.08c.19.05.3.19.37.37v-.07-.12c-.06-.19-.18-.33-.37-.39 0 0-.03.2 0 .2M555.34 309.32c.3.31.51.67.63 1.08 0-.03.02-.14 0-.2a2.65 2.65 0 0 0-.63-1.08c.02.02-.04.16 0 .2M554.65 306.94c.29.25.53.54.8.81-.03-.02.03-.16 0-.2-.27-.27-.51-.56-.8-.81.02.02-.04.17 0 .2M555.44 312.34c.08.48-.03.9-.2 1.33-.03.05 0 .16 0 .2.23-.56.31-1.12.21-1.7 0-.02-.02.13-.01.17M556.18 314.01c.04.25.05.5 0 .75v.14s0 .07.01.03c.07-.36.06-.73 0-1.09l-.01.04v.13M559.04 319.92a7.6 7.6 0 0 1 .23 2.07 8.3 8.3 0 0 0-.22-2.27c0 .04-.02.14 0 .2M558.57 321.3c-.16.47-.32.95-.53 1.4-.03.05.01.17 0 .2.22-.46.38-.94.53-1.41.02-.06-.01-.17 0-.2M542.58 316.73c.44.58.68 1.27 1.06 1.9-.02-.03.03-.16 0-.2-.37-.63-.61-1.32-1.06-1.9.03.03-.04.15 0 .2M545.39 316.8c-.4.05-.5-.53-.85-.65 0 0-.03.2 0 .2.34.12.44.7.85.65.02 0 0-.2 0-.2M543.8 319.49c.29.5.48 1.07.79 1.56-.01-.02.03-.14 0-.19-.3-.5-.5-1.06-.79-1.57.01.02-.03.15 0 .2M545.65 320.14c.33.4.62.8.8 1.3-.02-.04.02-.15 0-.2-.17-.5-.47-.9-.8-1.3.03.03-.04.15 0 .2M545.49 322.08c.16.34.31.69.48 1.03-.02-.03.03-.14 0-.2l-.48-1.02c.02.02-.02.14 0 .2M547.24 322.46a4.36 4.36 0 0 1 .17 1.1c0-.44-.05-.87-.17-1.3.01.04-.02.14 0 .2M546.5 324.07c.1.52.26 1.02.53 1.47-.02-.02.03-.14 0-.19a4.95 4.95 0 0 1-.53-1.45c0-.02-.02.13 0 .17M546.92 317.22c.42.16.84.32 1.27.43 0 0 .03-.2 0-.2-.43-.12-.85-.27-1.27-.43 0 0-.03.19 0 .2M547.24 319c.5.28 1.02.5 1.53.76 0 0 .04-.18 0-.2-.5-.26-1.03-.48-1.53-.76.01.01-.04.18 0 .2M547.72 321c.25.32.54.6.84.87-.02-.02.04-.17 0-.2-.3-.27-.59-.55-.84-.87.02.03-.04.16 0 .2M548.24 323.49c.22.34.32.72.37 1.12 0 .04.01-.03.01-.03v-.14a2.8 2.8 0 0 0-.37-1.15c.01.02-.04.15 0 .2M549.72 317.31l.16.72c0-.04.02-.14 0-.2a15.8 15.8 0 0 1-.16-.66v.14M553.43 315.83c-.1.26-.23.51-.37.76-.03.04.02.17 0 .2.15-.25.27-.5.38-.76.02-.06-.02-.17 0-.2M554.96 315.77c0 .42 0 .84-.1 1.26v.17a6.52 6.52 0 0 0 .1-1.43M555.28 318.1c.04.37 0 .73-.05 1.1v.17a5.81 5.81 0 0 0 .05-1.26M556.45 320.33c-.07.5-.38.9-.74 1.23-.04.04.02.18 0 .2.37-.33.68-.74.75-1.26l-.01-.17M552.69 318.16c-.1.2-.24.4-.37.6-.02.02 0 .09 0 .12v.07c.13-.2.27-.39.37-.6.02-.03.01-.09.01-.12 0-.01 0-.08-.01-.07M553.12 321.13c-.16.21-.32.43-.53.6-.04.02.02.18 0 .2.2-.17.37-.39.53-.6v-.1-.1M551.8 322.7c-.52-.52-.77-1.17-.53-1.92.01-.05-.02-.16-.01-.19-.26.83-.09 1.7.53 2.3-.02-.02.04-.16 0-.2M550.04 321.05c.04.3.04.6-.05.9-.02.05.01.15 0 .19.13-.41.12-.85.06-1.27l-.01.04v.14M554.07 323.02c-.11.37-.31.7-.48 1.03-.03.05.02.17 0 .2.17-.34.37-.66.48-1.03.02-.06-.01-.16 0-.2M556.66 324.1c-.22.4-.48.77-.74 1.14-.03.04.02.18 0 .2.26-.37.52-.75.75-1.14.02-.05-.02-.17-.01-.2M557.93 325.47a26.56 26.56 0 0 0-.2 2.2c.05-.68.1-1.36.2-2.03.02-.04 0-.19 0-.17M559.57 323.04c0 .24.04.47.05.7 0 .14.02.01.02-.05 0-.24-.05-.47-.06-.7 0-.15-.02-.01-.01.05M542.15 315.4c-.1.7-.01 1.37.22 2.03-.01-.03.02-.14 0-.2a3.42 3.42 0 0 1-.2-1.65l-.02-.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.15 306.8c1.12-1.04 2.6-2.12 4.18-1.74 0 0 .03-.2 0-.2-1.58-.38-3.06.7-4.18 1.73-.04.04.03.18 0 .2M553.53 308.01c-1.13-.76-3.08-1.04-4.18-.1-.04.03.02.18 0 .2 1.1-.94 3.05-.66 4.18.1-.02 0 .04-.17 0-.2M549.24 309.74c.46 1.48 1.06 3 .8 4.59v.17c.29-1.72-.29-3.34-.8-4.96.02.03-.01.14 0 .2M547.45 310.64c.28 1.5.1 3.03 0 4.54 0 .03 0 .23.01.1.11-1.6.3-3.22 0-4.81 0-.02-.02.13-.01.17M549.84 309.54a6 6 0 0 1 3.68 2.64c0-.03.04-.15 0-.2a6 6 0 0 0-3.68-2.65s-.02.2 0 .2M548.54 311.57c0 .93.08 1.85-.2 2.75 0 .06.02.16.01.2.3-.97.22-1.96.21-2.95 0-.11-.02-.11-.02 0M550.84 311.37c.92.76 1.65 1.9 1.78 3.12.01.08.02-.12.02-.14a4.99 4.99 0 0 0-1.8-3.19c.02.02-.04.17 0 .2M544.07 313.9c.3-.43.69-.93 1.2-1.11.03-.01-.01-.2 0-.2-.52.18-.9.68-1.2 1.12-.03.04.02.18 0 .2M546.26 306c-.19-.83-.81-1.32-1.48-1.77.02.01-.03.16 0 .18.66.45 1.29.93 1.48 1.76 0-.03.02-.13 0-.18M544.97 305.98a5.37 5.37 0 0 0-2.4-.4v.2c.84 0 1.63.04 2.4.4-.01 0 .03-.18 0-.2M547.36 305.85c.1-.8-.02-1.54-.7-2.03.02 0-.03.15 0 .17.57.41.78.99.7 1.7v.16M550.24 306.8c.72-.4 1.5-.32 2.29-.31.01 0 .02-.2 0-.2-.78-.01-1.57-.08-2.29.3-.04.02.02.2 0 .2M551.54 308.72c1.1.12 1.95.69 2.68 1.53-.05-.06.08-.32 0-.4a4.07 4.07 0 0 0-2.68-1.53c-.02 0-.05.4 0 .4M546.65 311.78c-.26 1.06-.06 2.4-1.28 2.84-.07.02 0 .4 0 .4 1.24-.44 1.03-1.78 1.3-2.85.02-.11-.03-.32-.02-.39",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.24 310.95c.43 1.12 1.02 2.26.8 3.5-.02.08 0 .38.01.34.28-1.52-.26-2.83-.8-4.23.02.06-.05.28 0 .4M550.84 310.75a2.63 2.63 0 0 1 2.18 2.21c0 .08.03-.06.03-.07l-.01-.27a2.67 2.67 0 0 0-2.2-2.27c-.02 0-.05.4 0 .4M550.83 312.35c.17.93.43 1.86.1 2.79-.04.1.04.33.01.39.41-1.16.12-2.36-.1-3.52 0-.04-.02.26-.01.34M550.24 308.32c1.2-.2 2.45-.39 3.48.4-.04-.03.08-.34 0-.4-1.03-.79-2.29-.61-3.48-.4-.05 0 0 .4 0 .4M548.06 305.95c.15-.99 1.01-1.69 1.88-2 .07-.03-.01-.4 0-.41-.9.33-1.75 1.05-1.9 2.06-.01.1 0 .19 0 .28 0 0 .01.15.02.07M546.97 306.54c-.02-1.1-.5-1.97-.97-2.93.02.05-.06.26-.01.35.42.85.93 1.69.95 2.68 0 .25.04.01.03-.1M545.97 307.13a3.04 3.04 0 0 0-1.7-2.07c.03.02-.07.37 0 .4a3 3 0 0 1 1.68 2.01c.01.04.04-.27.02-.34M544.37 306.74a4.43 4.43 0 0 0-1.82-.86s-.03.31 0 .31c.68.1 1.26.47 1.82.86-.03-.02.06-.27 0-.31M547.84 311.3c.1 1.04.22 2.08-.29 3.02-.05.1.04.35.01.4.62-1.14.42-2.47.3-3.7 0-.16-.03.23-.02.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.04 310.75c.35.97.76 2 .69 3.06 0 .06.02.45.03.2a9.04 9.04 0 0 0-.7-3.65c.01.06-.06.28-.02.39M549.84 309.33c1 .3 1.97.63 2.69 1.42-.05-.05.08-.31 0-.4-.72-.8-1.7-1.12-2.69-1.42.01 0-.06.38 0 .4M547.17 307.14c.1-.86.2-1.72.2-2.59.01-.23-.03-.22-.03 0-.01.78-.1 1.54-.2 2.3 0 .05.01.45.03.29M545.37 306.59a8.77 8.77 0 0 1-2-1.32c.05.04-.07.34 0 .4.62.52 1.27 1 2 1.32-.03 0 .07-.37 0-.4M545.07 311.78c-.47.3-.8.7-1 1.22-.03.07-.02.18-.02.25 0 .02.02.16.03.14.2-.51.52-.92.99-1.21.07-.05-.04-.38 0-.4M546.34 312.53c-.02.71-.4 1.3-.88 1.79-.07.08.05.35 0 .4a3 3 0 0 0 .92-2.08c0-.13-.03-.39-.04-.1M549.68 306.97c.59-.93 2.01-1 2.96-1.27.06-.01 0-.4 0-.4-.96.26-2.37.34-2.97 1.28-.06.09.04.35.01.39M543.16 306.95a3.24 3.24 0 0 1-.65-.3c.02.01-.04.22 0 .25.21.12.42.23.65.3 0 0 .03-.24 0-.25M543.28 311.7c-.2.08-.41.17-.55.35-.04.04-.02.15-.02.2v.14s.01.07.02.06c.14-.18.35-.26.55-.35.04-.01.02-.17.02-.2 0-.01 0-.2-.02-.2M544.14 311.92c-.42.19-.73.55-.99.92-.05.07.03.28.01.3.26-.36.57-.72.98-.9.06-.03-.01-.32 0-.32M545.77 312.32c-.37.9-1.37 1.89-.65 2.89-.02-.04.08-.3.01-.4-.5-.69.39-1.47.65-2.1.04-.1-.04-.33-.01-.4M546.91 312.3c.03.92-.13 1.82-.29 2.71-.01.08.01.39.02.35.19-1.05.34-2.1.31-3.16 0-.29-.04-.02-.04.1M549.85 311.23c.66.87 1.25 1.8 1.54 2.88-.02-.07.04-.27 0-.39a8.37 8.37 0 0 0-1.54-2.9c.05.07-.07.31 0 .4M550.2 310.52c1.09.84 2.3 1.62 3.08 2.8-.03-.04.06-.3 0-.39-.77-1.18-1.99-1.97-3.09-2.81.04.03-.08.34 0 .4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.84 309.08c.4-.04.78-.02 1.17.12.35.13.64.42.95.6.32.2.64.37.9.65.34.35.34.96.44 1.42.01.03.03-.23.02-.3-.08-.37-.12-.75-.25-1.12-.13-.36-.44-.57-.74-.77l-1.07-.7c-.42-.27-.94-.29-1.42-.24-.04 0-.02.34 0 .34",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.52 311.32l.38 1.06c-.02-.04.03-.18 0-.26l-.38-1.05c.02.04-.03.18 0 .25M550.45 305.75c.77-.22 1.56-.36 2.32-.62.06-.02-.01-.4 0-.4-.76.26-1.55.4-2.32.61-.06.02 0 .4 0 .4M547.24 306.13c.1-.4.28-.74.51-1.09.29-.43.33-.96.68-1.36.08-.08-.05-.34 0-.4-.29.32-.39.74-.56 1.13-.2.47-.5.82-.64 1.33-.03.12.03.32 0 .4M544.6 313.35c-.13.66-.1 1.35.14 1.99-.03-.06.05-.28 0-.4-.15-.4-.2-.8-.12-1.24.02-.1.02-.2.01-.28 0-.01-.01-.15-.03-.07M546.2 314.6c-.27.38-.28.95-.13 1.38l.02-.13c0-.07.01-.16-.01-.23-.08-.24-.02-.44.12-.64.03-.04.02-.14.02-.19 0-.02-.03-.18-.02-.19M547.39 313.97c-.01.38-.22.74-.38 1.08-.03.07.03.24.01.28.2-.42.38-.82.4-1.29 0-.09-.02-.28-.03-.07M547.43 311.72v.49c0 .01 0 .2.02.2s.02-.19.02-.2v-.49s0-.2-.02-.2c-.03 0-.02.2-.02.2M546.88 312l.08.18c.01.09.02.1.02.02 0 .03 0 .06-.02.1a1.2 1.2 0 0 0 0 .27c0 .01.01.15.02.07a1.6 1.6 0 0 0-.09-1.02l-.02.14c0 .06-.02.19.01.25M546.11 311.75c-.08.25-.13.5-.18.77v.27c0 .01.01.15.02.07.05-.24.1-.48.17-.72.03-.08.02-.17.02-.25a.65.65 0 0 0-.03-.14M545.52 311.79c-.37.44-.85.73-1.33 1-.08.05.03.4 0 .4.48-.27.96-.56 1.33-1 .03-.04.02-.15.02-.2l-.02-.2M544.49 311.96c-.22.18-.47.3-.73.4-.07.02 0 .4 0 .4.26-.1.5-.22.73-.4.03-.02.02-.16.02-.2l-.02-.2M543.03 311.6l-.65.27c-.05.03.02.32 0 .33l.65-.27c.05-.03-.02-.32 0-.33M547.47 311.43c0 .26.05.52.1.78.01.07.02-.06.02-.08v-.27c-.04-.18-.08-.36-.08-.54a.6.6 0 0 0-.03-.14c-.02.07-.01.17-.01.25M548.16 311.11c0 .31.03.6.14.9a.6.6 0 0 0 .02-.14c0-.08.02-.18-.01-.25a1.5 1.5 0 0 1-.11-.5c0-.02 0-.21-.02-.21-.03 0-.02.19-.02.2M548.68 311.04c.1.13.2.31.2.48 0 .01.02.15.03.14.03-.08.02-.18.01-.25 0-.28-.06-.53-.22-.76-.02-.02-.03.13-.03.14 0 .06-.02.2.02.25M549.33 310.79c.23.05.44.14.6.3l.02-.2c0-.04.02-.17-.01-.2a1.2 1.2 0 0 0-.6-.3s-.06.39 0 .4M549.68 310.26c.26.22.56.39.9.44 0 0 .05-.4 0-.4a1.83 1.83 0 0 1-.9-.44l-.02.2c0 .04-.02.17.02.2M550.4 308.5c.24.01.47.05.7.1 0 0 .05-.4 0-.4a3.62 3.62 0 0 0-.7-.1c-.02 0-.02.4 0 .4M550.07 307.67c.14-.23.35-.4.55-.57.04-.02.02-.16.02-.2l-.02-.2c-.2.17-.42.34-.56.58-.04.05-.02.18-.02.25 0 .01.02.16.03.14M549.43 306.86c.04-.27.13-.5.29-.72.03-.04.02-.15.02-.2l-.02-.2a1.63 1.63 0 0 0-.32 1.05s.02.15.03.07M548.91 306.48c.26-.37.44-.8.69-1.18.03-.05.01-.19.01-.25 0-.01-.01-.16-.02-.14-.25.39-.43.81-.69 1.18-.04.05-.02.2-.01.25 0 .02 0 .16.02.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.73 305.16c0 .45.04.9.13 1.35.02.07.03-.06.03-.08v-.27a5.71 5.71 0 0 1-.12-1.1c-.01-.3-.05-.03-.04.1M545.81 305.48c.07.16.16.31.24.47a3.13 3.13 0 0 1 .18.43c-.03-.09.02-.06-.03.02-.06.1.03.35 0 .4.12-.21.1-.53.05-.75-.08-.35-.3-.64-.43-.96.02.05-.05.28 0 .39M545.43 306.26a7.05 7.05 0 0 0-.86-.7l-.02.2c0 .04-.01.18.02.2.3.22.6.44.86.7l.02-.2c0-.04.01-.16-.02-.2M546.68 306.68a4.3 4.3 0 0 0-.22-2.6c.03.05-.05.28 0 .39a3 3 0 0 1 .2 1.86c-.01.1 0 .2 0 .28 0 .01 0 .15.02.07M548.56 305.53c.03 0 .03-.4 0-.4s-.03.4 0 .4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.44 306.72c.04-.5.16-.99.21-1.49a2.2 2.2 0 0 0 0-.43c0-.1-.03-.1-.04 0-.05.5-.17 1-.21 1.5a2.3 2.3 0 0 0 0 .42c0 .1.03.1.04 0M551.87 309.84c.43.14.86.43 1.06.86.01.03.04-.19.04-.21 0-.1.02-.27-.02-.37a1.8 1.8 0 0 0-1.08-.89c.01 0-.1.57 0 .6M550.4 312.85c.08.26.08.5.03.76-.02.13-.01.28 0 .42 0 .01.01.22.04.1.1-.6.12-1.27-.05-1.86-.01-.03-.04.18-.04.2 0 .12-.02.26.02.38M549.18 312.03c0 .5.02 1-.08 1.5-.02.13-.01.27 0 .4 0 .03.01.23.03.12.14-.67.1-1.34.1-2.02 0-.02.01-.3-.02-.3-.04 0-.03.28-.03.3M548.55 312.57c-.17.67-.34 1.33-.48 2-.02.14-.01.29 0 .42 0 .02.01.22.04.1.13-.64.3-1.29.46-1.93.04-.17-.04-.48-.02-.59M549.39 313c0 .57.07 1.14 0 1.71a2.1 2.1 0 0 0 0 .43c.02.1.04.1.05 0 .08-.72.02-1.43.01-2.14 0-.02 0-.3-.03-.3s-.03.28-.03.3M545.37 313.3v-.1a.93.93 0 0 1-.12.3c-.05.08-.02.27-.02.37 0 .02.02.24.04.2.2-.37.2-.87.13-1.3-.01-.1-.04.1-.04.12l.01.41M547.14 312.1c.12.23.1.43.1.68 0 .02 0 .3.03.3.04 0 .03-.28.03-.3 0-.42.05-.88-.15-1.26-.01-.03-.03.2-.03.21 0 .1-.03.28.02.37M547.62 311.9a.57.57 0 0 1 .21.28c.01.04.02.15.02.02l.01.18s0 .07.02.03c.04-.1.03-.26.02-.37 0-.3-.04-.56-.28-.75l-.02.09-.01.21v.22c.01.02.01.07.03.09M548.21 311.36l.3.57c.02.03.02-.03.02-.03l.02-.18v-.24c-.01-.03 0-.1-.02-.13l-.3-.57c-.02-.04-.03.02-.03.03l-.01.18v.23c0 .04 0 .1.02.14M549.54 310.88c.23.33.48.66.74.97l.03-.3c0-.07.02-.24-.03-.3-.26-.31-.5-.63-.72-.96-.02-.03-.04.2-.04.21 0 .09-.03.3.02.38M550.23 309.74c.18.31.38.6.6.88l.04-.3c0-.07.02-.24-.03-.3a6.44 6.44 0 0 1-.6-.87c-.01-.03-.03.2-.03.21 0 .1-.03.29.02.38M543.54 306.69c-.2-.16-.4-.3-.64-.4-.02 0-.03.3-.03.3 0 .04-.02.29.03.3.23.1.44.24.64.4l.03-.3c0-.06.02-.26-.03-.3M545.64 305.97a1.88 1.88 0 0 1 .06.18c0 .06 0 .12.02.18 0 0 0 .07.02.03.04-.1.02-.26.02-.37 0-.2-.02-.42-.1-.6-.02-.04-.03.02-.03.02l-.01.18c0 .11-.03.28.02.38M547.29 304.4c0 .4-.03.81-.24 1.16-.05.08-.02.28-.02.37 0 .02.02.24.04.21.32-.54.3-1.29.28-1.9a.88.88 0 0 0-.04-.22c-.04.11-.02.26-.02.38M547.66 306.64c.35-.24.6-.6.78-.98.05-.1.02-.27.02-.37 0-.02-.02-.24-.03-.21-.19.37-.42.72-.77.95-.05.03-.03.25-.03.3 0 .02.02.31.03.3M548.69 306.6c.12-.13.22-.28.34-.4.02-.02.02-.07.02-.1l.01-.2v-.22c0 .01-.02-.1-.03-.09l-.34.4c-.02.02-.02.06-.02.09a2.13 2.13 0 0 0 0 .42l.02.1M550.24 306.86c-.4 0-.78 0-1.16-.04-.03 0-.07.6 0 .6.38.04.77.05 1.16.05.04 0 .04-.6 0-.6M549.9 308.26c.5.3 1 .64 1.54.92-.04-.02.1-.55 0-.6-.53-.28-1.03-.62-1.55-.93.05.03-.11.54 0 .6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.93 309.31c.46.3.96.52 1.38.88l.03-.3c0-.07.02-.26-.03-.3-.42-.37-.92-.6-1.38-.89l-.02.3c0 .05-.03.28.02.31M546.98 307.1c.07-.21.07-.45.07-.68 0-.02 0-.3-.03-.3-.04 0-.03.28-.03.3 0 .08 0 .01 0 0l-.02.1c-.04.12-.03.26-.02.38l.01.18c0-.01.01.07.02.03M543.37 305.5c.4.49.91.85 1.4 1.23.38.29.65.78 1.05 1-.05-.02.11-.54 0-.6-.36-.2-.6-.64-.92-.9-.52-.44-1.1-.8-1.53-1.34.07.1-.11.47 0 .6M544.23 307.13c-.24-.25-.47-.52-.69-.8l-.02.1v.21c0 .07-.03.24.02.3.22.27.44.54.69.8l.03-.31c0-.07.02-.25-.03-.3M543.75 311.13c-.16.29-.3.6-.5.86-.06.07-.04.23-.04.3l.03.3c.21-.26.36-.58.52-.88.05-.09.03-.28.02-.37 0-.02-.02-.24-.03-.21M544.2 311.73c0 .34-.12.67-.16 1a2 2 0 0 0 0 .44c0 .1.02.1.04 0 .05-.43.17-.84.18-1.28 0-.11.01-.26-.02-.37-.01-.02-.04.19-.04.21M545.78 314.52c.29-.96.26-1.97.24-2.96-.01-.43-.07-.04-.06.16.01.75.02 1.49-.2 2.21-.05.17.05.49.02.59M546.7 312.2c.12.32.14.63.09.97-.02.14-.02.28-.01.42 0 .02.02.22.04.1.1-.68.12-1.42-.1-2.08l-.03.21c0 .11-.02.26.02.37M547.62 311.85c.33.41.43.95.4 1.48 0 .1.03.67.05.3.05-.79.07-1.74-.45-2.38l-.03.3c0 .07-.02.24.03.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.87 311.45c.2.87.37 1.74.46 2.64.02.23.05-.35.04-.43-.1-.95-.27-1.88-.49-2.8.03.1-.05.41-.01.59M548.73 311.23c.38.52.71 1.08.9 1.7l.03-.2c0-.12.02-.26-.02-.38a5.67 5.67 0 0 0-.9-1.7c.04.04-.1.45-.01.58M550.5 309.77c-.18-.3-.55-.35-.87-.32-.06 0-.02.6 0 .6.3-.02.69 0 .85.3.02.03.04-.19.04-.21 0-.1.03-.29-.02-.37",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.6 309.53c.55-.08 1.1-.09 1.66-.09.05 0 .05-.6 0-.6-.56 0-1.11 0-1.67.08-.07.01-.02.61 0 .6M550.62 304.93a4.55 4.55 0 0 0-.83 1.93c-.03.13-.02.28 0 .41 0 .03 0 .23.03.11a4.4 4.4 0 0 1 .8-1.84c.05-.06.03-.23.03-.3l-.03-.3M548.2 305.45c.09.52.3.99.44 1.48l.04-.21c0-.12 0-.26-.02-.37-.14-.48-.35-.93-.43-1.42-.02-.11-.04.1-.04.11l.01.41M547.75 306.34c-.2-.25-.37-.51-.47-.83 0-.03-.02.04-.02.04l-.01.18c0 .11-.02.25.02.37.1.32.27.59.48.84l.02-.09v-.21c0-.07.03-.24-.02-.3M546.93 306.73a6.22 6.22 0 0 1-1.89-.92c.06.05-.12.52 0 .6.57.44 1.22.7 1.9.93-.02 0 .09-.58 0-.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.67 306.56s-2.67.46-3.37.62c-.7.16-2.3.32-2.86.32-.55 0-1.4-.44-2-.56-.59-.12-2.52-.33-3.22.4-.7.73-1.15.97-1.37 1.21-.23.24-1.12 1.04-1.15 1.39-.04.35.22.87.66.87.45 0 1.38.95 1.38 1.15 0 .33 1.22.68 2.38.68 2.08-.02 3.1-1.06 6.22-.7 1.7.2 4.81-1.13 5.37-1.93.56-.81.9-1.66.33-2.59-.55-.93-2.22-.83-2.37-.86",
    fill: "#dba05f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.67 306.56s-2.67.46-3.37.62c-.7.16-2.3.32-2.86.32-.55 0-1.4-.44-2-.56-.59-.12-2.52-.33-3.22.4-.7.73-1.15.97-1.37 1.21-.23.24-1.12 1.04-1.15 1.39-.04.35.22.87.66.87.45 0 1.38.95 1.38 1.15 0 .33 1.22.68 2.38.68 2.08-.02 3.1-1.06 6.22-.7 1.7.2 4.81-1.13 5.37-1.93.56-.81.9-1.66.33-2.59-.55-.93-2.22-.83-2.37-.86z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.5 309.56s-.01.05-.02-.04l-.02-.07-.02-.05v-.05c-.01-.02.06.01.27-.2l.18-.28c0 .01.27-.34.68-.44.4-.1.78-.02.83-.02.02-.02-.92-.03-.98.08 0-.08.9-.1.95-.04.01-.03-.85-.03-.91.09 0-.06.78-.1.86-.02l-.18-.02.07.02h-.11l-.07-.01s.18.02.19.04c0 0 .07-.03-.23-.01 0 0-.19-.03-.5.06-.4.06-.38.6-1 .96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.43 309.33c.03 0 .3-.1.55-.57-.07-.13.94-.52 1.05-.4 0 0 .27 0 .43.03",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.43 308.45c-.1-.01-.61.42-.57.44-.1.27-.4.45-.43.44M537.48 308.51c0-.03.7-.1.83-.05M537.35 308.7c-.02-.07.72-.18.8-.13",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.12 309.17s.04.02 0-.02l-.04-.04-.02-.03-.02-.02s-.03 0-.21.17c0 0-.09.06-.18.15 0 0-.18.15-.38.26-.22.04-.52.17-.52.23-.02-.08.6-.25.6-.26.04.03-.56.14-.57.26-.02-.07.55-.21.58-.22.03.04-.51.13-.53.24 0 0 .08-.07.1-.07l-.03.03.06-.03.04-.02s-.1.04-.1.07c0 0-.06-.01.14-.06 0 .02.5-.1 1.08-.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.03 309.04s-.22.22-.45.38c0 .04-.47.32-.6.29 0-.02-.2.08-.28.18",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.33 309.6l.33-.24c.1-.1.37-.32.37-.32M537.34 309.66c.02.02-.44.09-.52.2M537.47 309.64c.03.06-.5.2-.52.22",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.86 307.01s-.04-.85-.85-1.17a5.04 5.04 0 0 0-2.08-.32c-.33.04-.39.19-.8.25-.42.07-.86.27-.86.27s0-.04-.23.37c-.22.4-.59.6-.4.97.18.36.06.42.29.5.23.06-.12-.13-.12-.13s-1.43.46-1.08 1.33c.35.88.7.55.8.53.1-.01.81-.38.81-.38l1.16-1.08s1.36-.53 1.5-.57c.16-.04.8.01.8.01l1.06-.58z",
    fill: "#c6262c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.86 307.01s-.04-.85-.85-1.17a5.04 5.04 0 0 0-2.08-.32c-.33.04-.39.19-.8.25-.42.07-.86.27-.86.27s0-.04-.23.37c-.22.4-.59.6-.4.97.18.36.06.42.29.5.23.06-.12-.13-.12-.13s-1.43.46-1.08 1.33c.35.88.7.55.8.53.1-.01.81-.38.81-.38l1.16-1.08s1.36-.53 1.5-.57c.16-.04.8.01.8.01l1.06-.58z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.83 309c0 .21-.22.48-.48.61-.27.12-.48.05-.48-.16 0-.2.21-.48.48-.6.26-.13.48-.06.48.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.16 312.87s-1.11-1.92 1.99-2.87c0 0 .94.51 1.15.87 0 0-.54.9-2.3 1.14 0 0-.8.23-.84.86",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.16 312.87s-1.11-1.92 1.99-2.87c0 0 .94.51 1.15.87 0 0-.54.9-2.3 1.14 0 0-.8.23-.84.86z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.49 312.56s1.25.26 2.1-.36c.68-.5.93-.27 1.1-.23 0 0 .05-.63-.39-1.1 0 0-.87.72-1.52.92-.65.2-1.1.13-1.3.77",
    fill: "#d9c0b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.49 312.56s1.25.26 2.1-.36c.68-.5.93-.27 1.1-.23 0 0 .05-.63-.39-1.1 0 0-.87.72-1.52.92-.65.2-1.1.13-1.3.77z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2080584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.96 311.93c.23 0 .47 0 .7-.06.02 0 0-.2 0-.2-.23.06-.47.05-.7.05v.2M535.52 308.7c-.19 0-.13.22-.25.32v.2c.12-.1.07-.32.25-.33.02 0 .02-.2 0-.2M536.17 309.13c.1-.18.29-.26.46-.34.03-.02-.01-.2 0-.2-.18.08-.37.16-.47.34v.2M537 310.24a.4.4 0 0 0 .38-.18v-.1-.1a.4.4 0 0 1-.38.18s-.02.2 0 .2M537.66 310c.26-.1.45-.26.6-.5v-.13s0-.08-.01-.07c-.14.24-.34.4-.59.5-.03.02.01.2 0 .2M536.63 308.92c-.15.24-.43.37-.6.6-.02.04.02.17.01.19.17-.23.44-.35.59-.6.02-.03 0-.1 0-.12v-.07M537.07 312.13c.53.03 1.04-.04 1.55-.18.03 0 0-.2 0-.2-.5.14-1.02.21-1.55.18 0 0-.02.2 0 .2M539.51 312.04c.7-.5 1.28-.93 1.5-1.8.02-.06-.01-.16 0-.2-.23.87-.81 1.3-1.5 1.8-.04.03.02.19 0 .2M539.92 310.84c.5-.29.85-.75 1.04-1.3.02-.05-.02-.16 0-.19-.2.54-.55 1-1.04 1.3-.03.01.02.18 0 .2M539.7 307.78c.37-.04.78.27 1.04.51-.02-.02.04-.16 0-.2-.26-.24-.67-.55-1.05-.5-.02 0 0 .2 0 .2M549.48 309.31c.42-.7.2-1.56-.25-2.18 0 .02-.04.15 0 .2.37.52.62 1.18.24 1.79-.03.04.02.17 0 .19M542 308.33c.44.31 1.63 1.11 1.3 1.77-.02.05.02.17.01.2.45-.9-.7-1.74-1.3-2.17.02.01-.04.17 0 .2M545.37 311.55a2.26 2.26 0 0 0 .1-.71c0-.04 0-.04 0 0-.02.18-.05.35-.11.52v.19",
    fill: "#7a2e26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.65 311.24c.26-.05.52-.18.78-.36M534.21 310.5c-.5.32-1.3.32-1.46 1.02v.05c.16-.7.96-.7 1.46-1.01v-.05",
    fill: "#5e3f17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.87 308.26c.22 0 .48.12.44.4v.13c0 .04.01.04.02 0 .02-.16.02-.35-.04-.5-.07-.17-.25-.22-.42-.23-.01 0-.02.2 0 .2M534.92 308.67c.1-.3.08-.65-.1-.9.01.01-.04.14 0 .19.1.16.16.32.1.51-.03.06 0 .17 0 .2M535.77 307.77c-.06-.35-.18-.74-.5-.93 0 .01-.04.18 0 .2.31.18.44.56.49.9 0 .05.01-.02.01-.03v-.14M536.51 307.59c.05-.33.02-.68-.25-.9.02.02-.04.17 0 .2.15.12.27.32.24.53v.13c0 .01 0 .08.01.04M535.26 306.49c.73-.37 2.22-.54 2.8.2-.03-.03.03-.16 0-.2-.58-.74-2.07-.58-2.8-.2-.03.01.02.19 0 .2",
    fill: "#842116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.53 309.53c.16-.24.1-.57-.05-.8 0 .01-.04.15-.01.2.04.05.08.11.1.18.04.09 0 .16-.05.23-.02.02 0 .1 0 .12v.07M540.97 311.67c.24-.15.4-.37.46-.65v-.14s0-.07-.01-.04a.95.95 0 0 1-.45.63c-.03.02.02.19 0 .2M542.1 311.58a.6.6 0 0 0 .14-.4l-.01-.12-.01.07c0 .09-.07.19-.13.25v.2M548.84 307.88c.18.32.21.68.13 1.05 0 .04 0 .19.01.17.1-.46.1-1-.14-1.42.02.03-.03.15 0 .2M548.17 308.56c.13.33.12.67.08 1.02 0 .03 0 .22.02.14.05-.46.08-.91-.1-1.35.02.03-.02.14 0 .2M547.54 309.15c0 .25 0 .5-.09.72-.02.06.02.17 0 .2.12-.3.1-.61.1-.92 0-.11-.01-.11-.01 0",
    fill: "#7a2e26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.65 328.86l.14.4s.03.07.1.14l-.22-.6-.02.06z",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.33 304.6c-2.68.16-5.32-1.62-5.32-1.62-3.32-.65-3.51-3.65-3.51-3.65-1.33-.5-2.47-3.91-2.47-3.91-2.06 1.23-4.63.01-4.63.01s0-.5-2.32 0-1.93-.43-1.93-.43.93-.94-3.18 0 .33-1.23.33-1.23c-1.2.36-5.1.65-5.1.65-1.44.06-2.9.77-4.49 1.23-.99.28-2.68.6-3.53.97-2.28.98-6.85 3.07-10.63 4.55-4.96 1.95-8.9 3.43-8.64 3.37.31-.08 5.4-3.3 11.75-6.18 5.91-2.68 12.7-5.16 16.11-6.13a15.42 15.42 0 0 1 10.13-.02c1 .36 6.49-.17 8.94.12 2.45.3 2.71 4.33 2.71 4.33.47.29.63 4.08.63 4.08s-1.36.04.23.25c1.6.22 4.51 2.53 4.51 2.53 1 0 1.11-.03 1.11-.03s.58-.73 1.38-1.04c.8-.3 1.52-.6 2.42-.67.9-.07 2.16-.08 3.05.02.9.1 1.96.11 3.22.35 1.26.24 1.4.3 1.79.44.4.13.75.05.75.05 1.64-.69 4.68-1.9 5.38-1.76 0 0 1.15-.29 1.77-.77l2.03-1.63s-.98-6.86 5.99-6.19c6.96.68 16.2 1.57 18.05 1.86 1.85.29 8.49 2.18 10.07 2.95 1.6.77 6.15 2.81 8.18 3.7.83.37 3.96 1.76 6.29 2.68a23.21 23.21 0 0 1 6.09 3.67c-2.19-.92-3.95-1.98-5.68-2.73-1.4-.61-2.87-.9-4-1.4-2.42-1.07-4.28-2.05-5.74-2.73-5.4-2.51-5.35-2.61-7.53-2.78-1.51-.12 1.08 1.83 1.08 1.83s-4.94-1.92-6.53-2.59a9.25 9.25 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.47-.39-.7 1.06s-2.38.48-2.56-.29c-.18-.77-1.41 3.46-2.03 4.7-.62 1.26-3.43.84-4.14 1.61-.7.77-2.2 1.28-2.56 1.47-.35.2-1.42.1-2.04.1-.92 0-.14.02-1.64.3 0 0-1.3 0-1.8-.21-.5-.2-1.6-.52-2.15-.68-.75-.21-4.94-.3-5.53-.27-.6.03-1.61.34-2.27.61-.67.27-1.83.98-1.83 1.15",
    fill: "#dcddde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.33 304.6c-2.68.16-5.32-1.62-5.32-1.62-3.32-.65-3.51-3.65-3.51-3.65-1.33-.5-2.47-3.91-2.47-3.91-2.06 1.23-4.63.01-4.63.01s0-.5-2.32 0-1.93-.43-1.93-.43.93-.94-3.18 0 .33-1.23.33-1.23c-1.2.36-5.1.65-5.1.65-1.44.06-2.9.77-4.49 1.23-.99.28-2.68.6-3.53.97-2.28.98-6.85 3.07-10.63 4.55-4.96 1.95-8.9 3.43-8.64 3.37.31-.08 5.4-3.3 11.75-6.18 5.91-2.68 12.7-5.16 16.11-6.13a15.42 15.42 0 0 1 10.13-.02c1 .36 6.49-.17 8.94.12 2.45.3 2.71 4.33 2.71 4.33.47.29.63 4.08.63 4.08s-1.36.04.23.25c1.6.22 4.51 2.53 4.51 2.53 1 0 1.11-.03 1.11-.03s.58-.73 1.38-1.04c.8-.3 1.52-.6 2.42-.67.9-.07 2.16-.08 3.05.02.9.1 1.96.11 3.22.35 1.26.24 1.4.3 1.79.44.4.13.75.05.75.05 1.64-.69 4.68-1.9 5.38-1.76 0 0 1.15-.29 1.77-.77l2.03-1.63s-.98-6.86 5.99-6.19c6.96.68 16.2 1.57 18.05 1.86 1.85.29 8.49 2.18 10.07 2.95 1.6.77 6.15 2.81 8.18 3.7.83.37 3.96 1.76 6.29 2.68 3.48 1.38 6.09 3.67 6.09 3.67-2.19-.92-3.95-1.98-5.68-2.73-1.4-.61-2.87-.9-4-1.4-2.42-1.07-4.28-2.05-5.74-2.73-5.4-2.51-5.35-2.61-7.53-2.78-1.51-.12 1.08 1.83 1.08 1.83s-4.94-1.92-6.53-2.59a9.26 9.26 0 0 0-4.4-.86c-1.5.1-2.65-.2-3.53-.48-.88-.3-5.91-.48-6.8-.58-.87-.1-1.58-.29-1.58-.29l.35.58-2.47-.39-.7 1.06s-2.38.48-2.56-.29c-.18-.77-1.41 3.46-2.03 4.7-.62 1.26-3.43.84-4.14 1.61-.7.77-2.2 1.28-2.56 1.47-.35.2-1.42.1-2.04.1-.92 0-.14.02-1.64.3 0 0-1.3 0-1.8-.21-.5-.2-1.6-.52-2.15-.68-.75-.21-4.94-.3-5.53-.27-.6.03-1.61.34-2.27.61-.67.27-1.83.98-1.83 1.15",
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1010988
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.6 303.8s-.27.22-.35.76c-.07.54-.03.33-.03.33",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.14 303.02c.36.26.72.53 1.04.85 0 0 .11.1.08.03a.85.85 0 0 0-.17-.22c-.35-.35-.75-.66-1.15-.95-.06-.05.01.07.02.08.05.07.11.15.18.2",
    fill: "#574f4c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/bo.b1a8c7bac51d081c70fb19d86950c468.svg";
export { ForwardRef as ReactComponent };